import _ from "lodash";

export default {
  /* old */
  _FLEET_VEHICLE_HISTORY_: "Detalles del historial de activos",

  _FLEET_SHOW_BTN_: "Mostrar",
  _FLEET_CLEAR_BTN_: "Limpiar",
  _FLEET_CLOSE_BTN_: "Cerrar",
  _FLEET_RESET_BTN_: "Restablecer",
  _REFUELS_: "Repostajes",

  _FLEET_REPORT_EVENT_: "Evento",
  _DELETE_EVENT_: "Eliminar evento",
  _FLEET_REPORT_EVENT_NO_: "N.º de evento",
  _FLEET_ALL_EVENT_: "Todos los eventos",
  _FLEET_START_EVENT_: "Iniciar evento",
  _FLEET_STOP_EVENT_: "Detener evento",
  _FLEET_START_TIME_MIN: "Hora de inicio (min)",
  _FLEET_STOP_TIME_MIN: "Hora de finalización (min)",
  _FLEET_START_TIME_: "Hora de inicio",
  _FLEET_STOP_TIME_: "Hora de finalización",
  _FLEET_ACC_EVENT_: "ACC Encendido/Apagado",
  _FLEET_STARTSTOP_EVENT_: "Inicio/Parada",
  _FLEET_OTHER_EVENT_: "Otro evento",
  _FLEET_SPEEDTIME_EVENT_: "Velocidad y tiempo",
  _ASSIGN_ALL_VEHICLES_OF_COMPANY_: "Asignar todos los vehículos de la empresa",
  _ASSIGN_VEHICLES_COMPANY_USERSELECTION_:
    "Asignar vehículos de la empresa (selección del usuario)",
  _ASSIGN_ALL_VEHICLES_SELECTEDGRP_:
    " Asignar todos los vehículos de los grupos seleccionados",
  _ASSIGN_VEHCLES_SELECTEDGRP_USERSELECTION_:
    "Asignar vehículos de los grupos seleccionados (selección del usuario)",

  _FLEET_RECORD_DISPLAYMSG_: "Mostrando registros {0} - {1} de {2}",
  _FLEET_RECORD_EMPTYMSG_: "No hay registros para mostrar",

  _FLEET_EVENT_REPORT_: "Vista de eventos en el mapa",
  _FLEET_RULETRIGGER_REPORT_: "Activación de reglas en el mapa",
  _FLEET_GEOFENCE_REPORT_: "Geocerca en el mapa",
  _FLEET_CHAT_REPORT_: "Posición del activo",
  _FLEET_CHAT_ALERT_: "Posición del activo no disponible",
  _REGISTER_IN_WASL_: "Registrar en WASL",

  _FLEET_LOGIN_SETLOAD_: "Iniciando sesión…",
  _OFFERS_: "Ofertas",

  _FLEET_LOGIN_LANGUAGE_: "Idioma",
  _FLEET_LOGIN_LANGUAGEDDL_ENGLISH_: "Inglés",
  _FLEET_LOGIN_LOGINBTNDDL_SPANISH_: "Español",
  _FLEET_LOGIN_LOGINBTN_: "Iniciar sesión",
  _FLEET_LOGIN_FRWDBTN_: "¿Olvidó su contraseña?",
  _FLEET_LOGIN_REMEMBER_: "Recordarme",
  _FLEET_LOGIN_EMAILLBL_: "Correo electrónico",
  _FLEET_LOGIN_PASSWORDLBL_: "Contraseña",
  _FLEET_LOGIN_INVALIDERROR_: "Nombre de usuario o contraseña incorrectos",

  _FLEET_ALERT_: "Alerta",
  _REMOVE_ALL_: "Eliminar todo",
  _FLEET_VEHICLEPOSITION_ON_: "Encendido",
  _FLEET_VEHICLEPOSITION_OFF_: "Apagado",
  _FLEET_VEHICLEPOSITION_VALID_: "Válido",
  _FLEET_VEHICLEPOSITION_INVALID_: "Inválido",
  _FLEET_VEHICLEPOSITION_OPEN_: "Abierto",
  _FLEET_VEHICLEPOSITION_CLOSE_: "Cerrado",
  _FLEET_VEHICLEPOSITION_NA_: "No disponible",

  _FLEET_WELCOME_: "Bienvenido ",
  _FLEET_LOGOUT_: "Cerrar sesión",
  _SIGN_OUT_: "Salir",
  _FLEET_REQUIRED_ERROR_: "Este campo es obligatorio",
  _FLEET_TELEPHONE_ERROR_:
    "Número de teléfono no válido. Debe ser ej.: (123-123-1234 o 123-4567 o 1234567896)",
  _FLEET_EMAIL_ERROR_:
    'Este campo debe ser un correo electrónico en el formato "usuario@ejemplo.com"',

  _FLEET_DASHBORD_RULETRIGGER_TITLE_: "Notificaciones",
  _FLEET_DASHBORD_RULETRIGGER_NAME_: "Nombre de la regla",
  _FLEET_DASHBORD_RULETRIGGER_VEHICLE_: "N.º de vehículo",
  _FLEET_DASHBORD_RULETRIGGER_TIME_: "Hora",
  _FLEET_DASHBORD_RULETRIGGER_DELETE_: "Eliminar",
  _VEHICLE_NO_: "N.º de vehículo",

  _FLEET_DASHBORD_NAVIRIGHT_NEWPOI_: "Nuevo PDI (PDI = Punto de Interés)",
  _FLEET_DASHBORD_NEWPOI_TITLE_: "Crear PDI",

  _FLEET_DASHBORD_NEWPOI_COMPANY_: "Empresa",
  _confirmation_: "¿Está seguro de que desea eliminar el registro?",
  _FLEET_DASHBORD_NEWPOI_NAME_: "Nombre",
  _FLEET_CUSTOMER_: "Cliente",
  _FLEET_DASHBORD_NEWPOI_CUSTOMER_: "Cuenta",
  _FLEET_DASHBORD_NEWPOI_ADDRESS_: "Dirección",
  _FLEET_DASHBORD_NEWPOI_TYPE_: "Tipo",
  _CONFIRM_: "Confirmar",

  _FLEET_DASHBORD_NEWPOI_TYPEDDL_CUSTOMER_: "Cuenta",
  _FLEET_DASHBORD_NEWPOI_TYPEDDL_FUEL_: "Estación de combustible",
  _FLEET_DASHBORD_NEWPOI_TYPEDDL_HOUSE_: "Casa",
  _FLEET_DASHBORD_NEWPOI_TYPEDDL_SHOP_: "Tienda",
  _FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_: "Almacén",
  _FLEET_DASHBORD_NEWPOI_TYPEDDL_CEDIS_:
    "CEDIS (central de distribución, se puede dejar como sigla)",
  _FLEET_DASHBORD_NEWPOI_TYPEDDL_AIRPORT_: "Aeropuerto",
  _FLEET_DASHBORD_NEWPOI_PHONE_: "N.º de teléfono",
  _FLEET_DASHBORD_NEWPOI_PHOTO_: "Subir foto",
  _FLEET_DASHBORD_NEWPOI_SAVEBTN_: "Guardar",
  _FLEET_DASHBORD_NEWPOI_REMOVEBTN_: "Eliminar PDI",
  _FLEET_DASHBORD_NEWPOI_REMOVETITLE_: "¿Eliminar PDI?",
  _FLEET_DASHBORD_NEWPOI_REMOVEMSG_: "¿Está seguro de que desea eliminarlo?",
  _FLEET_DASHBORD_NEWPOI_REMOVEYES_: "sí",
  _FLEET_DASHBORD_NEWPOI_SAVEMSG_: "Guardando el archivo…",
  _FLEET_DASHBORD_NEWPOI_COMPMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_NEWPOI_NAMEMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_NEWPOI_ERRORMSG_:
    "Las extensiones de imagen permitidas son png, jpg, jpeg, bmp y tamaño máximo de 1 MB",

  _FLEET_DASHBORD_NAVIRIGHT_SHOWPOI_: "Mostrar PDI",
  _FLEET_DASHBORD_SHOWPOI_TITLE_: "Mostrar todos los PDI",
  // _FLEET_DASHBORD_SHOWPOI_COMPANY_: 'Empresa',
  _FLEET_DASHBORD_SHOWPOI_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_SHOWPOI_COMPMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_SHOWPOI_SHOWBTN_: "MOSTRAR PDI",
  _FLEET_DASHBORD_SHOWPOI_CANCELBTN_: "Cancelar",
  _ASSIGNED_VEHICLES_: "Vehículos asignados",
  _ASSIGNED_: "Asignado",
  _NOT_ASSIGNED_: "No asignado",

  _FLEET_DASHBORD_NAVIRIGHT_CLEARPOI_: "Borrar PDI",

  _FLEET_DASHBORD_NAVIRIGHT_SEARCHPOI_: "Buscar PDI",
  _FLEET_DASHBORD_SEARCHPOI_TITLE_: "Buscar PDI",
  //_FLEET_DASHBORD_SEARCHPOI_COMPANY_: 'Empresa',
  _FLEET_DASHBORD_SEARCHPOI_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_SEARCHPOI_NAME_: "Nombre del PDI",
  _FLEET_DASHBORD_SEARCHPOI_COMPMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_SEARCHPOI_NAMEMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_SEARCHPOI_SEARCHBTN_: "BUSCAR",
  _FLEET_DASHBORD_SEARCHPOI_CANCELBTN_: "CANCELAR",

  _FLEET_DASHBORD_NAVIRIGHT_IMPORTPOI_: "Importar PDI desde kml",
  _FLEET_DASHBORD_IMPORTPOI_TITLE_: "Importar PDI",
  //_FLEET_DASHBORD_IMPORTPOI_COMPANY_: 'Empresa,
  _FLEET_DASHBORD_IMPORTPOI_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_IMPORTPOI_FILE_: "Seleccionar archivo",
  _FLEET_DASHBORD_IMPORTPOI_UPLOADBTN_: "SUBIR",
  _FLEET_DASHBORD_IMPORTPOI_CANCELBTN_: "CANCELAR",
  _FLEET_DASHBORD_IMPORTPOI_SAVEMSG_: "Guardando el archivo…",
  _FLEET_DASHBORD_IMPORTPOI_ERRORFILE_:
    "Las extensiones de archivo permitidas son kml, xml y tamaño máximo de 1 MB",

  _FLEET_DASHBORD_NAVIRIGHT_DROWGEO_: "Dibujar geocerca",
  _FLEET_DASHBORD_DROWGEO_TITLE_: "Dibujar geocerca",

  _FLEET_DASHBORD_DROWGEO_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_DROWGEO_ADDRESS_: "Dirección",
  _FLEET_DASHBORD_DROWGEO_ADDRESSMSG_: "Dirección no encontrada",
  _FLEET_DASHBORD_DROWGEO_NAME_: "Nombre",
  _FLEET_DASHBORD_DROWGEO_DISCARDBTN_: "Descartar y crear nuevo",
  _FLEET_DASHBORD_DROWGEO_SAVEBTN_: "GUARDAR",
  _FLEET_DASHBORD_DROWGEO_CANCEL_: "CANCELAR",
  _FLEET_DASHBORD_DROWGEO_LOADMSG_: "Guardando geocerca…",
  _FLEET_DASHBORD_DROWGEO_ALERTSTATUS_: "Estado",
  _FLEET_DASHBORD_DROWGEO_ALERTMSG_: "Geocerca guardada correctamente",
  _FLEET_DASHBORD_DROWGEO_ERRORMSG_:
    "Complete todos los campos marcados en rojo",

  _FLEET_DASHBORD_NAVIRIGHT_SHOWGEO_: "Mostrar geocerca",
  _FLEET_DASHBORD_SHOWGEO_TITLE_: "Lista de geocercas",

  _FLEET_DASHBORD_SHOWGEO_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_SHOWGEO_NAME_: "Nombre",
  _FLEET_DASHBORD_SHOWGEO_ADDRESS_: "Dirección",
  _FLEET_DASHBORD_SHOWGEO_DELETE_: "Eliminar geocerca",
  _FLEET_DASHBORD_SHOWGEO_REMOVETITLE_: "¿Eliminar geocerca?",
  _FLEET_DASHBORD_SHOWGEO_REMOVEMSG_: "¿Está seguro de que desea eliminarla?",
  _FLEET_DASHBORD_SHOWGEO_REMOVEYESBTN_: "sí",
  _FLEET_DASHBORD_SHOWGEO_REMOVELODING_: "Eliminando datos de la geocerca…",
  _FLEET_DASHBORD_SHOWGEO_REMOVEALERT_: " Alerta",

  _FLEET_DASHBORD_NAVIRIGHT_IMPORTGEO_: "Importar/Exportar <br/> desde XML",
  _FLEET_DASHBORD_IMPORTGEO_TITLE_: "Importar/Exportar desde XML",

  _FLEET_DASHBORD_IMPORTGEO_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_IMPORTGEO_FILE_: "Seleccionar archivo",
  _FLEET_DASHBORD_IMPORTGEO_UPLOADBTN_: "SUBIR",
  _FLEET_DASHBORD_IMPORTGEO_CANCELBTN_: "CANCELAR",
  _FLEET_DASHBORD_IMPORTGEO_SAVEMSG_: "Guardando el archivo...",
  _FLEET_DASHBORD_IMPORTGEO_ERRORMSG_:
    "Las extensiones de archivo permitidas son kml, xml y tamaño máximo de 1 MB",

  _FLEET_DASHBORD_NAVIRIGHT_SEARCHVEHICLE_: "Buscar activo",
  _FLEET_DASHBORD_SEARCHVEHICLE_TITLE_: "Buscar vehículo más cercano",

  _FLEET_DASHBORD_SEARCHVEHICLE_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_SEARCHVEHICLE_VEHICLE_: "Activo",
  _FLEET_DASHBORD_SEARCHVEHICLE_SEARCHBTN_: "BUSCAR",
  _FLEET_DASHBORD_SEARCHVEHICLE_CANCELBTN_: "CANCELAR",
  _FLEET_DASHBORD_SEARCHVEHICLE_COMPMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_SEARCHVEHICLE_VEHICLEMSG_: "Este campo es obligatorio.",

  _FLEET_DASHBORD_NAVIRIGHT_SEARCHADDRESS_: "Buscar dirección",
  _FLEET_DASHBORD_SEARCHADDRESS_TITLE_: "Buscar dirección",
  _FLEET_DASHBORD_SEARCHADDRESS_ADDRESS_: "Ingresar dirección",
  _FLEET_DASHBORD_SEARCHADDRESS_ADDRESSMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_SEARCHADDRESS_SEARCHBTN_: "BUSCAR",
  _FLEET_DASHBORD_SEARCHADDRESS_CANCELBTN_: "CANCELAR",

  _FLEET_DASHBORD_NAVIRIGHT_DISTMEASURE_: "Medición de distancia",
  _FLEET_DASHBORD_DISTMEASURE_TITLE_: "Medición de distancia",
  _FLEET_DASHBORD_DISTMEASURE_DISTCALCEBTN_: "Calcular distancia",
  _DISTANCE_MEASUREMENT_: "Medición de distancia",
  _FLEET_DASHBORD_DISTMEASURE_CANCELBTN_: "CANCELAR",

  _FLEET_DASHBORD_NAVIRIGHT_CREATEROUTE_: "Crear/Asignar viajep",
  _FLEET_DASHBORD_CREATEROUTE_ROUTELIST_: "Lista de rutas",
  _FLEET_DASHBORD_ROUTELIST_NAME_: "Nombre",
  _FLEET_DASHBORD_ROUTELIST_DISCRIPTION_: "Descripciónn",
  _FLEET_DASHBORD_ROUTELIST_TIME_: "Hora",
  _FLEET_DASHBORD_ROUTELIST_EMPTYTEXT_: "No hay rutas disponibles",

  _FLEET_DASHBORD_CREATEROUTE_TAB_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_CREATEROUTE_TAB_ADDROUTEBTN_: "Agregar ruta",
  _FLEET_DASHBORD_CREATEROUTE_TAB_LISTBTN_: "Lista",
  _FLEET_DASHBORD_ROUTEADD_SAVEROUTBTN_: "Guardar ruta",
  _FLEET_CREATEROUTE_ROUTEADD_SAVEBTN_: "Guardar",
  _FLEET_CREATEROUTE_ROUTEADD_CREATEPLANBTN_: "Crear plan",
  _FLEET_CREATEROUTE_ROUTEADD_ROUTENAME_: "Nombre de la ruta",
  _FLEET_CREATEROUTE_ROUTEADD_ROUTEDESCRIPTION_: "Descripción de la ruta",
  _FLEET_CREATEROUTE_ROUTEADD_ZONEORGANIZER_: "Organizador de zona",
  _FLEET_CREATEROUTE_ROUTEADD_DESCRIPTION_: "Descripción",
  _FLEET_CREATEROUTE_ROUTEADD_COMPANY_: "Seleccionar cuenta",
  _FLEET_CREATEROUTE_ROUTEADD_COMMENT_: "Comentario",
  _FLEET_CREATEROUTE_ROUTEADD_VEHICLE_: "Activo",
  _FLEET_CREATEROUTE_ROUTEADD_SRTDATE_: "Fecha de inicio",
  _FLEET_CREATEROUTE_ROUTEADD_ROUTEORGANIZER_: "Organizador de ruta",
  _FLEET_CREATEROUTE_ROUTEADD_VEHCHKBXLBL_:
    "ctivo estacionado aquí al inicio de la ruta",
  _FLEET_CREATEROUTE_ROUTEADD_TOOLTIP_STARTTIME_:
    "Defina la hora en que el vehículo comenzará la ruta !",
  _FLEET_CREATEROUTE_ROUTEADD_TOOLTIP_DISTANCE_:
    "Defina la distancia hasta la ubicación desde la ubicación anterior!",
  _FLEET_CREATEROUTE_ROUTEADD_TOOLTIP_ESTIMATETIME_:
    "Defina el tiempo estimado para llegar a la ubicación desde la ubicación anterior. !",
  _FLEET_CREATEROUTE_ROUTEADD_TOOLTIP_ESTIMATETIMESPEND_:
    "Defina la hora en que el vehículo comenzará la ruta.!",
  _FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_: "Distancia total",
  _FLEET_CREATEROUTE_ROUTEADD_TOTALTIME_: "Tiempo total",
  _FLEET_CREATEROUTE_ROUTEADD_ALERTSTATUS_: "Estado",
  _FLEET_CREATEROUTE_ROUTEADD_ALERTMSG_: "Ruta guardada correctamente…",
  _FLEET_CREATEROUTE_ROUTEADD_ERRORMSG_: "Datos no guardados...",

  _FLEET_DASHBORD_ROUTEADD_SUGGROUTBTN_: "Sugerir ruta",
  _FLEET_DASHBORD_ROUTEADD_CANCELBTN_: "Cancelar",
  _FLEET_DASHBORD_ROUTEADD_SUGGROUTE_SETROUTEBTN_: "Establecer ruta",
  _FLEET_DASHBORD_ROUTEADD_ADDRESS_ERRORMSG_:
    "Por favor, inténtelo de nuevo más tarde",

  _FLEET_DASHBORD_NAVIRIGHT_CREATECHAT_: "Crear chat",
  _FLEET_DASHBORD_CREATECHAT_TITLE_: "Chat",

  _FLEET_DASHBORD_CREATECHAT_COMPANY_: "Cuenta",
  _EDIT_TRIP_DETAILS_: "Editar detalles del viaje",

  _FLEET_DASHBORD_NAVIRIGHT_SETTING_TITLE_: "Configuración",
  _FLEET_DASHBORD_SETTING_STATUS_: "Estado",
  _FLEET_DASHBORD_SETTING_VEHICLE_: "Nombre/alias del vehículo",
  _FLEET_DASHBORD_SETTING_PLATE_: "Placas",
  _FLEET_DASHBORD_SETTING_IMEI_: "IMEI",
  _FLEET_DASHBORD_SETTING_DATE_: "Fecha y hora",
  _FLEET_DASHBORD_SETTING_ADDRESS_: "Dirección",
  _FLEET_DASHBORD_SETTING_SPEED_: "Velocidad",
  _FLEET_DASHBORD_SETTING_ODOMETER_: "Odómetro",
  _FLEET_DASHBORD_SETTING_HEADING_: "Dirección",
  _FLEET_DASHBORD_SETTING_INGNITION_: "Estado de encendido",
  _FLEET_DASHBORD_SETTING_EVENT_: "Evento",
  _FLEET_DASHBORD_SETTING_TEMPERATURE_: "Temperatura",
  _FLEET_DASHBORD_SETTING_FUELLEVEL_: "Nivel de combustible (%)",
  _FLEET_DASHBORD_SETTING_FUELLEVEL1_: "Nivel de combustible 1 (%)",
  _FLEET_DASHBORD_SETTING_FUELLEVEL2_: "Nivel de combustible 2 (%)",
  _FLEET_DASHBORD_SETTING_FUELLEVEL3_: "Nivel de combustible 3 (%)",
  _FLEET_DASHBORD_SETTING_FUELVOLUME_: "Volumen de combustible (Lt)",
  _FLEET_DASHBORD_SETTING_FUELVOLUME1_: "Entrada analógica 1",
  _FLEET_DASHBORD_SETTING_FUELVOLUME2_: "Entrada analógica 2",
  _FLEET_DASHBORD_SETTING_FUELVOLUM3_: "Entrada analógica 3",
  _FLEET_DASHBORD_SETTING_FUELVOLUME4_: "Entrada analógica 4",
  _FLEET_DASHBORD_SETTING_FUELVOLUME3_: "Volumen de combustible (Lt)",
  _FLEET_DASHBORD_SETTING_GPS_: "Estado GPS",
  _FLEET_DASHBORD_SETTING_GSM_: "Señal GSM",
  _FLEET_DASHBORD_SETTING_BATTERY_: "Batería",
  _FLEET_DASHBORD_SETTING_DOOR_: "Puerta",
  _FLEET_DASHBORD_SETTING_ACC_: "ACC",
  _FLEET_DASHBORD_SETTING_SEATBELT_: "Cinturón de seguridad",
  _FLEET_DASHBORD_SETTING_AC_: "Aire acondicionado",
  _FLEET_DASHBORD_SETTING_PANIC_: "Pánico",
  _FLEET_DASHBORD_SETTING_ANALOG_: "Entrada analógica",
  _FLEET_DASHBORD_SETTING_LATITUDE_: "Latitud",
  _FLEET_DASHBORD_SETTING_LONGITUDE_: "Longitud",
  _FLEET_DASHBORD_SETTING_MESSAGE_: "Mensaje",
  _FLEET_DASHBORD_SETTING_EXTERNAL_: "Datos de alarma externa",
  _FLEET_DASHBORD_SETTING_SELECTALLBTN_: "Seleccionar todo",
  _FLEET_DASHBORD_SETTING_DELETEALLBTN_: "Deseleccionar todo",
  _FLEET_DASHBORD_SETTING_SAVEBTN_: "Guardar",

  _FLEET_DASHBORD_VEHICLE_INFORMATION_TITLE_: "Detalles del activo",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_PLATENO_: "Número de placa",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_BRAND_: "Marca",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_MODEL_: "Modelo",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_TYPE_: "Tipo",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_YEAR_: "Año",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_IMEI_: "IMEI",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_ADDRESS_: "Dirección formateada",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_ODOMETER_: "Odómetro",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_: "Nombre del conductor",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_: "Número de móvil",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_SPEED_: "Velocidad (km/h)",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_UPDATE_: "Última actualización",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_STOPTIME_: "Tiempo de detención",
  _FLEET_DASHBORD_INFORMATION_DAY_: "Día(s)",
  _FLEET_DASHBORD_INFORMATION_HOUR_: "Hora(s)",
  _FLEET_DASHBORD_INFORMATION_MIN_: "Min(s)",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_EVENT_: "Tipo de evento",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_LATITUDE_: "Latitud",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_LONGI_: "Longitud",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_SERVICE_: "Último servicio realizado",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_OIL_: "Último cambio de aceite",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_TIRE_: "Último cambio de neumáticos",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_TYRE_: "Último cambio de neumáticos (KM)",
  _FLEET_DASHBORD_VEHICLE_INFORMATION_OIL_KM_: "Último cambio de aceite (KM)",

  _FLEET_DASHBORD_VEHICLE_INFORMATION_TYRE_DATE_:
    "Fecha del último cambio de neumáticos",

  _INVALID_EMAILID_: "Correo electrónico no válido",
  _FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_1:
    "Nombre del activo (Nombre del conductor)",
  _FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_:
    "Nombre del activo (Nombre del conductor)",

  _FLEET_DASHBORD_VEHICLE_HISTORY_TITLE_: "Seguimiento de activo sin conexió",

  _FLEET_DASHBORD_VEHICLE_HISTORY_COMPANY_: "Cuenta",
  _FLEET_DASHBORD_VEHICLE_HISTORY_VEHICLE_: "Número de activo",
  _FLEET_DASHBORD_VEHICLE_HISTORY_FROM_: "Desde",
  _FLEET_DASHBORD_VEHICLE_HISTORY_TO_: "Hasta",
  _FLEET_DASHBORD_VEHICLE_HISTORY_SHOWBTN_: "Mostrar",
  _FLEET_DASHBORD_VEHICLE_HISTORY_ERROR_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_VEHICLE_HISTORY_SETLOAD_: "Obteniendo datos...",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_: "Ubicación",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_SPEED_: "Velocidad",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_: "Conductor",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_MOBILE_: "Número de móvil",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_LASTREPORT_: "Última fecha reportada",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_NODRIVER_: "Sin conductor",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_NOMOBILE_: "Sin número de móvil",
  _FLEET_DASHBORD_VEHICLE_HISTORY_ALERTMSG_: "Esta función no está disponible.",

  _FLEET_DASHBORD_VEHICLE_STREET_ALERT_: "Alerta",
  _FLEET_DASHBORD_VEHICLE_STREET_ALERTMSG_:
    "Street View no disponible para esta ubicación.",
  _FLEET_DASHBORD_VEHICLE_STREET_ERROR_: "Esta función no está disponible.",

  _FLEET_DASHBORD_VEHICLE_COMMAND_TITLE_: "Por favor, ingrese el comando",
  _FLEET_DASHBORD_VEHICLE_COMMAND_SELECT_: "Seleccionar comando",
  _FLEET_DASHBORD_COMMAND_SELECTDDL_ON_: "Inmovilizador activado",
  _FLEET_DASHBORD_COMMAND_SELECTDDL_OFF_: "Inmovilizador desactivado",
  _FLEET_DASHBORD_COMMAND_SELECTDDL_POSITION_: "Obtener posición",
  _FLEET_DASHBORD_COMMAND_SELECTDDL_DOORLOCK_: "Cerrar puerta",
  _FLEET_DASHBORD_COMMAND_SELECTDDL_DOORUNLOCK_: "Abrir puerta",
  _FLEET_DASHBORD_VEHICLE_COMMAND_ERRORMSG_: "Este campo es obligatorio.",
  _FLEET_DASHBORD_VEHICLE_COMMAND_SENDBTN_: "Enviar",
  _FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_: "Aceptar",
  _FLEET_DASHBORD_VEHICLE_COMMAND_CANCELBTN_: "Cancelar",
  _FLEET_DASHBORD_VEHICLE_COMMAND_SUCCESSMGS_:
    "Comando enviado al dispositivo.",
  _FLEET_DASHBORD_VEHICLE_COMMAND_UNSUCCESSMGS_:
    "No se pudo enviar el comando al dispositivo.",

  _FLEET_DASHBORD_LEFT_VEHLIST_NEXTREFRESH_: "Próxima actualización",
  _FLEET_DASHBORD_LEFT_VEHLIST_SETREFRESH_: "Configurar actualización",
  _FLEET_DASHBORD_LEFT_VEHLIST_DEFAULT_: "Predeterminado..",
  _FLEET_DASHBORD_LEFT_VEHLIST_TIMER_:
    "Para configurar el temporizador, seleccione los vehículos.",

  _FLEET_DASHBORD_MAP_LOCK_: "Bloquear",
  _FLEET_DASHBORD_MAP_UNLOCK_: "Desbloquear",
  _FLEET_DASHBORD_MAP_LOCK_TOOLTIP_: "Haga clic para bloquear el mapa",
  _CLICKTOUPLOAD_EXCELFILE_: "Haga clic para subir archivo Excel",
  _FLEET_DASHBORD_MAP_PHOTO_: "Fotos",
  _FLEET_DASHBORD_MAP_PHOTO_TOOLTIP_: "Haga clic para ver las fotos",
  _FLEET_DASHBORD_MAP_WEATHER_: "Clima",
  _FLEET_DASHBORD_MAP_WEATHER_TOOLTIP_: "Haga clic para ver el clima",
  _FLEET_DASHBORD_MAP_TRAFFIC_: "Tráfico",
  _FLEET_DASHBORD_MAP_TRAFFIC_TOOLTIP_: "Haga clic para ver el tráfico",
  _FLEET_DASHBORD_MAP_MAP_: "Mapa",
  _FLEET_DASHBORD_MAP_MAP_TOOLTIP_: "Mapa",
  _FLEET_DASHBORD_MAP_SATELLITE_: "Satélite",
  _FLEET_DASHBORD_MAP_SATELLITE_TOOLTIP_: "Satélite",

  _FLEET_MANAGEUSER_TAB_: "Administrar usuario",
  _FLEET_MANAGEUSER_COMPANY_TAB_: "Cuenta",

  _FLEET_COMPANY_COMPANYLIST_: "Account List",
  _FLEET_COMPANY_COMPANYLIST_ADDBTN_: "ADD",

  _FLEET_COMPANY_COMPANYLIST_COMPANYNAME_: "Teléfono de contacto",
  _FLEET_COMPANY_COMPANYLIST_PHONE_: "Teléfono de contacto",
  _FLEET_COMPANY_COMPANYLIST_EMAIL_: "Correo electrónico de contacto",
  _FLEET_COMPANY_COMPANYLIST_STATUS_: "Estado",
  _FLEET_COMPANY_COMPANYLIST_EDIT_: "Editar",
  _FLEET_COMPANY_COMPANYLIST_DELETE_: "Eliminarv",
  _FLEET_COMPANY_COMPANYLIST_REMOVETITLE_: "¿Eliminar empresa?",
  _FLEET_COMPANY_COMPANYLIST_REMOVEMSG_:
    "¿Está seguro de que desea eliminarla?",
  _FLEET_COMPANY_COMPANYLIST_YESBTN_: "sí",
  _FLEET_COMPANY_COMPANYLIST_DELETELODING_: "Eliminando datos de la empresa..",

  // _FLEET_COMPANY_COMPANYDETAIL_TITLE_: 'Detalles de la empresa',
  _FLEET_COMPANY_COMPANYDETAIL_TITLE_: "Detalles de la cuenta",
  _FLEET_COMPANY_COMPANYDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_COMPANY_COMPANYDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_COMPANY_COMPANYDETAIL_CANCELBTN_: "CANCEL",

  _FLEET_COMPANY_COMPANYDETAIL_COMPANYNAME_: "Nombre de la cuenta",
  //  _FLEET_COMPANY_COMPANYDETAIL_COMPANYNAME_: 'Nombre de la empresa',
  _FLEET_COMPANY_COMPANYDETAIL_ADDRESS_: "Dirección de la cuenta",
  // _FLEET_COMPANY_COMPANYDETAIL_ADDRESS_: 'Dirección de la empresa',
  _FLEET_COMPANY_COMPANYDETAIL_EMAIL_: "Correo electrónico de contacto",
  _FLEET_COMPANY_COMPANYDETAIL_PHONE_: "Teléfono de contacto",
  _FLEET_COMPANY_COMPANYDETAIL_CITY_: "Ciudad",
  _FLEET_COMPANY_COMPANYDETAIL_STATE_: "Estado",
  _FLEET_COMPANY_COMPANYDETAIL_COUNTRY_: "País",
  _FLEET_COMPANY_COMPANYDETAIL_TIME_: "Zona horaria",
  _FLEET_COMPANY_COMPANYDETAIL_RFC_: "RFC",
  _FLEET_COMPANY_COMPANYDETAIL_STATUS_: "ESTADO",
  _FLEET_COMPANY_COMPANYDETAIL_SERVER_: "Servidor SMTP",
  _FLEET_COMPANY_COMPANYDETAIL_PORT_: "Puerto SMTP",
  _FLEET_COMPANY_COMPANYDETAIL_SELECT_: "Seleccionar",
  _FLEET_COMPANY_COMPANYDETAIL_SMPTEMAIL_: "Correo SMTP",
  _FLEET_COMPANY_COMPANYDETAIL_SMPTPASSWD_: "Contraseña SMTP",
  _FLEET_COMPANY_COMPANYDETAIL_EXPIREDATE_: "Fecha de expiración de la cuenta",

  _FLEET_COMPANY_COMPANYDETAIL_EXPIREMONTHS_:
    "Meses hasta la expiración de la cuenta",

  _FLEET_COMPANY_COMPANYDETAIL_UPLOAD_: "Subir logo de la empresa",
  _FLEET_COMPANY_COMPANYDETAIL_TAXEXPIREDATE_:
    "Fecha de vencimiento de impuestos",
  //_FLEET_COMPANY_COMPANYDETAIL_LOGO_: 'Logo de la empresa',
  _FLEET_COMPANY_COMPANYDETAIL_LOGO_: "Logo de la cuenta (150*150)",
  _FLEET_COMPANY_COMPANYDETAIL_NOLOGO_: "Sin logo",
  _FLEET_COMPANY_COMPANYDETAIL_NOIMAGE_: "Sin imagen",
  _FLEET_COMPANY_COMPANYDETAIL_ERRORMSG_:
    "Por favor, complete correctamente los campos marcados en rojo.",
  _FLEET_COMPANY_COMPANYDETAIL_ERRORCOMPANY_:
    "Este nombre de empresa ya existe",
  // _FLEET_COMPANY_COMPANYDETAIL_ERRORPHOTO_: 'Por favor, suba una imagen válida. Las dimensiones deben ser 189*65 ✅',
  _FLEET_COMPANY_COMPANYDETAIL_ERRORPHOTO_:
    "Por favor, suba una imagen válida. Las dimensiones deben ser 150*150",
  _FLEET_COMPANY_COMPANYDETAIL_ERRORUSER_: "Este nombre de usuario ya existe",

  _FLEET_COMPANY_USERDETAIL_TITLE_: "Detalles del usuario",
  _FLEET_COMPANY_USERDETAIL_NAME_: "Nombre",
  _FLEET_COMPANY_USERDETAIL_USERNAME_: "Nombre de usuario",
  _FLEET_COMPANY_USERDETAIL_PASSWORD_: "Contraseña",
  _FLEET_COMPANY_USERDETAIL_REPASSWORD_: "Reingrese la contraseña",
  _FLEET_COMPANY_USERDETAIL_PASSWDNOTMATCH_: "Las contraseñas no coinciden.",
  _FLEET_COMPANY_USERNAME_PROVIDE_: "Por favor, ingrese su nombre de usuario",
  _FLEET_COMPANY_PASSWORD_PROVIDE_: "Por favor, ingrese su contraseña",

  _FLEET_MANAGEUSER_USER_TAB_: "Usuario",
  _FLEET_USER_USERLIST_TITLE_: "Lista de usuarios",

  _FLEET_USER_USERLIST_COMPANYDDL_: "Cuenta",
  _FLEET_USER_USERLIST_ADDBTN_: "AGREGAR",
  _FLEET_USER_USERLIST_NAME_: "Nombre",
  _FLEET_USER_USERLIST_ADMINUSER_: "Usuario administrador",
  _FLEET_USER_USERLIST_ADDRESS_: "Dirección",
  _FLEET_USER_USERLIST_MOBILENO_: "Número de móvil.",
  _FLEET_USER_USERLIST_EMAIL_: "Correo electrónico",
  _FLEET_USER_USERLIST_USERNAME_: "Nombre de usuario",
  _FLEET_USER_USERLIST_STATUS_: "Estado",
  _FLEET_USER_USERLIST_STATUS_ACTIVE_: "Activo",
  _FLEET_USER_USERLIST_STATUS_INACTIVE_: "Inactivo",
  _FLEET_USER_USERLIST_EDIT_: "Editar usuario",
  _FLEET_USER_USERLIST_VEHICLE_: "Asignar vehículos",
  _FLEET_USER_USERLIST_DELETE_: "Eliminar usuario",
  _FLEET_USER_USERLIST_REMOVETITLE_: "¿Eliminar usuario?",
  _FLEET_USER_USERLIST_REMOVEMSG_: "¿Está seguro de que desea eliminarlo?",
  _FLEET_USER_USERLIST_YESBTN_: "sí",
  _FLEET_USER_USERLIST_DELETELODING_: "Eliminando datos del usuario..",

  _FLEET_USER_USERLIST_ASSIGNVEHICLE_TITLE_: "Asignar vehículos",
  _FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_: "Atrás",
  _FLEET_USER_USERLIST_ASSIGNVEHICLE_SAVEBTN_: "Guardar",
  _FLEET_USER_USERLIST_ASSIGNVEHICLE_SELECTVEHICLE_: "Seleccionar vehículos",

  _FLEET_USER_USERDETAIL_TITLE_: "Detalles del usuario",
  _FLEET_USER_USERDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_USER_USERDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_USER_USERDETAIL_CANCELBTN_: "CANCELAR",

  _FLEET_USER_USERDETAIL_COMPANY_: "Cuenta",
  _FLEET_USER_USERDETAIL_NAME_: "Nombre",
  _FLEET_USER_USERDETAIL_MOBILE_: "Número de móvil",
  _FLEET_USER_USERDETAIL_EMAIL_: "Correo electrónico",
  _FLEET_USER_USERDETAIL_ADDRESS_: "Dirección",
  _FLEET_USER_USERDETAIL_USERNAME_: "Nombre de usuario",
  _FLEET_USER_USERDETAIL_PASSWORD_: "Contraseña",
  _FLEET_USER_USERDETAIL_REPASSWORD_: "Reingrese la contraseña",
  _FLEET_USER_USERDETAIL_PASSWDNOTMATCH_: "Las contraseñas no coinciden.",
  _FLEET_USER_USERDETAIL_STATUS_: "Estado",
  _FLEET_USER_USERDETAIL_STATUSDDL_SELECT_: "Seleccionar estado",
  _FLEET_USER_USERDETAIL_STATUSDDL_ACTIVE_: "Activo",
  _FLEET_USER_USERDETAIL_STATUSDDL_INACTIVE_: "Inactivo",
  _FLEET_USER_USERDETAIL_ROLE_: "Seleccionar rol",
  _FLEET_USER_USERDETAIL_ROLE_EMPTY_: "Rol..",
  _FLEET_USER_USERDETAIL_PHOTO_: "Subir foto",
  _FLEET_USER_USERDETAIL_ICON_: "Icono",
  _FLEET_USER_USERDETAIL_NOICON_: "Sin icono",
  _FLEET_USER_USERDETAIL_NOIMAGE_: "Sin imagen",
  _FLEET_USER_USERDETAIL_SAVEMSG_: "Datos del usuario guardados correctamente",
  _FLEET_USER_USERDETAIL_ERRORMSG_:
    "Por favor, complete correctamente los campos marcados en rojo.",
  _FLEET_USER_USERDETAIL_ERRORPHOTO_:
    "Por favor, suba una imagen válida. Las dimensiones deben ser 75*75",
  _FLEET_USER_USERDETAIL_ERRORUSER_: "Este nombre de usuario ya existes",

  _FLEET_MANAGEUSER_CHANGEPASSWORD_TAB_: "Cambiar contraseña",
  _FLEET_CHANGEPASSWORD_TITLE_: "Cambie su contraseña",
  _FLEET_CHANGEPASSWORD_SAVEBTN_: "Guardar",
  _FLEET_CHANGEPASSWORD_CANCELBTN_: "CANCELAR",
  _FLEET_CHANGEPASSWORD_OLDPASSWD_: "Contraseña antigua",
  _FLEET_CHANGEPASSWORD_NEWPASSWD_: "Nueva contraseña",
  _FLEET_CHANGEPASSWORD_CONFIRMPASSWD_: "Confirmar contraseña",
  _FLEET_CHANGEPASSWORD_PASSWDNOTMATCH_: "Las contraseñas no coinciden.",
  _FLEET_CHANGEPASSWORD_SETLOAD_: "Guardando nueva contraseña...",
  _FLEET_CHANGEPASSWORD_SAVEMSG_: "Guardado correctamente",
  _FLEET_CHANGEPASSWORD_ERRORMSG_:
    "or favor, complete todos los campos marcados en rojo.",
  _FLEET_CHANGEPASSWORD_ERRORPASSWD_: "Contraseña antigua incorrecta",

  _FLEET_MANAGEUSER_GROUP_TAB_: "Grupo",
  _FLEET_GROUP_GROUPLIST_TITLE_: "Lista de dispositivos",

  _FLEET_GROUP_GROUPLIST_COMPANYDDL_: "Cuenta",
  _FLEET_GROUP_GROUPLIST_ADDBTN_: "AGREGAR",
  _FLEET_GROUP_GROUPLIST_DEVICENAME_: "Dispositivo",
  _FLEET_GROUP_GROUPLIST_EDIT_: "Editar dispositivo",
  _FLEET_GROUP_GROUPLIST_DELETE_: "Eliminar dispositivo",
  _FLEET_GROUP_GROUPLIST_REMOVETITLE_: "¿Eliminar dispositivo?",
  _FLEET_GROUP_GROUPLIST_REMOVEMSG_: "¿Está seguro de que desea eliminarlo?",
  _FLEET_GROUP_GROUPLIST_YESBTN_: "sí",
  _FLEET_GROUP_GROUPLIST_DELETELODING_: "Eliminando datos del dispositivo..",

  _FLEET_GROUP_GROUPDETAIL_TITLE_: "Detalles del dispositivo",
  _FLEET_GROUP_GROUPDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_GROUP_GROUPDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_GROUP_GROUPDETAIL_CANCELBTN_: "CANCELAR",

  _FLEET_GROUP_GROUPDETAIL_COMPANY_: "Cuenta",
  _FLEET_GROUP_GROUPDETAIL_PARENTGROUP_: "Seleccionar grupo principal",
  _FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_: "Grupo de dispositivos",
  _FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_: "Seleccionar activo",
  _FLEET_GROUP_GROUPDETAIL_SETLOAD_: "Guardando datos del activo..",
  _FLEET_GROUP_GROUPDETAIL_SAVEMSG_: "Guardado correctamente",
  _FLEET_GROUP_GROUPDETAIL_DEVICESAVEMSG_:
    "Grupo de dispositivos aplicado a los vehículos seleccionados",
  _FLEET_GROUP_GROUPDETAIL_ERRORMSG_:
    "Por favor, complete correctamente los campos marcados en rojo.",
  _FLEET_GROUP_GROUPDETAIL_ERRORGROP_:
    "El nombre del grupo de dispositivos ya existe.",
  _GROUP_VEHICLE_: "Vehículos del grupo",
  _COMPANY_VEHICLE_: "Vehículos de la empresa",

  _FLEET_MANAGEUSER_ROLE_TAB_: "Rol",
  _FLEET_ROLE_ROLELIST_TITLE_: "Lista de roles",

  _FLEET_ROLE_ROLELIST_COMPANYDDL_: "Cuenta",
  _FLEET_ROLE_ROLELIST_ADDBTN_: "Agregar",
  _FLEET_ROLE_ROLELIST_ROLENAME_: "Nombre del rol",
  _FLEET_ROLE_ROLELIST_STATUS_: "Estado",
  _FLEET_ROLE_ROLELIST_STATUS_ACTIVE_: "Activo",
  _FLEET_ROLE_ROLELIST_STATUS_INACTIVE_: "Inactivo",
  _FLEET_ROLE_ROLELIST_EDIT_: "Editar rol",
  _FLEET_ROLE_ROLELIST_DELETE_: "Eliminar rol",
  _FLEET_ROLE_ROLELIST_REMOVETITLE_: "¿Eliminar rol?",
  _FLEET_ROLE_ROLELIST_REMOVEMSG_: "¿Está seguro de que desea eliminarlo?",
  _FLEET_ROLE_ROLELIST_YESBTN_: "sí",
  _FLEET_ROLE_ROLELIST_DELETELODING_: "Eliminando datos del rol..",

  _FLEET_ROLE_ROLEDETAIL_TITLE_: "Detalles del rol",
  _FLEET_ROLE_ROLEDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_ROLE_ROLEDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_ROLE_ROLEDETAIL_CANCELBTN_: "CANCELAR",
  _FLEET_ROLE_ROLEDETAIL_COMPANY_: "Seleccionar cuenta",
  _FLEET_ROLE_ROLEDETAIL_ROLENAME_: "Nombre del rol",
  _FLEET_ROLE_ROLEDETAIL_MODULENAME_: "Nombre del módulo",
  _FLEET_ROLE_ROLEDETAIL_VIEW_: "Ver",
  _FLEET_ROLE_ROLEDETAIL_ADD_: "Agregar",
  _FLEET_ROLE_ROLEDETAIL_EDIT_: "Editar",
  _FLEET_ROLE_ROLEDETAIL_DELETE_: "Eliminar",
  _FLEET_ROLE_ROLEDETAIL_IMPORT_: "Importar",
  _FLEET_ROLE_ROLEDETAIL_SETLOAD_: "Guardando rol...",
  _FLEET_ROLE_ROLEDETAIL_SAVEMSG_: "Guardado correctamente",
  _FLEET_ROLE_ROLEDETAIL_ERRORMSG_:
    "Complete todos los campos marcados en rojo",

  _FLEET_MANAGEVEHICLE_TAB_: "Gestionar activos y conductores",
  _FLEET_MANAGEVEHICLE_VEHICLE_TAB_: "Activos",
  _FLEET_VEHICLE_VEHICLELIST_TITLE_: "Lista de activos",
  _FLEET_VEHICLE_VEHICLELIST_COMPANYDDL_: "Cuenta",

  _FLEET_VEHICLE_VEHICLELIST_ADDBTN_: "Agregar",
  _FLEET_VEHICLE_VEHICLELIST_VEHICLENO_: "Número de activo",
  _FLEET_VEHICLE_VEHICLELIST_DRIVER_: "Conductor",
  _FLEET_VEHICLE_VEHICLELIST_NODRIVER_: "Sin conductor",
  _FLEET_VEHICLE_VEHICLELIST_DEVICE_: "Dispositivo",
  _FLEET_VEHICLE_VEHICLELIST_NODEVICE_: "Sin dispositivo",
  _FLEET_VEHICLE_VEHICLELIST_IMEI_: "IMEI",
  _FLEET_VEHICLE_VEHICLELIST_SIMNO_: "Número de SIM.",
  _SIM_NUMBER_: "Número de SIM",
  _FLEET_VEHICLE_VEHICLELIST_STATUS_: "Estado",
  _FLEET_VEHICLE_VEHICLELIST_STATUS_ACTIVE_: "Activo",
  _FLEET_VEHICLE_VEHICLELIST_STATUS_INACTIVE_: "Inactivo",
  _FLEET_VEHICLE_VEHICLELIST_EDIT_: "Editar activo",
  _FLEET_VEHICLE_VEHICLELIST_DELETE_: "Eliminar activo",
  _FLEET_VEHICLE_VEHICLELIST_REMOVETITLE_: "¿Eliminar activo?",
  _FLEET_GEOFENCE_GEOFENCELIST_REMOVETITLE_: "¿Eliminar geocerca?",
  _FLEET_VEHICLE_VEHICLELIST_REMOVEMSG_:
    "¿Está seguro de que desea eliminarlo?",
  _FLEET_VEHICLE_VEHICLELIST_YESBTN_: "sí",
  _FLEET_VEHICLE_VEHICLELIST_DELETELODING_: "Eliminando datos del activo..",

  _FLEET_VEHICLE_VEHICLEDETAIL_TITLE_: "Detalles del activo",
  _FLEET_VEHICLE_VEHICLEDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_VEHICLE_VEHICLEDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_VEHICLE_VEHICLEDETAIL_CANCELBTN_: "CANCELAR",

  _FLEET_VEHICLE_VEHICLEDETAIL_COMPANY_: "Cuenta",
  _FLEET_VEHICLE_VEHICLEDETAIL_PLATENO_: "ID / Matrícula",
  _FLEET_VEHICLE_VEHICLEDETAIL_VEHICLENAME_: "Nombre / Alias del activo",
  _FLEET_VEHICLE_VEHICLEDETAIL_DRIVER_: "Conductor",
  _FLEET_VEHICLE_VEHICLEDETAIL_ADDDRIVER_: "Agregar nuevo conductor",
  _FLEET_VEHICLEDETAIL_ADDDRIVER_TITLE_: "Agregar conductor",
  _FLEET_VEHICLE_VEHICLEDETAIL_SIMNO_: "Número de SIM",
  _FLEET_VEHICLE_VEHICLEDETAIL_BRAND_: "Marca",
  _FLEET_VEHICLE_VEHICLEDETAIL_MODEL_: "Modelo",
  _FLEET_VEHICLE_VEHICLEDETAIL_COLOR_: "Color",
  _FLEET_VEHICLE_VEHICLEDETAIL_DEVICE_: "Dispositivo",
  _FLEET_VEHICLE_VEHICLEDETAIL_IMEI_: "IMEI",
  _FLEET_VEHICLE_VEHICLEDETAIL_VIN_: "VIN",
  _FLEET_VEHICLE_VEHICLEDETAIL_ODOMETER_: "Lectura del odómetro",
  _FLEET_VEHICLE_VEHICLEDETAIL_LASTSERVICE_: "Último servicio realizado",
  _FLEET_VEHICLE_VEHICLEDETAIL_LASTOILCHANGE_: "Último cambio de aceite",

  _FLEET_VEHICLE_VEHICLEDETAIL_LASTOILCHANGE_DATE_:
    "Fecha del último cambio de aceite",

  _FLEET_VEHICLE_VEHICLEDETAIL_LASTTIRE_: "Último cambio de neumáticos",
  _FLEET_VEHICLE_VEHICLEDETAIL_OILCHANGE_: "Cambio de aceite (km)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TIRECHANGE_: "Cambio de neumáticos (km)",
  _FLEET_VEHICLE_VEHICLEDETAIL_SERVICEEXPIRE_: "Vencimiento del servicio (km)",
  _FLEET_VEHICLE_VEHICLEDETAIL_MANUFACTURE_: "Año de fabricación",

  _FLEET_VEHICLE_VEHICLEDETAIL_FUELCAPACITY_: "Capacidad de combustible",
  _FLEET_VEHICLE_VEHICLEDETAIL_FUELTANK_: "Número de tanques de combustible",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANKVOLUME1_: "Volumen del tanque 1 (lt)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANKVOLUME2_: "Volumen del tanque 2 (lt)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANKVOLUME3_: "Volumen del tanque 3 (lt)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANKVOLUME_: "Volumen del tanque",

  _FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_HORIZONTAL_: "Rectángulo horizontal",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_VERTICAL_: "Cilindro vertical",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_CYLINDRICAL_: "Cilindro horizontal",

  _FLEET_VEHICLE_VEHICLEDETAIL_TANK1SHAPE_: "Forma del tanque 1",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK1LENGTH_: "Longitud del tanque 1 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK1WIDTH_: "Ancho del tanque 1 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK1HEIGHT_: "Altura del tanque 1 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK1DIAMETER_: "Diámetro del tanque 1 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_FID1_: "ID F 1",
  _FLEET_VEHICLE_VEHICLEDETAIL_INSTALLATIONSPACE1_:
    "Espacio de instalación 1 (cm)",

  _FLEET_VEHICLE_VEHICLEDETAIL_TANK2SHAPE_: "Forma del tanque 2",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK2LENGTH_: "Longitud del tanque 2 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK2WIDTH_: "Ancho del tanque 2 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK2HEIGHT_: "Altura del tanque 2 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK2DIAMETER_: "Diámetro del tanque 2 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_FID2_: "ID F 2",
  _FLEET_VEHICLE_VEHICLEDETAIL_INSTALLATIONSPACE2_:
    "Espacio de instalación 2 (cm)",

  _FLEET_VEHICLE_VEHICLEDETAIL_TANK3SHAPE_: "Forma del tanque 3",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK3LENGTH_: "Longitud del tanque 3 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK3WIDTH_: "Ancho del tanque 3 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK3HEIGHT_: "Altura del tanque 3 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_TANK3DIAMETER_: "Diámetro del tanque 3 (cm)",
  _FLEET_VEHICLE_VEHICLEDETAIL_FID3_: "ID F 3",
  _FLEET_VEHICLE_VEHICLEDETAIL_INSTALLATIONSPACE3_:
    "Espacio de instalación 3 (cm)",

  _LENGTH_: "Longitud",

  _FLEET_VEHICLE_VEHICLEDETAIL_FUELTYPE_: "Tipo de combustible",
  _FLEET_VEHICLEDETAIL_FUELTYPEDDL_PETROL: "Gasolina",
  _FLEET_VEHICLEDETAIL_FUELTYPE_DIESEL_: "Diésel",
  _FLEET_VEHICLE_VEHICLEDETAIL_STATUS_: "Estado",
  _FLEET_VEHICLEDETAIL_STATUSDDL_ACTIVE_: "Activo",
  _FLEET_VEHICLEDETAIL_STATUSDDL_INACTIVE_: "Inactivo",
  _FLEET_VEHICLE_VEHICLEDETAIL_UPLOADICON_: "Subir ícono",
  _FLEET_VEHICLE_VEHICLEDETAIL_ICON_: "Ícono",
  _FLEET_VEHICLE_VEHICLEDETAIL_NOICON_: "Sin ícono",
  _FLEET_VEHICLEDETAIL_DIGITALIPDDL_DOOR_: "Puerta",
  _FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT_: "Cinturón de seguridad",
  _FLEET_VEHICLEDETAIL_DIGITALIPDDL_ACC_: "ACC",
  _FLEET_VEHICLEDETAIL_DIGITALIPDDL_PANIC_: "Alarma",
  _FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL1_: "Entrada digital 1",
  _FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL2_: "Entrada digital 2",
  _FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL3_: "Entrada digital 3",
  _FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL4_: "Entrada digital 4",
  _FLEET_VEHICLE_VEHICLEDETAIL_SETLOAD_: "Guardando datos del activo...",
  _FLEET_VEHICLE_VEHICLEDETAIL_SAVEMSG_: "Guardado correctamente",
  _FLEET_VEHICLE_VEHICLEDETAIL_ERRORMSG_:
    "Por favor, complete correctamente los campos que están marcados en rojo.",
  //_FLEET_VEHICLE_VEHICLEDETAIL_ERRORPHOTO_: 'Por favor, suba una imagen válida. Las dimensiones de la imagen deben ser 75*75',
  _FLEET_VEHICLE_VEHICLEDETAIL_ERRORPHOTO_:
    "Por favor, suba una imagen válida. Las dimensiones de la imagen deben ser 150*150",
  _FLEET_VEHICLE_VEHICLEDETAIL_ERRORIMEI_:
    "El número IMEI ya existe para este activo",

  _FLEET_MANAGEVEHICLE_DRIVER_TAB_: "Conductor",
  _FLEET_DRIVER_DRIVERLIST_TITLE_: "Lista de Conductores",

  _FLEET_DRIVER_DRIVERLIST_COMPANYDDL_: "Cuenta",
  _FLEET_DRIVER_DRIVERLIST_ADDBTN_: "Añadir",
  _FLEET_DRIVER_DRIVERLIST_WASLBTN_: "Wasl",
  _FLEET_DRIVER_DRIVERLIST_DRIVERNAME_: "Nombre del Conductor",
  _FLEET_DRIVER_DRIVERLIST_LICENCE_: "Número de Licencia",
  _LICENSE_NUMBER_ARABIC_: "Número de Licencia (Árabe)",
  _DRIVER_NAME_ARABIC_: "Nombre del Conductor (Árabe)",
  _FLEET_DRIVER_DRIVERLIST_MOBILE_: "Número de Móvil",
  _FLEET_DRIVER_DRIVERLIST_EDIT_: "Editar Conductor",
  _FLEET_DRIVER_DRIVERLIST_DELETE_: "Eliminar Conductor",
  _FLEET_DRIVER_DRIVERLIST_REMOVETITLE_: "¿Eliminar Conductor?",
  _FLEET_DRIVER_DRIVERLIST_REMOVEMSG_: "¿Está seguro de eliminar?",
  _FLEET_DRIVER_DRIVERLIST_YESBTN_: "Sí",
  _FLEET_DRIVER_DRIVERLIST_DELETELODING_: "Eliminando datos del conductor..",
  _ADD_NEW_: "AÑADIR NUEVO",

  _FLEET_DRIVER_DRIVERDETAIL_TITLE_: "Detalles del Conductor",
  _FLEET_DRIVER_DRIVERDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_DRIVER_DRIVERDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_DRIVER_DRIVERDETAIL_CANCELBTN_: "CANCELAR",

  _FLEET_DRIVER_DRIVERDETAIL_COMPANY_: "Cuenta",
  _FLEET_DRIVER_DRIVERDETAIL_LICENCENO_: "Número de Licencia",
  _FLEET_DRIVER_DRIVERDETAIL_DRIVERNAME_: "Nombre del Conductor",
  _FLEET_DRIVER_DRIVERDETAIL_ADDRESS_: "Dirección del Conductor",
  _FLEET_DRIVER_DRIVERDETAIL_UPLOAD_: "Subir Foto de Identificación",
  _FLEET_DRIVER_DRIVERDETAIL_ICON_: "Icono",
  _FLEET_DRIVER_DRIVERDETAIL_NOIMAGE_: "Sin Imagen",
  _FLEET_DRIVER_DRIVERDETAIL_LICENSEEXPIRY_:
    "Fecha de Vencimiento de la Licencia",
  _FLEET_DRIVER_DRIVERDETAIL_MOBILE_: "Número de Teléfono",
  _FLEET_DRIVER_DRIVERDETAIL_EMERGENCYNAME_:
    "Nombre del Contacto de Emergencia",
  _FLEET_DRIVER_DRIVERDETAIL_EMERGENCYNUMBER_:
    "Número del Contacto de Emergencia",
  _FLEET_DRIVER_DRIVERDETAIL_BLOODGROUP_: "Grupo Sanguíneo",
  _FLEET_DRIVER_DRIVERDETAIL_NOTES_: "Notas",
  _FLEET_DRIVER_DRIVERDETAIL_SETLOAD_: "Guardando Datos del Conductor...",
  _FLEET_DRIVER_DRIVERDETAIL_SAVEMSG_:
    "Datos del Conductor Guardados Correctamente",
  _FLEET_DRIVER_DRIVERDETAIL_ERRORMSG_:
    "Por favor, complete correctamente los campos marcados en rojo.",
  _FLEET_DRIVER_DRIVERDETAIL_ERRORPHOTO_:
    "Por favor, suba una imagen válida. Las dimensiones de la imagen deben ser 7575",

  _FLEET_MANAGERULE_TAB_: "Administrar Reglas",
  _FLEET_MANAGERULE_RULEADMIN_TAB_: "Administración de Reglas",
  _FLEET_RULEADMIN_RULELIST_TITLE_: "Lista de Reglas",

  _FLEET_RULEADMIN_RULELIST_COMPANYDDL_: "Cuenta",
  _FLEET_RULEADMIN_RULELIST_ADDBTN_: "Agregar",
  _FLEET_RULEADMIN_RULELIST_RULEID_: "ID de Regla",
  _FLEET_RULEADMIN_RULELIST_DESCRIPTION_: "Descripción",
  _FLEET_RULEADMIN_RULELIST_CRONRULE_: "Regla Cron",
  _FLEET_RULELIST_CRONRULE_NO_: "Ninguna",
  _FLEET_RULELIST_CRONRULE_5MIN_: "5 Minutos",
  _FLEET_RULELIST_CRONRULE_15MIN_: "15 Minutos",
  _FLEET_RULELIST_CRONRULE_30MIN_: "30 Minutos",
  _FLEET_RULELIST_CRONRULE_HOURLY_: "Cada Hora",
  _FLEET_RULELIST_CRONRULE_DAILY_: "Diario",
  _FLEET_RULELIST_CRONRULE_WEEKLY_: "Semanal",
  _FLEET_RULEADMIN_RULELIST_ACTIVE_: "Activa",
  _FLEET_RULEADMIN_RULELIST_EDIT_: "Editar Regla",
  _FLEET_RULEADMIN_RULELIST_DELETE_: "Eliminar Regla",
  _FLEET_RULEADMIN_RULELIST_REMOVETITLE_: "¿Eliminar Regla?",
  _FLEET_RULEADMIN_RULELIST_REMOVEMSG_: "¿Está seguro de que desea eliminar?",
  _FLEET_RULEADMIN_RULELIST_YESBTN_: "sí",
  _FLEET_RULEADMIN_RULELIST_DELETELODING_: "Eliminando datos de la regla..",

  _FLEET_RULEADMIN_RULEDETAIL_TITLE_: "Detalles de la Regla",
  _FLEET_RULEADMIN_RULEDETAIL_BACKBTN_: "ATRÁS",
  _FLEET_RULEADMIN_RULEDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_RULEADMIN_RULEDETAIL_CANCELBTN_: "CANCELAR",

  _FLEET_RULEADMIN_RULEDETAIL_COMPANY_: "Cuenta",
  _FLEET_RULEADMIN_RULEDETAIL_RULENAME_: "Nombre de Alerta",
  _FLEET_RULEADMIN_RULEDETAIL_NOTIFICATIONEMAIL_: "Correo de Notificación",
  _FLEET_RULEADMIN_RULEDETAIL_NOTIFICATIONMOBILE_: "Móvil de Notificación",
  _FLEET_RULEADMIN_RULEDETAIL_SYSTEMRULE_: "Regla del Sistema",
  _FLEET_RULEADMIN_RULEDETAIL_ACTIVE_: "Activa",
  _FLEET_RULEDETAIL_ACTIVEDDL_NO_: "No",
  _FLEET_RULEDETAIL_ACTIVEDDL_YES_: "Sí",
  _FLEET_RULEADMIN_RULEDETAIL_CRONRULE_: "Regla Cron",
  _FLEET_RULEDETAIL_CRONRULE_NO_: "No",
  _FLEET_RULEDETAIL_CRONRULE_5MIN_: "5 Minutos",
  _FLEET_RULEDETAIL_CRONRULE_15MIN_: "15 Minutos",
  _FLEET_RULEDETAIL_CRONRULE_30MIN_: "30 Minutos",
  _FLEET_RULEDETAIL_CRONRULE_HOURLY_: "Cada Hora",
  _FLEET_RULEDETAIL_CRONRULE_DAILY_: "Diario",
  _FLEET_RULEDETAIL_CRONRULE_WEEKLY_: "Semanal",
  _FLEET_RULEDETAIL_CRONRULE_RULETRIGGER_:
    "(Usado para activar la regla periódicamente)",
  _FLEET_RULEADMIN_RULEDETAIL_DESCRIPTION_: "Descripción",
  _FLEET_RULEADMIN_RULEDETAIL_RULESELECTOR_: "Selector de Alerta",
  _FLEET_RULEADMIN_RULEDETAIL_RULESELECTORBTN_:
    "Seleccionar Selector de Alerta",
  _FLEET_RULEADMIN_RULEDETAIL_TRIGGERACTION_: "Acción de Activación",
  _FLEET_RULEDETAIL_TRIGGERACTION_EMAIL_: "Correo Electrónico",
  _FLEET_RULEDETAIL_TRIGGERACTION_SAVE_: "Guardar/Alerta",
  _FLEET_RULEDETAIL_TRIGGERACTION_QUEUE_: "Cola",
  _FLEET_RULEADMIN_RULEDETAIL_MININTERVAL_: "Intervalo de Alerta",
  _FLEET_RULEADMIN_RULEDETAIL_MININTERVALMIN_: "(minutos)",
  _FLEET_RULEADMIN_RULEDETAIL_PREDEFINEACTION_: "Acciones Predefinidas",
  _FLEET_RULEDETAIL_PREDEFINEACTIONDDL_SELECT_: "Seleccionar",
  _FLEET_RULEDETAIL_PREDEFINEACTIONDDL_ON_: "Enviar comando Inmovilización ONN",
  _FLEET_RULEDETAIL_PREDEFINEACTIONDDL_OFF_:
    "Enviar comando Inmovilización OFF",
  _FLEET_RULEADMIN_RULEDETAIL_EMAILSUBJECT_: "Asunto del Correo",
  _FLEET_RULEADMIN_RULEDETAIL_SELECTPARAMETER_: "Seleccionar Parámetro",
  _FLEET_RULEDETAIL_SELECTPARAMETER_VEHICLE_: "Nº de Activo",
  _FLEET_RULEDETAIL_SELECTPARAMETER_SPEED: "Velocidad",
  _FLEET_RULEDETAIL_SELECTPARAMETER_DISTANCE_: "Distancia",
  _FLEET_RULEDETAIL_SELECTPARAMETER_LOCATION_: "Ubicación",
  _FLEET_RULEDETAIL_SELECTPARAMETER_TEMPERATURE_: "Temperatura",
  _FLEET_RULEADMIN_RULEDETAIL_EMAILMESSAGE_: "Mensaje de Correo",
  _FLEET_RULEADMIN_RULEDETAIL_SMSMESSAGE_: "Mensaje SMS",
  _FLEET_RULEADMIN_VEHICLEDETAIL_TITLE_:
    "Selección de Activo/Código de Estado:",
  _FLEET_RULEADMIN_RULEDETAIL_VEHICLEID_: "Por ID de Activo",
  _FLEET_RULEADMIN_RULEDETAIL_VEHICLE_EMPTY_:
    "No hay Activos (Seleccionar por Grupos)",
  _FLEET_RULEADMIN_RULEDETAIL_VEHICLE_ERRORMSG_:
    "Por favor seleccione un Activo.",
  _FLEET_RULEADMIN_RULEDETAIL_GROUPID_: "ID de Grupo",
  _FLEET_RULEADMIN_RULEDETAIL_GROUP_EMPTY_:
    "No hay Grupos (Seleccionar por Activos)",
  _FLEET_RULEADMIN_RULEDETAIL_GROUP_ERRORMSG_:
    "Por favor seleccione ID de Activo o ID de Grupo.",
  _FLEET_RULEADMIN_RULEDETAIL_STATUSCODE_: "Código de Estado",
  _FLEET_RULEDETAIL_STATUSCODEDDL_ALLCODE_: "Todos los Códigos",
  _FLEET_RULEADMIN_RULEDETAIL_SETLOAD_: "Guardando datos de la Regla...",
  _FLEET_RULEADMIN_RULEDETAIL_SAVEMSG_: "Guardado Exitosamente",
  _FLEET_RULEADMIN_RULEDETAIL_ERRORMSG_:
    "Por favor complete correctamente los campos que están marcados en rojo.",

  _FLEET_RULEDETAIL_RULESELECTORWIN_TITLE_: "Ventana del Selector de Alerta",
  _FLEET_RULEDETAIL_RULESELECTORWIN_ALERTTITLE_: "Confirmación de Cierre",
  _FLEET_RULEADMIN_RULESELECTORWIN_ALERTMSG_:
    "Tienes cambios no guardados en esta ventana. ¿Deseas cerrar la ventana y perder tus cambios?",
  _FLEET_RULEADMIN_RULESELECTORWIN_YESBTN_:
    "Tienes cambios no guardados en esta ventana. ¿Deseas cerrar la ventana y perder tus cambios?",

  _FLEET_RULESELECTORDETAIL_TITLE_: "Detalles del Selector de Alerta",
  _FLEET_RULESELECTORDETAIL_SAVEBTN_: "GUARDAR",
  _FLEET_RULESELECTORDETAIL_ENABLEBTN_: "Habilitar",
  _FLEET_RULESELECTORDETAIL_DISABLEBTN_: "Deshabilitar",
  _FLEET_RULESELECTORDETAIL_DESCRIPTION_: "Descripción",
  _FLEET_RULESELECTORDETAIL_ERRORMSG_: "Este es un campo obligatorio.",
  _FLEET_RULESELECTORDETAIL_RULE1_TITLE_: "Frenado brusco",
  _FLEET_RULESELECTORDETAIL_RULE1__SETSPEEDLIMIT_:
    "Establecer límite de reducción de velocidad (km/h)",
  _FLEET_RULESELECTORDETAIL_RULE1_DESCRIPTION_:
    "Esta regla se activa cuando el conductor aplica un frenado repentino. El usuario puede establecer el límite de reducción de velocidad en km/h. La regla se activará cuando la velocidad disminuya repentinamente hasta el límite establecido y el usuario será notificado al respecto.",

  _FLEET_RULESELECTORDETAIL_RULE2_TITLE_: "Aceleración brusca",
  _FLEET_RULESELECTORDETAIL_RULE2_SETACCERSPEEDLIMIT_:
    "Establecer límite de velocidad acelerada (km/h)",
  _FLEET_RULESELECTORDETAIL_RULE2_DESCRIPTION_:
    "Esta regla se activa cuando el conductor aplica una aceleración repentina. El usuario puede establecer el límite de velocidad acelerada en km/h. La regla se activará cuando la velocidad aumente repentinamente hasta el límite definido y el usuario será notificado al respecto.",

  _FLEET_RULESELECTORDETAIL_RULE3_TITLE_: "Cinturón de seguridad",
  _FLEET_RULESELECTORDETAIL_RULE3_SETVEHICLESPEED_:
    "Establecer velocidad del vehículo (km/h)",
  _FLEET_RULESELECTORDETAIL_RULE3_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo se mueve a una velocidad de 10 km/h y el conductor no está usando el cinturón de seguridad.",

  _FLEET_RULESELECTORDETAIL_RULE4_TITLE_: "Trabajo fuera de horario",
  _FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_: "Desde la hora",
  _FLEET_RULESELECTORDETAIL_RULE4_TOTIME_: "Hasta la hora",
  _FLEET_RULESELECTORDETAIL_RULE4_SPEEDLIMIT_:
    "Establecer límite de velocidad (km/h)",
  _FLEET_RULESELECTORDETAIL_RULE4_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo se conduce fuera del horario laboral con una velocidad mayor que el límite definido. Si no se requiere límite de velocidad, el usuario puede establecerlo en 0. Nota: Por favor, defina las horas de trabajo en los campos de tiempo anteriores.",
  _FLEET_RULESELECTORDETAIL_RULE5_TITLE_: "Activo detenido sin reportar",
  _FLEET_RULESELECTORDETAIL_RULE5_SETTIMELIMIT_:
    "Establecer límite de tiempo (min)",
  _FLEET_RULESELECTORDETAIL_RULE5_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo ha dejado de reportar durante el intervalo de tiempo definido.",

  _FLEET_RULESELECTORDETAIL_RULE6_TITLE_: "Detenido fuera del geocerca",
  _FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_: "Seleccionar geocerca",
  _FLEET_RULESELECTORDETAIL_RULE6_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo está detenido fuera de la geocerca durante el intervalo de tiempo definido.",

  _FLEET_RULESELECTORDETAIL_RULE7_TITLE_: "Exceso de velocidad",
  _FLEET_RULESELECTORDETAIL_RULE7_SETSPEEDLIMIT_:
    "Establecer límite de velocidad (km/h)",
  _FLEET_RULESELECTORDETAIL_RULE7_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo supera el límite de velocidad definido.",

  _FLEET_RULESELECTORDETAIL_RULE8_TITLE_: "Entrada Encendido/Apagado",
  _FLEET_RULESELECTORDETAIL_RULE8_INPUT_: "Seleccionar entrada",
  _FLEET_RULESELECTORDETAIL_RULE8_EVENT_: "Seleccionar evento",
  _FLEET_RULESELECTORDETAIL_RULE8_EVENT_ON_: "ENCENDIDO",
  _FLEET_RULESELECTORDETAIL_RULE8_EVENT_OFF_: "APAGADO",
  _FLEET_RULESELECTORDETAIL_RULE8_DESCRIPTION_:
    "Esta regla se activa cuando cualquier entrada se enciende o se apaga.",

  _FLEET_RULESELECTORDETAIL_RULE9_TITLE_: "Monitoreo de temperatura",
  _FLEET_RULESELECTORDETAIL_RULE9_SETTEMPERATURE_:
    "Establecer nivel de temperatura (Temp mínima)",
  _FLEET_RULESELECTORDETAIL_RULE9_MAXTEMP_: "Temp máxima",
  _FLEET_RULESELECTORDETAIL_RULE9_DESCRIPTION_:
    "Esta regla se activa cuando la temperatura supera el límite definido. El usuario establecerá la temperatura mínima y máxima.",

  _FLEET_RULESELECTORDETAIL_RULE10_TITLE_: "Aumento de combustible",
  _FLEET_RULESELECTORDETAIL_RULE10_FUELINCREASE_:
    "Establecer nivel de aumento de combustible (%)",
  _FLEET_RULESELECTORDETAIL_RULE10_DESCRIPTION_:
    "Esta regla se activa cuando el nivel de combustible aumenta según el porcentaje definido.",

  _FLEET_RULESELECTORDETAIL_RULE11_TITLE_: "Disminución de combustible",
  _FLEET_RULESELECTORDETAIL_RULE11_FUELDROP_:
    "Establecer nivel de disminución de combustible (%)",
  _FLEET_RULESELECTORDETAIL_RULE11_FUELDROPDDL_SENS1_:
    "Sensor de combustible 1",
  _FLEET_RULESELECTORDETAIL_RULE11_FUELDROPDDL_SENS2_:
    "Sensor de combustible 2",
  _FLEET_RULESELECTORDETAIL_RULE11_FUELDROPDDL_SENS3_:
    "Sensor de combustible 3",
  _FLEET_RULESELECTORDETAIL_RULE11_DESCRIPTION_:
    "Esta regla se activa cuando el combustible disminuye según el porcentaje definido.",

  _FLEET_RULESELECTORDETAIL_RULE12_TITLE_: "Llegada/Salida de geocerca",
  _FLEET_RULESELECTORDETAIL_RULE12_GEOFENCE_: "Seleccionar geocerca",
  _FLEET_RULESELECTORDETAIL_RULE12_EVENT_: "Seleccionar evento",
  _FLEET_RULESELECTORDETAIL_RULE12_EVENTDDL_INOUT_: "Dentro/Fuera",
  _FLEET_RULESELECTORDETAIL_RULE12_EVENTDDL_IN_: "Dentro",
  _FLEET_RULESELECTORDETAIL_RULE12_EVENTDDL_OUT_: "Fuera",
  _FLEET_RULESELECTORDETAIL_RULE12_DESCRIPTION_:
    "Esta regla se activa cuando el activo entra o sale de la geocerca asignada.",

  _FLEET_RULESELECTORDETAIL_RULE13_TITLE_: "Distancia recorrida",
  _FLEET_RULESELECTORDETAIL_RULE13_ASSIGNDISTANCE_: "Asignar distancia (KM)",
  _FLEET_RULESELECTORDETAIL_RULE13_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo ha recorrido la distancia indicada.",

  _FLEET_RULESELECTORDETAIL_RULE14_TITLE_: "Recordatorio de servicio",
  _FLEET_RULESELECTORDETAIL_RULE14_DESCRIPTION_:
    "Esta regla se activa cuando el servicio ha expirado.",

  _FLEET_RULESELECTORDETAIL_RULE15_TITLE_:
    "Enviar última posición a intervalos fijos",
  _FLEET_RULESELECTORDETAIL_RULE15_SELECTINTERVAL_:
    "Seleccionar intervalo (hora)",
  _FLEET_RULESELECTORDETAIL_RULE15_DESCRIPTION_:
    "Esta regla enviará la última posición por correo electrónico en intervalos de tiempo fijos.",

  _FLEET_REPORTS_TAB_: "Informes",
  _REPORT_: "Informe",
  _FLEET_REPORTS_COMPANY_: "Cuenta",
  _FLEET_REPORTS_VEHICLENO_: "Nombre del activo",
  _FLEET_REPORTS_VEHICLETYPE_: "Tipo de activo",
  _FLEET_REPORTS_FROM_: "Desde",
  _FLEET_REPORTS_TO_: "Hasta",
  _FLEET_REPORTS_SHOWBTN_: "Mostrar",
  _FLEET_REPORTS_EMAILBTN_: "Correo",
  _FLEET_REPORTS_COMPLETEREPORT_TITLE_: "Datos de seguimiento",
  _FLEET_REPORTS_FUELREPORT_TITLE_: "Informe de nivel de combustible",
  _FLEET_REPORTS_FUELREPORT_FUELVOLUME_: "Volumen de combustible y odómetro",
  _FLEET_REPORTS_FUELREPORT_TIME_: "Hora",
  _FLEET_REPORTS_TEMPREPORT_TITLE_: "Informe de temperatura",
  _FLEET_REPORTS_TEMPREPORT_TEMPERATURE_: "Temperatura",
  _FLEET_REPORTS_TEMPREPORT_TIME_: "Hora",
  _TOTAL_TRAVEL_REPORT_: "Informe de viaje total",
  _FLEET_REPORTS_STARTSTOPREPORT_TITLE_: "Informe de viaje",
  _FLEET_REPORTS_STARTSTOPREPORT_STOPEDTIME_: "Tiempo detenido",
  _FLEET_REPORTS_STARTSTOPREPORT_STARTDATETIME_: "Fecha/Hora de inicio",
  _FLEET_REPORTS_STARTSTOPREPORT_STARTADDRESS_: "Dirección de inicio",
  _FLEET_REPORTS_STARTSTOPREPORT_STOPDATETIME_: "Fecha/Hora de parada",
  _FLEET_REPORTS_STARTSTOPREPORT_STOPADDRESS_: "Dirección de parada",
  _FLEET_REPORTS_STARTSTOPREPORT_DISTTRAVEL_: "Distancia recorrida",
  _FLEET_REPORTS_STARTSTOPREPORT_ELAPSEDTIME_: "Duración",
  _FLEET_REPORTS_STARTSTOPREPORT_FUELUSED_1: "Combustible usado 1",
  _FLEET_REPORTS_STARTSTOPREPORT_FUELUSED_2: "Combustible usado 2",
  _FLEET_REPORTS_STARTSTOPREPORT_FUELUSED_3: "Combustible usado 3",

  _FLEET_REPORTS_DISTANCEREPORT_TITLE_: "Informe diario de distancia",
  _FLEET_REPORTS_DISTANCEREPORT_STARTOD_: "Odómetro de inicio",
  _FLEET_REPORTS_DISTANCEREPORT_STOPOD_: "Odómetro de parada",

  _FLEET_REPORTS_STOPREPORT_TITLE_: "Informe de paradas",
  _FLEET_REPORTS_STOPREPORT_ADDRESS_: "Dirección",
  _FLEET_REPORTS_STOPREPORT_NEARESTPOI_: "POI más cercano (si existe)",
  _FLEET_REPORTS_STOPREPORT_ARRIVALTIME_: "Hora de llegada",
  _FLEET_REPORTS_STOPREPORT_DEPARTURETIME_: "Hora de salida",
  _FLEET_REPORTS_STOPREPORT_TIMESTOP_: "Tiempo detenido",
  _FLEET_REPORTS_STOPREPORT_VIEWMAP_: "Ver en el mapa",

  _FLEET_REPORTS_EVENTREPORT_TITLE_: "Informe de eventos",
  _FLEET_REPORTS_EVENTREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_EVENTREPOR_ADDRESS_: "Dirección",
  _FLEET_REPORTS_EVENTREPOR_SPEED_: "Velocidad",
  _FLEET_REPORTS_EVENTREPOR_ODOMETER_: "Odómetro",
  _FLEET_REPORTS_EVENTREPOR_EVENT_: "Evento",
  _FLEET_REPORTS_EVENTREPOR_IGNITION_: "Estado del encendido",
  _FLEET_REPORTS_EVENTREPOR_VIEWMAP_: "Ver en el mapa",

  _FLEET_REPORTS_RULETRIGGERREPORT_TITLE_: "Informe de activación de reglas",
  _FLEET_REPORTS_RULETRIGGERREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_RULETRIGGERREPORT_ADDRESS_: "Dirección",
  _FLEET_REPORTS_RULETRIGGERREPORT_SPEED_: "Velocidad",
  _FLEET_REPORTS_RULETRIGGERREPORT_ODOMETER_: "Odómetro",
  _FLEET_REPORTS_RULETRIGGERREPORT_EVENT_: "Evento",
  _FLEET_REPORTS_RULETRIGGERREPORT_IGNITION_: "Estado del encendido",
  _FLEET_REPORTS_RULETRIGGERREPORT_RULETRIGGER_: "Regla activada",
  _FLEET_REPORTS_RULETRIGGERREPORT_VIEWMAP_: "Ver en el mapa",

  _FLEET_REPORTS_FLEETREPORT_TITLE_: "Informe resumido de la flota",
  _FLEET_DAY_SUMMRY_REPORTS_FLEETREPORT_TITLE_: "Resumen diario de la flota",
  _FLEET_REPORTS_FLEETREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_FLEETREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_FLEETREPORT_MAXSPEED_: "Velocidad máxima",
  _FLEET_REPORTS_FLEETREPORT_AVERAGESPEED_: "Velocidad promedio",
  _FLEET_REPORTS_FLEETREPORT_DELTAMILAGE_:
    "Distancia recorrida en el período seleccionado",
  _FLEET_REPORTS_FLEETREPORT_CURRENTODOMETER_: "Odómetro actual",
  _FLEET_REPORTS_FLEETREPORT_MAXRPM_: "RPM máxima (desde OBD o CANBUS)",
  _FLEET_REPORTS_FLEETREPORT_AVERAGERPM_: "RPM promedio (desde OBD o CANBUS)",
  _FLEET_REPORTS_FLEETREPORT_FUELCONSUM_: "Consumo de combustible (L)",
  _FLEET_REPORTS_FLEETREPORT_FUELECONOMY_: "Rendimiento de combustible (Km/L)",
  _FLEET_REPORTS_FLEETREPORT_FATIGUEHOUR_: "Horas de fatiga",
  _FLEET_REPORTS_FLEETREPORT_HARSHBREAK_: "Alarmas de frenado brusco",
  _FLEET_REPORTS_FLEETREPORT_HARSHACCELERATION_:
    "Alarmas de aceleración brusca",

  _FLEET_REPORTS_GEOFENCEREPORT_TITLE_:
    "Informe de geocerca o POI entrada/salida",
  _FLEET_REPORTS_GEOFENCEREPORT_INTIME_: "Hora de entrada",
  _FLEET_REPORTS_GEOFENCEREPORT_OUTTIME_: "Hora de salida",
  _FLEET_REPORTS_GEOFENCEREPORT_GEOPOI_: "Geocerca o POI",
  _FLEET_REPORTS_GEOFENCEREPORT_ELAPSETIME_:
    "Tiempo transcurrido dentro de la geocerca",
  _FLEET_REPORTS_GEOFENCEREPORT_TIMESTOP_: "Tiempo detenido",

  _FLEET_REPORTS_COMMANDREPORT_TITLE_: "Informe de comandos enviados",
  _FLEET_REPORTS_COMMANDREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_COMMANDREPORT_COMMANDSENT_: "Comando enviado",
  _FLEET_REPORTS_COMMANDREPORT_DEVICECOMMAND_:
    "¿El dispositivo recibió el comando?",
  _FLEET_REPORTS_COMMANDREPORT_USER_: "Usuario",
  _FLEET_REPORTS_COMMANDREPORT_INPUTSENT_: "Entrada enviada",
  _FLEET_REPORTS_COMMANDREPORT_REPLY_: "Respuesta",

  _FLEET_REPORTS_OBDFAULTREPORT_TITLE_: "Códigos de fallas OBD",
  _FLEET_REPORTS_OBDFAULTREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_OBDFAULTREPORT_LASTFAULTCODE_:
    "Fecha/hora en que se recibió el último código de falla",
  _FLEET_REPORTS_OBDFAULTREPORT_FAULTCODE_: "Código de falla",
  _FLEET_REPORTS_OBDFAULTREPORT_LINK_: "Enlace**",

  _FLEET_REPORTS_MAINTENANCEREPORT_TITLE_:
    "Informe de mantenimiento de la flota",
  _FLEET_REPORTS_MAINTENANCEREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_MAINTENANCEREPORT_LASTOILCHANGE_:
    "Último cambio de aceite (Fecha/Hora y odómetro)",
  _FLEET_REPORTS_MAINTENANCEREPORT_LASTTIRECHANGE_:
    "Último cambio de neumático (Fecha/Hora y odómetro)",
  _LAST_TYRE_CHANGE_: "Último cambio de neumático (Fecha/Hora y odómetro)",
  _FLEET_REPORTS_MAINTENANCEREPORT_LASTMAJORSERVICE_:
    "Último servicio mayor (Fecha/Hora y odómetro)",

  _FLEET_REPORTS_MAINTENANCEREPORT_NEXTOILCHANGE_:
    "Próximo cambio de aceite (km)",
  _FLEET_REPORTS_MAINTENANCEREPORT_NEXTTIRECHANGE_:
    "Próximo cambio de neumático (km)",
  _NEXT_TYRE_CHANGE_KM_: "Próximo cambio de neumático (km)",
  _FLEET_REPORTS_MAINTENANCEREPORT_NEXTMAJORSERVICE_:
    "Próximo servicio mayor (km)",

  _FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_:
    "Valor actual del odómetro",

  _FLEET_REPORTS_VEHICLEREPORT_TITLE_: "Informe de activos registrados",
  _FLEET_REPORTS_VEHICLEREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_VEHICLEREPORT_DEVICE_: "ID del dispositivo",
  _FLEET_REPORTS_VEHICLEREPORT_PLATE_: "Placas",
  _FLEET_REPORTS_VEHICLEREPORT_SERIALNO_: "Número de serie",
  _FLEET_REPORTS_VEHICLEREPORT_BRAND_: "Marca",
  _FLEET_REPORTS_VEHICLEREPORT_MODEL_: "Modelo",
  _FLEET_REPORTS_VEHICLEREPORT_YEAR_: "Año",
  _FLEET_REPORTS_VEHICLEREPORT_COLOR_: "Color",
  _FLEET_REPORTS_VEHICLEREPORT_VEHICLETYPE_: "Tipo de activo",
  _FLEET_REPORTS_VEHICLEREPORT_FUELECONOMY_:
    "Rendimiento de combustible (Km/L)",
  _FLEET_REPORTS_VEHICLEREPORT_VEHICLESTATUS_: "Estado del activo",
  _FLEET_REPORTS_VEHICLEREPORT_REGISTER_: "Fecha de registro",

  _FLEET_REPORTS_GEOFENCELIST_TITLE_: "Lista de geocercas",
  _FLEET_REPORTS_GEOFENCELIST_GEOFENCENAME_: "Nombre de geocerca",
  _FLEET_REPORTS_GEOFENCELIST_CREATIONDATE_: "Fecha de creación",
  _FLEET_REPORTS_GEOFENCELIST_VIEWMAP_: "Ver en el mapa",

  _FLEET_REPORTS_CHATREPORT_TITLE_: "Informe de chat",
  _FLEET_REPORTS_CHATREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_CHATREPORT_MESSAGE_: "Mensaje",
  _FLEET_REPORTS_CHATREPORT_RECEIVE_: "Recibido",
  _FLEET_REPORTS_CHATREPORT_SENT_: "Enviado",
  _FLEET_REPORTS_CHATREPORT_LOCATION_: "Ubicación del vehículo",
  _FLEET_REPORTS_CHATREPORT_User_: "Usuario",
  /* New */
  _TRACKING_: "Seguimiento",
  _MAINTENANCE_: "Mantenimiento",
  _REPORTS_: "Informes",
  _MANAGE_APP_: "Gestionar App",
  _MANAGE_ACCOUNTS_: "Gestionar cuenta",
  _DASHBOARD_: "Panel",
  _DASH_BOARD_: "PANEL",
  _HELP_AND_SUPPORT_: "Ayuda y soporte",
  _ROAD_ASSISTANCE_: "Asistencia en carretera",
  _ADMIN_ACCESS_: "Acceso de administrador",
  _LIVE_TRACING_: "Seguimiento en vivo",
  _LIVE_TRAVERSE_: "Recorrido en vivo",
  _DETAILED_TRACKING_: "Seguimiento detallado",
  _HISTORY_TRACKING_: "Historial de seguimiento",
  _MULTI_TRACKING_: "Seguimiento múltiple",
  _HEAT_MAP_: "Mapa de calor",
  _TRACK_DATA_REPORT_: "Informe de datos de seguimiento",
  _TRAVEL_REPORT_: "Informe de viaje",
  _STOPPAGE_REPORT_: "Informe de paradas",
  _TRIP_REPORT_: "Informe de trayecto",
  _EX_IDLE_REPORT_: "Informe de inactividad previa",
  _IDLE_REPORT_: "Informe de inactividad",
  _DISTANCE_REPORT_: "Informe de distancia",
  _DETAILED_DISTANCE_REPORT_: "Informe detallado de distancia",
  _ACCOUNT_: "Cuenta",
  _ASSET_NAME_: "Nombre del activo",
  _FROM_: "Desde",
  _FROM_TIME_: "Hora de inicio",
  _TO_TIME_: "Hora de fin",
  _FILTER_: "Filtrar",
  _SHOW_: "Mostrar",
  _EXPORT_: "Exportar",
  _EMAIL_: "Correo",
  _TIKTOK_: "Tiktok",
  _NEW_TAB_: "Nueva pestaña",
  _START_ODOMETER_: "Odómetro inicial",
  _STOP_ODOMETER_: "Odómetro final",
  _DISTANCE_TRAVELED_KMS_: "Distancia recorrida (Km)",
  _DISTANCE_TRAVELED_: "Distancia recorrida",
  _START_DATETIME_: "Fecha/Hora de inicio",
  _STOP_DATETIME_: "Fecha/Hora de parada",
  _FLEET_REPORT_: "Informe de flota",
  _FLEET_SUMMARY_REPORT_: "Informe resumido de la flota",
  _FUEL_FILLED_REPORT_: "Informe de combustible llenado",
  _MILEAGE_REPORT_: "Informe de kilometraje",
  _MILEAGE_: "Kilometraje",
  _FUEL_PRICE_: "Precio del combustible",
  _FLEET_MANAGEMENT_REPORT_: "Informe de gestión de flota",
  _VEHICLE_DIAGNOSTIC_REPORT_: "Informe de diagnóstico del vehículo",
  _ALERT_REPORT_: "Informe de alertas",
  _SPEED_VIOLATION_REPORT_: "Informe de exceso de velocidad",
  _SPEED_KM_: "Velocidad (Km/h)",
  _GEOFENCE_OR_POI_INOUT_REPORT_: "Informe de geocerca o POI entrada/salida",
  _TEMP_REPORT_: "Informe de temperatura",
  _VEHICLE_NUMBER_: "Número del vehículo",
  _INTERVAL_: "Intervalo",
  _CRITICAL_DATA_: "Datos críticos",
  _GEOFENCE_SUMMARY_REPORT_: "Informe resumido de geocercas",
  _SUMMARY_: "Resumen",
  _DETAIL_GEOFENCE_SUMMARY_: "Resumen detallado de geocerca",
  _GEOFENCE_NAME_: "Nombre de geocerca",
  _GEOFENCE_TYPE_: "Tipo de geocerca",
  _IN_TIME_: "Hora de entrada",
  _OUT_TIME_: "Hora de salida",
  _DISTANCE_: "Distancia",
  _FUEL_: "Combustible",
  _COST_: "Costo",
  _RT_IDLE_TIME_: "Tiempo de inactividad RT",
  _RT_TRAVEL_TIME_: "Tiempo de viaje RT",
  _FS_IDLE_TIME_: "Tiempo de inactividad FS",
  _FS_TRAVEL_TIME_: "Tiempo de viaje FS",
  _IDLE_TIME_: "Tiempo inactivo",
  _TRAVEL_TIME_: "Tiempo de viaje",
  _VEHICLE_NOT_POLL_REPORT_: "Informe de vehículo sin encuestar",
  _RULE_TRIGGER_REPORT_: "Informe de activación de reglas",
  _RULE_SELECTOR_: "Selector de reglas",
  _DRIVER_RELATED_REPORT_: "Informe relacionado con conductor",
  _DRIVER_LOGIN_REPORT_: "Informe de inicio de sesión del conductor",
  _DRIVER_NAME_: "Nombre del conductor",
  _DRIVER_DETAILS_: "Detalles del conductor",
  _LOGIN_TIME_: "Hora de inicio de sesión",
  _LOGOUT_TIME_: "Hora de cierre de sesión",
  _MAX_SPEED_1: "Velocidad máxima",
  _DRIVER_PERFORMANCE_REPORT_: "Informe de desempeño del conductor",
  _DRIVER_PERFORMANCE_DETAIL_: "Detalles de desempeño del conductor",
  _EXC_IDLE_: "Ex inactividad",
  _HARSH_BREAK_: "Frenado brusco",
  _HARSH_ACCELERATION_: "Aceleración brusca",
  _OVER_SPEED_: "Exceso de velocidad",
  _MAXIMUM_SPEED_AS_PER_THE_LIMIT_SET_:
    "Velocidad máxima según el límite establecido",
  _OVER_SPEED_AS_PER_THE_ROAD_SPEED_: "Exceso de velocidad según la vía",
  _DRIVER_COMPLAIN_REPORT_: "Informe de quejas del conductor",
  _OVERTIME_REPORT_: "Informe de horas extra",
  _MISCELLANEOUS_REPORTS_: "Informes varios",
  _USER_LOGIN_REPORT_: "Informe de inicio de sesión de usuario",
  _VEHICLE_REGISTERED_REPORT_: "Informe de vehículo registrado",
  _COMMAND_SENT_REPORT_: "Informe de comando enviado",
  _EVENT_REPORT_: "Informe de eventos",
  _EMAIL_REPORT_: "Informe por correo",
  _RAW_DATA_REPORT_: "Informe de datos sin procesar",
  _GEOFENCES_LIST_: "Lista de geocercas",
  _PASSENGER_LOG_REPORT_: "Informe de registro de pasajeros",
  _ATTENDANCE_REPORT_: "Informe de asistencia",
  _ATTENDANCE_DETAILS_: "Detalles de asistencia",
  _EMPLOYEE_TYPE_: "Tipo de empleado",
  _OFFICE_NAME_: "Nombre de la oficina",
  _CATALOGS_: "Catálogos",
  _USERS_: "Usuarios",
  _USERS_LIST_: "Lista de usuarios",
  _NAME_: "Nombre",
  _LAST_NAME_: "Apellido",
  _USERNAME_: "Usuario",
  _USER_TYPE_: "Tipo de usuario",
  _EMAIL_ID_: "Correo electrónico",
  _MOBILE_NUMBER_: "Número móvil",
  _STATUS_: "Estado",
  _EMPLOYEE_ID_: "ID de empleado",
  _ASSET_ID_: "ID de activo",
  _ACCOUNT_NAME_: "Nombre de la cuenta",
  _ASSET_TYPE_: "Tipo de activo",
  _DEVICE_: "Dispositivo",
  _IMEI_: "IMEI",
  _SIM_NO_: "Número de SIM",
  _INSTALLATION_: "Instalación",
  _EXPIRY_DATE_: "Fecha de expiración",
  _DRIVER_: "Conductor",
  _GROUPS_: "Grupos",
  _LICENSE_NUMBER_: "Número de licencia",
  _LICENSE_EXPIRE_: "Expiración de licencia",
  _OFFICE_LOCATION_: "Ubicación de la oficina",
  _COMPANY_NAME_: "Nombre de la empresa",
  _OFFICE_TYPE_: "Tipo de oficina",
  _CONTACT_PERSON_: "Persona de contacto",
  _CONTACT_PERSONS_EMAIL_ID: "Correo electrónico de contacto",
  _ADD_: "Agregar",
  _REFRESH_: "Actualizar",
  _ASSET_DEVICE_ASSIGNMENT_: "Asignación de dispositivo al activo",
  _ALLOCATE_ASSET_: "Asignar activo",
  _ALLOCATE_DATE_: "Fecha de asignación",
  _DAYS_USED_: "Días usados",
  _RETURN_ASSET_: "Devolver activo",
  _RETURN_DATE_: "Fecha de devolución",
  _RULES_ENGINE_: "Motor de reglas",
  _RULE_ID_: "ID de regla",
  _DESCRIPTION_: "Descripción",
  _CRON_RULE_: "Regla Cron",
  _ACTIVE_: "Activo",
  _MAINTENANCE_MODULE_: "Módulo de mantenimiento",
  _ASSET_NUMBER_: "Número de activo",
  _CURRENT_ODOMETER_: "Odómetro actual",
  _GARAGE_NAME_: "Nombre del garaje",
  _GARAGE_ADDRESS_: "Dirección del garaje",
  _FUEL_MANAGEMENT_: "Gestión de combustible",
  _FUEL_DETAIL_: "Detalles del combustible",
  _PETROL_: "Gasolina",
  _DIESEL_: "Diésel",
  _FUEL_FILLED_: "Combustible llenado",
  _GEOFENCE_MANAGEMENT_: "Gestión de geocercas",
  _CREATION_DATE_: "Fecha de creación",
  _BOUNDS_: "Límites",
  _RADIUS_: "Radio",
  _ACTION_: "Acción",
  _TRIP_CODE_: "Código de viaje",
  _TRIP_COST_: "Costo del viaje",
  _TRIP_DURATION_: "Duración del viaje",
  _STATUS_AND_DURATION_: "Estado y última duración",
  _TRIP_NAME_: "Nombre del viaje",
  _ZONE_DETAILS_: "Detalles de zona",
  _ROUTE_MANAGEMENT_: "Gestión de rutas",
  _DELIVERY_MANAGEMENT_: "Gestión de entregas",
  _DELIVERY_MANAGEMENT_REPORT_: "Informe de gestión de entregas",
  _CUSTOMER_NAME_: "Nombre del cliente",
  _INVOICE_NO_: "Número de factura",
  _INVOICE_AMOUNT_: "Monto de la factura",
  _MATERIAL_DESCRIPTION_: "Descripción del material",
  _NO_OF_CARTONS_: "Número de cajas",
  _PICKUP_DELIVERY_: "Recoger/Entregar",
  _BACK_: "Atrás",
  _SERVICE_: "Servicio",
  _LOCK_: "Bloquear",
  _TRANSIT_: "En tránsito",
  _TRAFFIC_: "Tráfico",
  _EDIT_ACCOUNT_: "Editar cuenta",
  _EDIT_PROFILE_: "Editar perfil",
  _CHANGE_PASSWORD_: "Cambiar contraseña",
  _NEW_POI_: "Nuevo POI",
  _SHOW_POI_: "Mostrar POI",
  _CLEAR_POI_: "Borrar POI",
  _SEARCH_POI_: "Buscar POI",
  _IMPORT_POI_FROM_KML_: "Importar POI desde KML",
  _DRAW_GEOFENCE_: "Dibujar geocerca",
  _SHOW_GEOFENCE_: "Mostrar geocerca",
  _IMPORT_EXPORT_FROM_XML_: "Importar/Exportar desde XML",
  _SEARCH_ASSET_: "Buscar activo",
  _SEARCH_ADDRESS_: "Buscar dirección",
  _HOSPITAL_: "Hospital",
  _FUEL_STATION_: "Estación de combustible",
  _POLICE_STATION_: "Comisaría",
  _NEAREST_ASSET_: "Activo más cercano",
  _GARAGE_: "Garaje",
  _NAVIGATION_: "Navegación",
  _CLEAR_MAP_: "Limpiar mapa",
  _DISTANCE_MEASURE_: "Medición de distancia",
  _CREATE_ASSIGN_TRIP_: "Crear/Asignar viaje",
  _LOCATION_: "Ubicación",
  _IGNITION_: "Encendido",
  _DATE_TIME_: "Fecha/Hora",
  _LAST_LOCATION_: "Última ubicación",
  _SEARCH_BY_VEHICLE_NO_: "Buscar por número de vehículo",
  _SEARCH_BY_IMEI_NO_: "Buscar por número IMEI",
  _ASSET_: "Activo",
  _TO_TIME_: "Hora de fin",
  _GRAPH_: "Gráfico",
  _SERVICES_: "Servicios",
  _USER_PROFILE_: "Perfil de usuario",
  _CONTACT_: "Contacto",
  _GPRS_COMMAND_: "Comando GPRS",
  _FLEET_GPRS_TEXT_ADDBTN_: "Agregar comando",
  _WORKING_HOURS_REPORT_: "Informe de horas de trabajo",
  _ESN_POLL_REPORT_: "Informe de sondeo ESN",
  _FLEET_REPORTS_ESNPOLLING_TITLE_: "Sondeo ESN",
  _FLEET_REPORTS_VEHICLEID_: "ID del vehículo",
  _FLEET_REPORTS_DATE_: "Fecha",
  _FLEET_REPORTS_DRIVER_ID_: "ID del conductor",
  _FLEET_REPORTS_IN_HOURS_DISTANCE_: "KM en servicio",
  _FLEET_REPORTS_OUT_HOURS_DISTANCE_: "KM fuera de servicio",
  _FLEET_REPORTS_DISTANCE_: "Distancia (Km)",
  _FLEET_REPORTS_IN_HOURS_DURATION_: "Duración en servicio",
  _FLEET_REPORTS_OUT_HOURS_DURATION_: "Duración fuera de servicio",
  _FLEET_REPORTS_IN_HOURS_START_: "Inicio de horas de servicio",
  _FLEET_REPORTS_IN_HOURS_END_: "Fin de horas de servicio",
  _FLEET_DASHBORD_SETTING_TEMP1_: "Temp1",
  _FLEET_DASHBORD_SETTING_TEMP2_: "Temp2",
  _FLEET_DASHBORD_SETTING_TEMP3_: "Temp3",
  _FLEET_DASHBORD_SETTING_RFID_: "RFID",
  _COMMAND_: "Comando",
  _ALL_: "Todos",
  _EXCEL_: "Excel",
  _CSV_: "CSV",
  _PDF_: "PDF",
  _XML_: "XML",
  _POWER_: "Potencia",
  _LAST_ROUTE_: "Última ruta",
  _BATTERY_: "Batería",
  _SPEED_: "Velocidad",
  _KEEP_AN_EYE_: "Vigilar",
  _STREET_VIEW_: "Vista de calle",
  _OBD_DATA: "Datos OBD",
  _SEND_COMMAND_: "Enviar comando",
  _IMMOBILIZER_ON_: "Inmovilizador ENCENDIDO",
  _IMMOBILIZER_OFF_: "Inmovilizador APAGADO",
  _DOOR_LOCK_: "Cerrar puerta",
  _DOOR_UNLOCK_: "Abrir puerta",
  _SHARE_LOCATION_: "Compartir ubicación",
  _RLID_: "rlId",
  _LOADING_: "Cargando",
  _DISMISS_: "Descartar",
  _FLEET_REPORTS_POILIST_TITLE_: "Lista de POI",
  _FLEET_SERVICE_POILIST_SEARCH_: "Buscar por nombre de POI",
  _POI_MANAGEMENT_: "Gestión de POI",
  _FLEET_REPORTS_POILIST_NAME_: "Nombre del POI",
  _FLEET_SERVICE_POILIST_MAP_: "Mapas",
  _FLEET_SERVICE_POILIST_VIEWMAP_: "Ver en mapa",
  _FLEET_SERVICE_POILIST_SHARE_: "Compartir",
  _FLEET_SERVICE_POILIST_SHARELOCATION_: "Compartir ubicación",
  _FLEET_SERVICE_RULEALERS_VALUE_: "Valor",
  _FLEET_DASHBORD_NEWPOI_SHAREEBTN_: "COMPARTIR",
  _FLEET_DASHBORD_GPRS_COMMAND_REPORT_: "INFORME",
  _FLEET_SELECT_EVENT_: "Seleccionar evento",
  _REPORTS_HEALTHCHECK_TITLE_: "Informe de chequeo de salud",
  _KPA_DASHBOARD_: "Panel KPA",
  _COURSE_: "Curso",
  _HEIGHT_: "Altura",
  _PID_: "PID",
  _CURRENT_TRIP_FUEL_CONSUMPTION_: "Consumo de combustible del viaje actual",
  _CURRENT_TRIP_MILEAGE_: "Kilometraje del viaje actual",
  _CURRENT_TRIP_DURATION_: "Duración del viaje actual",
  _MMCX_: "MMCX",
  _GSENSOR_1_XAXIS_: "Sensor G1 Eje X",
  _GSENSOR_1_YAXIS_: "Sensor G1 Eje Y",
  _GSENSOR_1_ZAXIS_: "Sensor G1 Eje Z",
  _GSENSOR_2_XAXIS_: "Sensor G2 Eje X",
  _GSENSOR_2_YAXIS_: "Sensor G2 Eje Y",
  _GSENSOR_2_ZAXIS_: "Sensor G2 Eje Z",
  _GSENSOR_3_XAXIS_: "Sensor G3 Eje X",
  _GSENSOR_3_YAXIS_: "Sensor G3 Eje Y",
  _GSENSOR_3_ZAXIS_: "Sensor G3 Eje Z",
  _GSENSOR_4_XAXIS_: "Sensor G4 Eje X",
  _GSENSOR_4_YAXIS_: "Sensor G4 Eje Y",
  _GSENSOR_4_ZAXIS_: "Sensor G4 Eje Z",
  _GSENSOR_5_XAXIS_: "Sensor G5 Eje X",
  _GSENSOR_5_YAXIS_: "Sensor G5 Eje Y",
  _GSENSOR_5_ZAXIS_: "Sensor G5 Eje Z",
  _VOLTAGE_: "Voltaje",
  _REPORTS_OBD_TITLE_: "Informe OBD",
  _FLEET_REPORTS_AREAWISESPEED_TITLE_:
    "Informe de exceso de velocidad por zona",
  _DEFINED_SPEED_: "Velocidad definida",
  _VEHICLE_SPEED_: "Velocidad del vehículo",
  _SPEED_LIMIT_: "Límite de velocidad",
  _SPEED_AREA_: "Área de velocidad",
  _OVERSPEED_DATE_: "Fecha de exceso de velocidad",
  _PACKET_TYPE_: "Tipo de paquete",
  _LOAD_VOLTAGE_: "Voltaje de carga",
  _IDENTITY_NUMBER_: "Número de identidad",
  _COMPANY_IDENTITY_NUMBER_: "Número de identidad de la empresa",
  _SELECT_COMPANY_IDENTITY_NUMBER_:
    "Seleccionar número de identidad de la empresa",
  _COMMERCIAL_RECORD_NUMBER_: "Número de registro comercial",
  _COMMERCIAL_RECORD_NUMBER_ARABIC_: "Número de registro comercial (árabe)",
  _COMPANY_NAME_ARABIC_: "Nombre de la empresa (árabe)",
  _COMMERCIAL_RECORD_ISSUE_DATE_:
    "Fecha de emisión del registro comercial (Hijri)",
  _EXTENSION_NUMBER_: "Número de extensión",
  _MANAGER_NAME_: "Nombre del gerente",
  _MANAGER_PHONE_: "Teléfono del gerente",
  _MANAGER_MOBILE_: "Móvil del gerente",
  _REPLY_: "Responder",
  _REGISTER_: "Registrar",
  _WASL_KEY_: "Clave WASL",
  _FLEET_REPORTS_TEMPREPORT_TITLE_: "Informe de temperatura",
  _FLEET_REPORTS_TEMPREPORT_TEMPERATURE_: "Temperatura",
  _FLEET_REPORTS_TEMPREPORT_TIME_: "Hora",
  _TOTAL_TRAVEL_REPORT_: "Informe total de viajes",
  _FLEET_REPORTS_STARTSTOPREPORT_TITLE_: "Informe de viaje",
  _FLEET_REPORTS_STARTSTOPREPORT_STOPEDTIME_: "Tiempo detenido",
  _FLEET_REPORTS_STARTSTOPREPORT_STARTDATETIME_: "Fecha/Hora de inicio",
  _FLEET_REPORTS_STARTSTOPREPORT_STARTADDRESS_: "Dirección de inicio",
  _FLEET_REPORTS_STARTSTOPREPORT_STOPDATETIME_: "Fecha/Hora de parada",
  _FLEET_REPORTS_STARTSTOPREPORT_STOPADDRESS_: "Dirección de parada",
  _FLEET_REPORTS_STARTSTOPREPORT_DISTTRAVEL_: "Distancia recorrida",
  _FLEET_REPORTS_STARTSTOPREPORT_ELAPSEDTIME_: "Duración",
  _FLEET_REPORTS_STARTSTOPREPORT_FUELUSED_1_: "Combustible usado 1",
  _FLEET_REPORTS_STARTSTOPREPORT_FUELUSED_2_: "Combustible usado 2",
  _FLEET_REPORTS_STARTSTOPREPORT_FUELUSED_3_: "Combustible usado 3",

  _FLEET_REPORTS_DISTANCEREPORT_TITLE_: "Informe de distancia por día",
  _FLEET_REPORTS_DISTANCEREPORT_STARTOD_: "Odómetro inicial",
  _FLEET_REPORTS_DISTANCEREPORT_STOPOD_: "Odómetro final",

  _FLEET_REPORTS_STOPREPORT_TITLE_: "Informe de paradas",
  _FLEET_REPORTS_STOPREPORT_ADDRESS_: "Dirección",
  _FLEET_REPORTS_STOPREPORT_NEARESTPOI_: "POI más cercano (si existe)",
  _FLEET_REPORTS_STOPREPORT_ARRIVALTIME_: "Hora de llegada",
  _FLEET_REPORTS_STOPREPORT_DEPARTURETIME_: "Hora de salida",
  _FLEET_REPORTS_STOPREPORT_TIMESTOP_: "Tiempo detenido",
  _FLEET_REPORTS_STOPREPORT_VIEWMAP_: "Ver en mapa",

  _FLEET_REPORTS_EVENTREPORT_TITLE_: "Informe de eventos",
  _FLEET_REPORTS_EVENTREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_EVENTREPOR_ADDRESS_: "Dirección",
  _FLEET_REPORTS_EVENTREPOR_SPEED_: "Velocidad",
  _FLEET_REPORTS_EVENTREPOR_ODOMETER_: "Odómetro",
  _FLEET_REPORTS_EVENTREPOR_EVENT_: "Evento",
  _FLEET_REPORTS_EVENTREPOR_IGNITION_: "Estado del encendido",
  _FLEET_REPORTS_EVENTREPOR_VIEWMAP_: "Ver en mapa",

  _FLEET_REPORTS_RULETRIGGERREPORT_TITLE_: "Informe de activación de reglas",
  _FLEET_REPORTS_RULETRIGGERREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_RULETRIGGERREPORT_ADDRESS_: "Dirección",
  _FLEET_REPORTS_RULETRIGGERREPORT_SPEED_: "Velocidad",
  _FLEET_REPORTS_RULETRIGGERREPORT_ODOMETER_: "Odómetro",
  _FLEET_REPORTS_RULETRIGGERREPORT_EVENT_: "Evento",
  _FLEET_REPORTS_RULETRIGGERREPORT_IGNITION_: "Estado del encendido",
  _FLEET_REPORTS_RULETRIGGERREPORT_RULETRIGGER_: "Regla activada",
  _FLEET_REPORTS_RULETRIGGERREPORT_VIEWMAP_: "Ver en mapa",

  _FLEET_REPORTS_FLEETREPORT_TITLE_: "Informe resumido de flota",
  _FLEET_DAY_SUMMRY_REPORTS_FLEETREPORT_TITLE_:
    "Informe resumen diario de flota",
  _FLEET_REPORTS_FLEETREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_FLEETREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_FLEETREPORT_MAXSPEED_: "Velocidad máxima",
  _FLEET_REPORTS_FLEETREPORT_AVERAGESPEED_: "Velocidad promedio",
  _FLEET_REPORTS_FLEETREPORT_DELTAMILAGE_:
    "Kilometraje delta en el período seleccionado",
  _FLEET_REPORTS_FLEETREPORT_CURRENTODOMETER_: "Odómetro actual",
  _FLEET_REPORTS_FLEETREPORT_MAXRPM_: "RPM máxima (OBD o CANBUS)",
  _FLEET_REPORTS_FLEETREPORT_AVERAGERPM_: "RPM promedio (OBD o CANBUS)",
  _FLEET_REPORTS_FLEETREPORT_FUELCONSUM_: "Consumo de combustible (Lt)",
  _FLEET_REPORTS_FLEETREPORT_FUELECONOMY_: "Economía de combustible (Km/Lt)",
  _FLEET_REPORTS_FLEETREPORT_FATIGUEHOUR_: "Horas de fatiga",
  _FLEET_REPORTS_FLEETREPORT_HARSHBREAK_: "Alarmas de frenado brusco",
  _FLEET_REPORTS_FLEETREPORT_HARSHACCELERATION_:
    "Alarmas de aceleración brusca",

  _FLEET_REPORTS_GEOFENCEREPORT_TITLE_:
    "Informe de geocercas o POI entrada/salida",
  _FLEET_REPORTS_GEOFENCEREPORT_INTIME_: "Hora de entrada",
  _FLEET_REPORTS_GEOFENCEREPORT_OUTTIME_: "Hora de salida",
  _FLEET_REPORTS_GEOFENCEREPORT_GEOPOI_: "Geocerca o POI",
  _FLEET_REPORTS_GEOFENCEREPORT_ELAPSETIME_:
    "Tiempo transcurrido dentro de la geocerca",
  _FLEET_REPORTS_GEOFENCEREPORT_TIMESTOP_: "Tiempo detenido",

  _FLEET_REPORTS_COMMANDREPORT_TITLE_: "Informe de comandos enviados",
  _FLEET_REPORTS_COMMANDREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_COMMANDREPORT_COMMANDSENT_: "Comando enviado",
  _FLEET_REPORTS_COMMANDREPORT_DEVICECOMMAND_:
    "¿El dispositivo recibió el comando?",
  _FLEET_REPORTS_COMMANDREPORT_USER_: "Usuario",
  _FLEET_REPORTS_COMMANDREPORT_INPUTSENT_: "Entrada enviada",
  _FLEET_REPORTS_COMMANDREPORT_REPLY_: "Respuesta",

  _FLEET_REPORTS_OBDFAULTREPORT_TITLE_: "Códigos de fallos OBD",
  _FLEET_REPORTS_OBDFAULTREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_OBDFAULTREPORT_LASTFAULTCODE_:
    "Fecha/Hora del último código de fallo recibido",
  _FLEET_REPORTS_OBDFAULTREPORT_FAULTCODE_: "Código de fallo",
  _FLEET_REPORTS_OBDFAULTREPORT_LINK_: "Enlace**",

  _FLEET_REPORTS_MAINTENANCEREPORT_TITLE_: "Informe de mantenimiento de flota",
  _FLEET_REPORTS_MAINTENANCEREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_MAINTENANCEREPORT_LASTOILCHANGE_:
    "Último cambio de aceite (Fecha/Hora y Odómetro)",
  _FLEET_REPORTS_MAINTENANCEREPORT_LASTTIRECHANGE_:
    "Último cambio de neumático (Fecha/Hora y Odómetro)",
  _LAST_TYRE_CHANGE_: "Último cambio de neumático (Fecha/Hora y Odómetro)",
  _FLEET_REPORTS_MAINTENANCEREPORT_LASTMAJORSERVICE_:
    "Último servicio mayor (Fecha/Hora y Odómetro)",
  _FLEET_REPORTS_MAINTENANCEREPORT_NEXTOILCHANGE_:
    "Próximo cambio de aceite (km)",
  _FLEET_REPORTS_MAINTENANCEREPORT_NEXTTIRECHANGE_:
    "Próximo cambio de neumático (km)",
  _NEXT_TYRE_CHANGE_KM_: "Próximo cambio de neumático (Km)",
  _FLEET_REPORTS_MAINTENANCEREPORT_NEXTMAJORSERVICE_:
    "Próximo servicio mayor (km)",
  _FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_:
    "Valor actual del odómetro",

  _FLEET_REPORTS_VEHICLEREPORT_TITLE_: "Informe de activos registrados",
  _FLEET_REPORTS_VEHICLEREPORT_VEHICLE_: "Activo",
  _FLEET_REPORTS_VEHICLEREPORT_DEVICE_: "ID del dispositivo",
  _FLEET_REPORTS_VEHICLEREPORT_PLATE_: "Placas",
  _FLEET_REPORTS_VEHICLEREPORT_SERIALNO_: "Número de serie",
  _FLEET_REPORTS_VEHICLEREPORT_BRAND_: "Marca",
  _FLEET_REPORTS_VEHICLEREPORT_MODEL_: "Modelo",
  _FLEET_REPORTS_VEHICLEREPORT_YEAR_: "Año",
  _FLEET_REPORTS_VEHICLEREPORT_COLOR_: "Color",
  _FLEET_REPORTS_VEHICLEREPORT_VEHICLETYPE_: "Tipo de activo",
  _FLEET_REPORTS_VEHICLEREPORT_FUELECONOMY_: "Economía de combustible (Km/Lt)",
  _FLEET_REPORTS_VEHICLEREPORT_VEHICLESTATUS_: "Estado del activo",
  _FLEET_REPORTS_VEHICLEREPORT_REGISTER_: "Fecha de registro",

  _FLEET_REPORTS_GEOFENCELIST_TITLE_: "Lista de geocercas",
  _FLEET_REPORTS_GEOFENCELIST_GEOFENCENAME_: "Nombre de geocerca",
  _FLEET_REPORTS_GEOFENCELIST_CREATIONDATE_: "Fecha de creación",
  _FLEET_REPORTS_GEOFENCELIST_VIEWMAP_: "Ver en mapa",

  _FLEET_REPORTS_CHATREPORT_TITLE_: "Informe de chat",
  _FLEET_REPORTS_CHATREPORT_DATETIME_: "Fecha/Hora",
  _FLEET_REPORTS_CHATREPORT_MESSAGE_: "Mensaje",
  _FLEET_REPORTS_CHATREPORT_RECEIVE_: "Recibido",
  _FLEET_REPORTS_CHATREPORT_SENT_: "Enviado",
  _FLEET_REPORTS_CHATREPORT_LOCATION_: "Ubicación del vehículo",
  _FLEET_REPORTS_CHATREPORT_User_: "Usuario",

  _WASL_VEHICLE_LIST_: "Lista de vehículos WASL",
  _WASL_DRIVER_LIST_: "Lista de conductores WASL",
  _SEQUENCE_NUMBER_: "Número de secuencia",
  _PLATE_REGISTER_NUMBER_: "Número de registro de placa",
  _NUMBER_: "Número de placa",
  _RIGHT_LETTER_: "Letra derecha de la placa",
  _MIDDLE_LETTER_: "Letra central de la placa",
  _LEFT_LETTER_: "Letra izquierda de la placa",
  _IMEI_NUMBER_: "Número IMEI",
  _RESPONSE_: "Respuesta",
  _PLATE_TYPE_: "Tipo de placa",
  _WASL_VEHICLE_KEY_: "Clave de vehículo WASL",
  _WASL_DRIVER_KEY_: "Clave de conductor WASL",
  _DOB_: "Fecha de nacimiento",
  _DOB_FORMATE_: "Formato de fecha de nacimiento",
  _DOB_LABEL_: "Fecha de nacimiento",
  _SELECT_DRIVER_: "Seleccionar conductor",
  _WASL_: "WASL",
  _WEIGHT_VOLT_: "Peso/Volt",
  _LOAD_SENSOR_: "Sensor de carga",
  _TOTAL_TRUCK_WEIGHT_: "Peso total (Kg)",
  _EMPTY_TRUCK_WEIGHT_: "Peso del camión vacío (Kg)",
  _LOAD_LUGGAGE_WEIGHT_: "Peso de carga/equipaje (Kg)",
  _EMPTY_TRUCK_WEIGHT_KG_: "Peso del camión vacío (Kg)",
  _VEHICLE_STATUS_: "Estado del vehículo",
  _WASL_REPLY_: "Respuesta WASL",
  _VEHICLE_REFERENCE_KEY_: "Clave de referencia del vehículo",
  _DRIVER_REFERENCE_KEY_: "Clave de referencia del conductor",
  _VELOCITY_: "Velocidad",
  _WEIGHT_: "Peso",
  _WEIGHT_PDF_: "PDF de peso",
  _LOCATION_TIME_: "Hora de ubicación",
  _ROLE_CODE_: "Código de rol",
  _REGISTRATION_TYPE_: "Tipo de registro",
  _POSTING_TIME_: "Hora de publicación",
  _RESPONSE_TIME_: "Tiempo de respuesta",
  _FLEET_MAINTENANCE_REPORT_: "Informe de mantenimiento de flota",
  _GENSET_WORKING_HOUR_REPORT_: "Informe de horas de trabajo del generador",
  _VEHICLE_PERFORMANCE_REPORT_: "Informe de rendimiento del vehículo",
  _DATA_CONSUMPTION_REPORT_: "Informe de consumo de datos",
  _TOTAL_: "Total",
  _HALTED_FROM_: "Detenido desde",
  _HALTED_TILL_: "Detenido hasta",
  _EMAIL_IDS_: "Correos electrónicos",
  _TOTAL_STOP_REPORT_: "Informe total de paradas",
  _FROM_DATE_: "Desde fecha",
  _TO_DATE_: "Hasta fecha",
  _TOTAL_STOPPAGE_: "Paradas totales",
  _TOTAL_DURATION_: "Duración total",
  _SUB_ACCOUNT_: "Subcuentas",
  _TOTAL_TRAVEL_REPORT_: "Informe total de viajes",
  _TOTAL_TRIPS_: "Total de viajes",
  _TOTAL_TRAVEL_DURATION_: "Duración total de viaje",
  _TAG_ID_: "ID de etiqueta",
  _ACTIVITY_: "Actividad",
  _TRIP_REPORT_MAP_: "Mapa del informe de viaje",
  _TRIP_MIN_KM_: "Distancia mínima del viaje (Km)",
  _TOTAL_IDLE_REPORT_: "Informe total de inactividad",
  _TOTAL_IDLING_COUNT_: "Conteo total de inactividad",
  _IDLE_SINCE_: "Inactivo desde",
  _IDLE_FROM_: "Inactivo desde",
  _IDLE_TO_: "Inactivo hasta",
  _IDLE_DURATION_: "Duración de inactividad",
  _TOTAL_EX_IDLE_REPORT_: "Informe total de ex-inactividad",
  _TOTAL_EXIDLING_COUNT_: "Conteo total de ex-inactividad",
  _VEHICLE_MODEL_: "Modelo del vehículo",
  _DETAILED_DISTANCE_RECORD_: "Registro detallado de distancia",
  _EXIDLE_TIME_: "Tiempo de ex-inactividad",
  _TOTAL_STOP_: "Paradas totales",
  _IDLE_COUNT_: "Conteo de inactividad",
  _OVER_SPEED_: "Exceso de velocidad",
  _ENERED_ODOMETER_: "Odómetro ingresado",
  _TOTAL_RUN_KM_: "Total recorrido (Km)",
  _FUEL_CONSUMED_: "Combustible consumido",
  _FUEL_CONSUMPTION_: "Consumo de combustible (L)",
  _AMOUNT_: "Monto",
  _VEHICLE_TYPE_: "Tipo de vehículo",
  _LAST_POLLED_DATETIME_: "Última consulta Fecha/Hora",
  _LAST_POLLED_LOCATION_: "Última ubicación consultada",
  _GEOFENCE_SUMMARY_TOTAL_: "Resumen total de geocercas",
  _FS_IDLE_: "FS Inactivo",
  _FS_TRAVEL_: "FS en viaje",
  _RT_IDLE_: "RT Inactivo",
  _RT_TRAVEL_: "RT en viaje",
  _TOTAL_RT_TIME_: "Tiempo total RT (Minutos)",
  _TOTAL_FS_TIME_: "Tiempo total FS (Minutos)",
  _TOTAL_RT_COST_: "Costo total RT",
  _TOTAL_FS_COST_: "Costo total FS",
  _FREEZER_: "Congelador",
  _CHILLER_: "Refrigerador",
  _DRY_: "Seco",
  _INSTALLATION_DATE_: "Fecha de instalación",
  _DEVICE_: "Dispositivo",
  _DRIVER_PERFORMANCE_TOTAL_: "Rendimiento total del conductor",
  _NO_OF_VEHICLES_: "Número de vehículos",
  _KM_: "Km",
  _TRAVEL_: "Viaje",
  _IDLE_: "Inactividad",
  _EX_IDLE_: "Ex-inactividad",
  _MAX_SPEED_AS_LIMIT_SET_: "Velocidad máxima según el límite establecido",
  _COMPLAIN_: "Queja",
  _COMPLAIN_DATETIME_: "Fecha y hora de la queja",
  _OVER_TIME_REPORT_: "Informe de horas extras",
  _WORKING_HR_: "Horas de trabajo (Tiempo de viaje)",
  _ALLOCATE_WORKING_HR_: "Asignar horas de trabajo",
  _OVERTIME_HOURS_: "Horas extras",
  _OVERTIME_CHARGE_: "Costo de horas extras",
  _LOGIN_DATETIME_: "Fecha/Hora de inicio de sesión",
  _LOGIN_IP_: "IP de inicio de sesión",
  _LOGIN_LOCATION_: "Ubicación de inicio de sesión",
  _CONTACT_NO_: "Número de contacto",
  _ACCOUNT_STATUS_: "Estado de la cuenta",
  _REPORT_NAME_: "Nombre del informe",
  _FREQUENCY_: "Frecuencia",
  _RAW_DATA_: "Datos sin procesar",
  _CUSTOMER_TYPE_: "Tipo de cliente",
  _MAILID_: "Correo electrónico",
  _CC_: "CC",
  _PASSENGER_TAGID_: "ID de etiqueta del pasajero",
  _PASSENGER_NAME_: "Nombre del pasajero",
  _LOGOUT_LOCATION_: "Ubicación de cierre de sesión",
  _TOTAL_ATTENDANCE_DETAILS_: "Detalles totales de asistencia",
  _DRIVER_ID_: "ID del conductor",
  _TOTAL_WORKING_HOURS_: "Horas totales de trabajo",
  _TOTAL_OVERTIME_: "Total de horas extras",
  _PUNCH_IN_: "Entrada",
  _PUNCH_OUT_: "Salida",
  _DAILY_WORKING_HOURS_: "Horas de trabajo diarias",
  _OVERTIME_: "Horas extras",
  _DIFFERENCE_: "Diferencia",
  _TRACKING_REPORT_: "Informe de seguimiento",
  _USAGE_: "Uso",
  _MULTISCREEN_: "Multipantalla",
  _DEVICE_LOG_: "Registro del dispositivo",
  _ASSET_DEVICE_ASSIGNMENT_: "Asignación de dispositivo al activo",
  _TASK_MANAGEMENT_: "Gestión de tareas",
  _FUEL_CONSUMPTION_: "Consumo de combustible",
  _WORKING_HOUR_: "Horas de trabajo",
  _PASSENGER_: "Pasajero",
  _VEHICLE_PERFORMANCE_TOTAL_: "Rendimiento total del vehículo",
  _VEHICLE_: "Vehículos",
  _TOTAL_DRIVER_: "Total de conductores",
  _TOTAL_KM_: "Km totales",
  _TOTAL_TRAVEL_: "Viaje total",
  _TOTAL_IDLE_: "Inactividad total",
  _TOTAL_EXC_IDLE_: "Ex-inactividad total",
  _TOTAL_OVER_SPEED_: "Exceso de velocidad total",
  _TOTAL_OVER_SPEED_AS_ROAD_SPEED_: "Exceso de velocidad según la carretera",
  _VEHICLE_PERFORMANCE_DETAILS_: "Detalles del rendimiento del vehículo",
  Travel: "Paradas",
  _DATA_LOADING_: "Cargando datos...",
  _BYTES_RECEIVED_: "Bytes recibidos",
  _VIN_: "VIN",
  _CONNECT_: "Conectar",
  _SUPPORT_PID_: "PID compatible",
  _RPM_: "RPM",
  _COOLANT_TEMP_: "Temperatura del refrigerante",
  _DTC__CLEARED_: "Kilometraje DTC borrado",
  _MIL_ACTIVATED_DISTANCE_: "Distancia activada MIL",
  _MIL_STATUS_: "Estado MIL",
  _DTC_NUMBER_: "Número DTC",
  _DIAGNOSTIC_TROUBLE_CODE_: "Código de falla de diagnóstico",
  _THROTLE_POSITION_: "Posición del acelerador",
  _ENGINE_LOAD_: "Carga del motor",
  _FUEL_LEVEL_INPUT_: "Nivel de combustible",
  _PROTOCOL_: "Protocolo",
  _MILAGE_: "Kilometraje",

  _ACCOUNT_ID_: "ID de cuenta",
  _ACCOUNT_ALISE_: "Alias de cuenta",
  _POSTAL_CODE_: "Código postal",
  _TAX_ID_: "ID fiscal",
  _ACCOUNT_SETTINGS_: "Configuración de cuenta",
  _INDUSTRY_: "Industria",
  _ACCOUNT_CREATED_: "Cuenta creada",
  _PAYMENT_TERM_: "Términos de pago",
  _MAIN_CONTACT_: "Contacto principal",
  _ADMINISTRATIVE_CONTACT_: "Contacto administrativo",
  _TECHNICAL_CONTACT_: "Contacto técnico",
  _WEBSITE_: "Sitio web",
  _SHOW_HIDE_PASSWORD_: "Mostrar/Ocultar contraseña",
  _CREATED_BY_: "Creado por",
  _PHOTO_ID_: "ID de foto",
  _EMPLOYMENT_STATUS_: "Estado de empleo",
  _NATIONALITY_: "Nacionalidad",
  _EMPLOYEE_INFORMATION_: "Información del empleado",
  _EMARGENCY_INFORMATION_: "Información de emergencia",

  _TRACKING_DETAILS_: "Detalles de seguimiento",
  _TRACK_: "Rastrear",
  _WORKING_HOUR_: "Horas de trabajo",
  _OVERTIME_CHARGES_: "Cargos por horas extras",
  _SEARCH_BRAND_: "Buscar marca",
  _SEARCH_DRIVER_: "Buscar conductor",
  _SEARCH_SIM_NO_: "Buscar SIM",
  _SEARCH_IMEI_: "Buscar IMEI",
  _SEARCH_ASSET_: "Buscar activo",
  _HOME_LOCATION_: "Ubicación principal",
  _PAYMENT_TYPE_: "Tipo de pago",
  _COMMUNICATION_: "Comunicación",
  _ASSET_EXPIRY_DATE_: "Fecha de vencimiento del activo",
  _ATTENDANT_MOBILE_NO_: "Teléfono móvil del asistente",
  _ATTENDANT_NAME_: "Nombre del asistente",
  _PLATE_NO_: "ID/Placa",
  _INSTALLER_: "Instalador",
  _INSATALLED_LOCATION_: "Ubicación instalada",
  _FUEL_SENSOR_: "Sensor de combustible",
  _TEMP_SENSOR_: "Sensor de temperatura",
  _CANBUS_OBD_: "Canbus/OBD",
  _LOCK_ALARM_: "Bloqueo/Alarma",
  _ASSET_IMAGE_: "Imagen del activo (150*150)",
  _ATTACHED_PICTURE_: "Imagen adjunta",
  _ADMINISTRATIVE_SETTINGS_: "Configuración administrativa",
  _ASSET_PICTURE_: "Imagen del activo",
  _DEVICE_SETTINGS_: "Configuración del dispositivo",
  _CONNECTED_ACCESORIES_: "Accesorios conectados",
  _FUELID1_: "FuelId1",
  _FUELID2_: "FuelId2",
  _SENSOR1_: "Sensor 1",
  _SPEED_LIMIT_: "Límite de velocidad",
  _IDLE_LIMIT_: "Límite de inactividad",
  _MAX_IDLE_LIMIT_: "Límite máximo de inactividad",
  _MAINTENANCE_MODULE_SETTING_: "Configuración del módulo de mantenimiento",
  _DIFF_ODOMETER_: "Diferencia del odómetro",
  _SERVICE_INTERVAL_: "Intervalo de servicio (km)",
  _SERVICE_INTERVAL_DAYS: "Intervalo de servicio (días)",
  _OIL_CHANGE_INTERVAL_: "Intervalo de cambio de aceite (km)",
  _TIRE_CHANGE_KM_: "Intervalo de cambio de neumático (km)",
  _MACHINE_RUNNING_HR_: "Horas de funcionamiento de la máquina",
  _SERVICING_HR_: "Horas de mantenimiento",
  _FUEL_MODULE_SETTING_: "Configuración del módulo de combustible",
  _ASSET_MILAGE_: "Kilometraje del activo (km/lt)",
  _FUEL_CAPACITY1_: "Capacidad de combustible 1 (lt)",
  _FUEL_CAPACITY2_: "Capacidad de combustible 2 (lt)",
  _HEAVY_VEHICLE_: "Vehículo pesado",
  _LIGHT_VEHICLE_: "Vehículo ligero",
  _DRIVING_DETAILS_: "Detalles de conducción",
  _ASSET_VEHICLE_: "Activos/Vehículos",
  _TAG_ID1_: "ID de etiqueta 1",
  _TAG_ID2_: "ID de etiqueta 2",
  _PERMIT_NO_: "Número de permiso",
  _PERMIT_EXPIRY_DATE_: "Fecha de vencimiento del permiso",
  _VISA_EXPIRY_DATE_: "Fecha de vencimiento de visa",
  _CONTACT_PERSON_NAME_: "Nombre del contacto",
  _CONTACT_PERSON_EMAILID_: "Correo del contacto",
  _ASSIGN_ASSET_: "Activo asignado",
  _ADD_WORKING_HOURS_: "Agregar horas de trabajo",
  _ADD_LOCATION_: "Agregar ubicación",
  _WORKING_TIME_FROM_: "Horario de trabajo desde",
  _WORKING_TIME_TO_: "Horario de trabajo hasta",
  _SELECT_TYPE_: "Seleccionar tipo",
  _EMPLOYEE_NAME_: "Nombre del empleado",
  _DESIGNATION_: "Cargo",
  _DEPARTMENT_: "Departamento",
  _DEPARTMENTS_: "Departamentos",
  _LOCATION_: "Ubicación",
  _PICK_UP_TIME_: "Hora de recogida",
  _DROP_OFF_TIME_: "Hora de entrega",
  _ADD_PASSENGER_: "Agregar pasajero",
  _REMOVE_: "Eliminar",
  _IDNO_: "ID",
  _BLOOD_GROUP_: "Grupo sanguíneo",
  _PASSENGER_TYPE_: "Tipo de pasajero",
  _WASL_COMPANY_LIST_: "Lista de empresas WASL",
  _ACCOUNT_LIST_: "Lista de cuentas",
  _USER_PROFILE_LIST_: "Lista de perfiles de usuario",
  _RECORD_: "Registro",
  _SEARCH_DERIVER_NAME_: "Buscar por nombre de conductor",
  _SEARCH_MOBILENO_: "Buscar por número de móvil",
  _OFFICE_LOCATION_LIST_: "Lista de ubicaciones de oficina",
  _WORKING_HOUR_LIST_: "Lista de horas de trabajo",
  _PASSENGER_LIST_: "Lista de pasajeros",
  _BUSNO_: "Número de autobús",
  _UPLOAD_: "Subir",
  _DOWNLOAD_SAMPLE_EXCEL_: "Descargar Excel de ejemplo",
  _MODIFIEDBY_: "Modificado por",
  _FIELD_NAME_: "Nombre del campo",
  _BEFORE_: "Antes",
  _AFTER_: "Después",
  _ASSIGN_JOB_: "Asignar trabajo",
  _JOB_: "Trabajo",
  _DELIVERY_DATE_: "Fecha de entrega",
  _DELIVERY_TIME_: "Hora de entrega",
  _HALT_TIME_: "Tiempo de parada",
  _NOTE_TO_DRIVER_: "Nota para el conductor",
  _SEARCHBY_: "Buscar por",
  _CUSTOMER_ADDRESS_: "Dirección del cliente",
  _CUST_NAME_: "Nombre del cliente",
  _CUST_MOBILENO_: "Teléfono del cliente",
  _NOTIFICATION_MAIL_: "Correo de notificación",
  _EDIT_NOTIFICATION_: "Editar notificación",
  _ADD_TASK_: "Agregar tarea",
  _UPLOAD_INVOICE_: "Subir factura",
  _QUANTITY_: "Cantidad",
  _JOB_TO_: "Trabajo a",
  _JOB_DATE_: "Fecha del trabajo",
  _JOB_TIME_: "Hora del trabajo",
  _JOB_TYPE_: "Tipo de trabajo",
  _ALLOCATE_TO_: "Asignar a",
  _CURRENT_VEHICLE_CONDITION_: "Condición actual del vehículo",
  _DUEDATE_: "Fecha de vencimiento",
  _ALLOCATE_VEHICLE_: "Asignar vehículo",
  _PROJECT_NAME_: "Nombre del proyecto/empresa",
  _PAYMENT_MODE_: "Método de pago",
  _TOTAL_AMOUNT_: "Monto total",
  _SERVICE_TYPE_: "Tipo de servicio",
  _SERVICE_DATE_: "Fecha de servicio",
  _NEW_SERVICE_TYPE_: "Nuevo tipo de servicio",
  _EXTRA_WORK_DONE_: "Trabajo adicional realizado",
  _TOTAL_DAYS_USED_: "Total días utilizados",
  _TOLL_USED_: "Peaje utilizado",
  _TOLL_CHARGES_: "Cargos por peaje",
  _VEHICLE_DAMAGE_CHARGE_: "Cargos por daños del vehículo",
  _TRAFFIC_FINE_: "Multa de tráfico",
  _TOTAL_AMOUNT_CHARGABLE_: "Monto total a cobrar",
  _INITIAL_ODOMETER_: "Odómetro inicial",
  _INITIAL_VEHICLE_CONDTION_: "Condición inicial del vehículo",
  _VEHICLE_PRESENT_CONDTION_: "Condición actual del vehículo",
  _RETURN_ODOMETER_: "Odómetro de retorno",
  _SEQUENCE_: "Secuencia",
  _STOP_IDLE_POINTS_: "Puntos de parada/inactividad",
  _SELECT_ADDRESS_: "Seleccionar dirección",
  _GRAPHS_: "Gráficos",
  _SPEED_GRAPH_: "Gráfico de velocidad",
  _DISTANCE_GRAPH_: "Gráfico de distancia",
  _IDLE_GRAPH_: "Gráfico de inactividad",
  _FUEL_GRAPH_: "Gráfico de combustible",
  _USAGE_GRAPH_: "Gráfico de uso",
  _TEMP_GRAPH_: "Gráfico de temperatura",
  _TEMPERATURE_GRAPH_: "Gráfico de temperatura",
  _DASHBOARD_GRAPH_: "Gráfico del tablero",
  _MULTISCREEN_GRAPH_: "Gráfico multipantalla",
  _DOWNLOAD_: "Descargar",
  _SPEED_VS_TIME_: "Velocidad vs Tiempo",
  _FROM_DATE_TIME_: "Desde fecha y hora:",
  _SPEED_KM_PER_HOUR_: "Velocidad (Km/h)",
  _TIME_MIN_: "Tiempo (Min)",
  _SUNDAY_: "Domingo",
  _MONDAY_: "Lunes",
  _TUESDAY_: "Martes",
  _WEDNESDAY_: "Miércoles",
  _THURSDAY_: "Jueves",
  _FRIDAY_: "Viernes",
  _SATURDAY_: "Sábado",
  _VALID_FROM_: "Válido desde",
  _VALID_TO_: "Válido hasta",
  _ZONE_: "Zona",
  _POINT_NAME_: "Nombre del punto",
  _NO_OF_STUDENTS_: "Número de estudiantes",
  _SEQUENCE_NO_: "Número de secuencia",
  _TRAVEL_DISTANCE_: "Distancia de viaje",
  _SELECT_DAYS_: "Seleccionar días",
  _FUEL_FILLED_DETAILS_: "Detalles de combustible llenado",
  _SEND_PUSH_NOTIFICATION_: "Enviar notificación push",
  _ALERT_SETTING_: "Configuración de alerta",
  _INSIDE_GEOFENCE_: "Dentro de la geocerca",
  _INSIDE_GEOFENCE_DESC:
    "Esta regla se activa cuando el vehículo entra en la geocerca y permanece más tiempo del asignado",
  _TIRE_CHANGE_REMINDER_: "Recordatorio de cambio de neumático",
  _OIL_CHANGE_REMINDER_: "Recordatorio de cambio de aceite",
  _AREAWISE_SPEED_VIOLATION_: "Violación de velocidad por área",
  _POWER_CUT_: "Corte de energía",
  _ALLOCATE_ASSET_LIST_: "Lista de activos asignados",
  _RETURN_ASSET_LIST_: "Lista de activos devueltos",
  _MAINTENANCE_DETAILS_: "Detalles de mantenimiento",
  _SEARCH_BY_GEOFENCE_NAME_: "Buscar por nombre de geocerca",
  _TRIP_DETAILS_ASSIGN_: "Crear/Asignar detalles de viaje",
  _TASK_MANNAGE_LIST_: "Lista de gestión de tareas",
  _FUEL_DETAIL_LIST_: "Lista de detalles de combustible",
  _FUEL_FILLED_LIST_: "Lista de combustible llenado",
  _FINISH_JOB_: "Finalizar trabajo",
  _KM_PER_HOUR_: "(Km/h)",
  _FOR_: "para",
  _HOURS_: "Hrs",
  _hour_: "Horas",

  _MIN_: "Min",
  _TOTAL_TRAVEL_DISTANCE: "Distancia total de viaje",
  _DISTANCE_NOT_APPLICABLE: "Distancia total de viaje: No disponible",
  _IDLE_IN_MINUTE: "Inactividad (Min)",
  _IDLE_DURATION_IN_MINUTE_: "Duración de inactividad (Min)",

  _TOTAL_OF_ASSETS_: "Número total de activos: ",
  _VEHICLES_: "Vehículo",

  _CONTACT_INFORMATION_: "Información de contacto",
  _BROWSE_: "Examinar...",
  _TEMPID1_: "TempId1",
  _TEMPID2_: "TempId2",
  _TEMPID3_: "TempId3",
  _TOTAL_ASSET_COST_: "Costo total del activo",
  _LOW_LIMIT1_: "Límite bajo 1",
  _HIGH_LIMIT1_: "Límite alto 1",
  _SENSOR2_: "Sensor 2",
  _SENSOR4_: "Sensor 4",
  _LOW_LIMIT2_: "Límite bajo 2",
  _HIGH_LIMIT2_: "Límite alto 2",
  _SERATER_: "Asientos",
  _COMPANY_VEHICLES_: "Vehículos de la empresa",
  _GROUP_VEHICLES_: "Vehículos del grupo",
  _ENTER_LOCATION_: "Ingresar ubicación",
  _USER_PROFILE_: "Perfil de usuario",
  _ADD_MAINTENANCE_DETAILS_: "Agregar detalles de mantenimiento",
  _EXCEL_FILE_: "Archivo Excel",
  _SELECT_EXCEL_TO_UPLOAD_: "Por favor seleccione un archivo Excel...",
  _FILE_UPLOAD_: "Subir archivo",
  _NOTIFICATIOS_: "Notificaciones",
  _SELECT_ALERT_TYPE_: "Seleccionar tipo de alerta",
  _SHOW_GEOFENCES_: "MOSTRAR GEOCERCAS",
  _SHOW_ALL_GEOFENCE_: "Mostrar todas las geocercas",
  _CURRENT_VEHICLE_LOCATION_: "Ubicación actual del vehículo",
  _MOVING_VEHICLES_: "Vehículos en movimiento",
  _STOPPED_VEHICLES_: "Vehículos detenidos",
  _IDLING_VEHICLES_: "Vehículos inactivos",
  _NOT_REPORTING_VEHICLES_: "Vehículos sin reporte",
  _EX_IDLE_: "Ex Inactivo",
  _TOTAL_VEHICLES_: "Total de vehículos",
  _LOCK_UNLOCK_MAP_: "Bloquear/Desbloquear mapa",
  _CLEAR_LAST_ROUTE_: "Borrar última ruta",
  _EXPORT_DETAILS_: "Exportar detalles",
  _SELECT_FROM_HISTORY_: "Seleccionar del historial",
  _DISCARD_CREATE_NEW_: "Descartar y crear nuevo",
  _LOAD_: "Cargar",
  _SEARCH_ADDRESS_: "Buscar dirección",
  _SEARCH_GEOFENCE_: "Buscar geocerca",
  _SEARCH_: "Buscar",
  _ENTER_DISTANCE_: "Ingresar distancia",
  _SEARCH_NEARST_VEHICLE_: "Buscar vehículo más cercano",
  _CLICK_ON_MAP_: "Hacer clic en el mapa",
  _STOPPED_: "Detenido",
  _RUNNING_: "En movimiento",
  _IDLE_: "Inactivo",
  _EX_IDLE_: "Ex-inactivo",
  _NO_GPS_: "Sin GPS",
  _NO_DATA_: "Sin datos",
  _SEC_: "(Seg)",
  _SEARCH_BY_ESN_: "Buscar por ESN",
  _SELECT_ROUT_OPTION_: "Seleccionar opción de ruta",
  _SELECT_TRIP_EVENT_: "Seleccionar evento de viaje",
  _SELECT_SPEED_: "Seleccionar velocidad",
  _PAUSE_: "Pausa",
  _PLAY_: "Reproducir",
  _ASSET_HISTORY_DETAILS_: "Detalles del historial del activo",
  _HEATMAP_: "Mapa de calor",
  _UPDATE_DATE_: "Fecha de actualización",
  _MONITOR_CENTER_: "Centro de monitoreo",
  _ROUTING_DASHBOARD_: "Tablero de rutas",
  _ALERT_TYPE_: "Tipo de alerta",
  _SEARCH_DERIVER_: "Buscar por conductor",
  _TEMPERATURE_GRAPH_: "Gráfico de temperatura",
  _TEMP_SENSOR1_: "Sensor de temperatura 1",
  _TEMP_SENSOR2_: "Sensor de temperatura 2",
  _TEMP_SENSOR3_: "Sensor de temperatura 3",
  _TEMP_SENSOR4_: "Sensor de temperatura 4",
  _TEMPERATURE_SENSOR1_: "Sensor de temperatura 1",
  _TEMPERATURE_SENSOR2_: "Sensor de temperatura 2",
  _TEMPERATURE_SENSOR3_: "Sensor de temperatura 3",
  _SHOW_ALL_: "Mostrar todo",
  _TRACK_DATE_: "Fecha de seguimiento",
  _CLEAR_ALL_: "Borrar todo",
  _PAYMENT_MODE_: "Modo de pago",
  _INVOICE_: "Factura",
  _CONTACT1_: "Contacto principal",
  _CONTACT2_: "Contacto secundario",
  _CONTACT3_: "Contacto 3",
  _MONTHLY_RENTAL_: "Renta mensual",
  _DEVICE_CHARGES_: "Cargos por dispositivo",
  _SIM_CHARGES_: "Cargos por SIM",
  _APPLICATON_CHARGES_: "Cargos por aplicación",
  _ADDON_: "Complemento",
  _RFID_CHARGES_: "Cargos RFID",
  _TEMPERATURE_SENSOR_CHARGE_: "Cargos por sensor de temperatura",
  _DRIVERID_CHARGES_: "Cargos por ID de conductor",
  _FUEL_SENSOR_CHARGES_: "Cargos por sensor de combustible",
  _CANBUS_: "Canbus",
  _MARK_LOCATION_: "Marcar ubicación",
  _RENEW_: "Renovar",
  _ATTACH_INVOICE_: "Adjuntar factura",
  _PHOTO_: "Foto",
  _LOCATION_ON_MAP_: "Ubicación en el mapa",
  _ADD_NEW_DEPARTMENT_: "Agregar nuevo departamento",
  _POLLING_IMEI_: "IMEI de sondeo",
  _VEHICLE_EXPIRY_DATE_: "Fecha de vencimiento del vehículo",
  _RENEWED_AT_: "Renovado en",
  _ATTENDAN_: "Teléfono móvil del asistente",
  _TEMPERATURE_SENSOR_: "Sensor de temperatura",
  _MULKIYA_RENEWAL_DATE_: "Fecha de renovación de Istimara",
  _MULKIYA_RENEWAL_DATE_1: "Fecha de renovación de Mulkiya",
  _INSURANCE_EXPIRY_DATE_: "Fecha de vencimiento del seguro",
  _MACHINE_SERVICE_HOURS_: "Horas de servicio de la máquina",
  _VEHICLE_PURCHASE_DATE_: "Fecha de compra del vehículo",
  _TOTAL_VEHICLE_COST_: "Costo total del vehículo",
  _DOWN_PAYMENT_: "Pago inicial",
  _MONTHLY_EMI_: "EMI mensual",
  _NO_OF_EMI_: "Número de EMI",
  _EMI_DUE_DATE_: "Fecha de vencimiento de EMI",
  _PERMIT_EXPIRY_DATE_: "Fecha de vencimiento del permiso",
  _NATIONAL_PERMIT_EXPIRY_DATE_: "Fecha de vencimiento del permiso nacional",
  _POLLUTION_EXPIRY_DATE_: "Fecha de vencimiento de contaminación",
  _VEHICLE_MILAGE_: "Kilometraje del vehículo",
  _SENSOR3_: "Sensor 3",
  _LOWLIMIT3_: "Límite bajo 3",
  _HIGH_LIMIT3_: "Límite alto 3",
  _INSURANCE_TYPE_: "Tipo de seguro",
  _MULKIYA_TYPE_: "Tipo de Istimara",
  _TERM_: "Plazo",
  _FEE_: "Tarifa",
  _CLASS_NAME_: "Nombre de la clase",
  _CLASS_DIV_: "División de clase",
  _STUDENT_NAME_: "Nombre del estudiante",
  _SCHOOL_NAME_: "Nombre de la escuela",
  _SCHOOL_: "Escuela",
  _CC_DETAILS_: "Detalles de CC",
  _EMAIL_DETAILS_: "Detalles de correo",
  _REMOVE_EVENT_: "Eliminar evento",
  _SELECT_COMPANY_: "Seleccionar empresa",
  _TRACK_DATA_MAP_: "Mapa de datos de seguimiento",
  _REPORTS_PRIOR_CONTACT_ADMINISTRATOR_:
    "Para informes anteriores a 6 meses, contacte al administrador",
  _BREAK_COUNT_: "Conteo de frenos",
  _HARSH_BRAKE_COUNT_: "Conteo de frenadas bruscas",
  _HARSH_ACCELERATION_COUNTER_: "Conteo de aceleraciones bruscas",
  _IDLING_EVENT_: "Evento de inactividad",
  _MAXSPEED_: "Velocidad máxima",
  _MAX_SPEED_: "Velocidad máxima",
  _ENGINEER_TIMER_: "Temporizador de motor encendido",
  _IDLING_TIMER_: "Temporizador de inactividad",
  _OVERSPEED_TIMER_: "Temporizador de exceso de velocidad",
  _RULE_DELETE_: "¿Está seguro de que desea eliminar la regla?",
  _MINUTES_: "Minutos",
  _IBUTTONID_: "ID del iButton",
  _PASSENGER_ID_: "ID del pasajero",
  _MANAGE_: "Administrar",
  _INPUT2_: "Entrada2",
  _MENU_SETTING_: "Configuración del menú",
  _SIM_LIST_: "Lista de SIM",
  _NOTIFICATION_: "Notificación",
  _INSPECTION_: "Inspección",
  _ERROR_: "Error",
  _SELECT_EXCEL_OR_XML_: "Seleccione solo archivos Excel o XML...",
  _FROM_DATETIME_: "Desde fecha/hora",
  _TO_DATETIME_: "Hasta fecha/hora",
  _UPLOADING_FILE_: "Subiendo su archivo...",
  _INTERVEL_: "Intervalo",
  _SAMPLE_EXCEL_: "Excel de ejemplo",
  _VEHICLE_HISTORY_DETAILS_: "Detalles del historial del vehículo",
  _END_ODOMETER_: "Odómetro final",
  _REMOVE_RECORD_: "Eliminar registro",
  _DELETE_SIM_RECORD_: "¿Desea eliminar el registro de SIM?",
  _INT_: "Int",
  _SERVICE_PROVIDER_: "Proveedor de servicios",
  _SERIAL_NO_: "Número de serie",
  _WANT_TO_DELETE_DEVICE_DETAILS_:
    "¿Desea eliminar los detalles del dispositivo?",
  _EDIT_DEVICE_DETAILS_: "Editar detalles del dispositivo",
  _DELETE_DEVICE_DETAILS_: "Eliminar detalle del dispositivo",
  _DISTANCE_TRAVEL_: "Distancia recorrida",
  _STARTTIME_: "Hora de inicio",
  _STOPTIME_: "Hora de parada",
  _DISTANCETRAVELLED_: "Distancia recorrida",
  _IDLE_MAP_: "Mapa de inactividad",
  _IDLE_TILL_: "Inactivo hasta",
  _EXCESSIVE_IDLE_MAP_: "Mapa de inactividad excesiva",
  _PICKUP_DROP_: "Recogida/Entrega",
  _VEHICLE_NOT_PULL_MAP_: "Mapa de vehículo no registrado",
  _SPEED_EXCEPTION_REPORT_: "Informe de excepción de velocidad",
  _SPEED_KM_: "Velocidad (Km)",
  _SHIPMENT_DATE_: "Fecha de envío",
  _WARRANTY_DATE_: "Fecha de garantía",
  _ROUTE_: "Ruta",
  _NO_OF_TRIPS_: "Número de viajes",
  _IMEI_NO_: "Número IMEI",
  _SHIPMENT_RECEIVED_DATE_: "Fecha de recepción del envío",
  _WARRANTY_VALIDITY_DATE_: "Fecha de validez de la garantía",
  _TRIP1_START_TIME_: "Hora de inicio del viaje 1",
  _TRIP2_START_TIME_: "Hora de inicio del viaje 2",
  _TRIP1_END_TIME_: "Hora de fin del viaje 1",
  _ADD_DEVICE_DETAILS_: "Agregar detalles del dispositivo",
  _TRIP2_END_TIME_: "Hora de fin del viaje 2",
  _GEOFENCE_OR_POI_OUT_MAP_: "Geocerca o POI dentro/fuera en mapa",
  _RPM_SPEED_: "RPM y velocidad",
  _WANT_TO_DELETE_NOTIFICATION_: "¿Desea eliminar la notificación?",
  _EDIT_SCHOOL_CALENDAR_: "Editar calendario escolar",
  _DELETE_NOTIFICATION_: "Eliminar notificación",
  _MH14_J5645_: "MH-14 J-5645",
  _GEOFENCE_ID_: "ID de geocerca",
  _HTML_: "HTML",
  _DRILL_START_TIME_: "Hora de inicio del taladro",
  _DRILL_STOP_TIME_: "Hora de fin del taladro",
  _OPERATION_HOUR_: "Horas de operación",
  _FATIQUE_HOURS_: "Horas de fatiga",
  _SELECT_GROUP_: "Seleccionar grupo",
  _EVENT_DESCRIPTION_: "Descripción del evento",
  _RFID1_: "RFID1",
  _DURATION_HH_MM_SS_: "Duración (HH:MM:SS)",
  _DISTANCE_KM_: "Distancia (KM)",
  _TRAVEL_INT_: "Intervalo de viaje",
  _STOP_INT_: "Intervalo de parada",
  _IDLE_INT_: "Intervalo de inactividad",
  _TEMP_REPORT_MAP_: "Mapa de informe de temperatura",
  _T1_MIN_: "T1 Min",
  _T1_MAX_: "T1 Max",
  _T2_MIN_: "T2 Min",
  _T2_MAX_: "T2 Max",
  _T3_MIN_: "T3 Min",
  _T3_MAX_: "T3 Max",
  _END_TIME_: "Hora de fin",
  _DRIVER_TOTAL_DETAILS_: "Detalles totales del conductor",
  _NO_OF_VEHICLES_USED_: "Número de vehículos usados",
  _MACHINE_START_TIME_: "Hora de inicio de la máquina",
  _MACHINE_STOP_TIME_: "Hora de parada de la máquina",
  _LAST_DRILL_START_TIME_: "Hora de inicio del último taladro",
  _LAST_DRILL_STOP_TIME_: "Hora de fin del último taladro",
  _MOVEMENT_SENSOR_: "Sensor de movimiento",
  _IVCAN_VEHICLE_SPEED_: "Velocidad del vehículo Ivcan",
  _IVCAN_PEDAL_POSITION_: "Posición del pedal Ivcan",
  _ENGINE_TEMP_: "Temperatura del motor",
  _FUEL_PERCENT_: "Porcentaje de combustible",
  _FUEL_CONSUMED_COUNTED_: "Combustible consumido contabilizado",
  _TOTAL_MILEAGE_COUNTED_: "Kilometraje total contabilizado",
  _IVCAN_PROGRAM_NUMBER_: "Número de programa Ivcan",
  _ENGINE_WORKING_TIME_: "Tiempo de trabajo del motor",
  _PROJECT_NAMES_: "Nombres de proyectos",
  _TRUCK_: "Camión",
  _CAR_: "Coche",
  _car_: "Coche",
  _TOTAL_FUEL_CONSUMED_LTRS_: "Combustible total consumido (Ltrs)",
  _MILEAGE_DIST_LTR_: "Rendimiento (Dist/Ltr)",
  _FUEL_LEVEL_: "Nivel de combustible",
  _BEFORE_REFILL_LTRS_: "Antes de rellenar (Ltrs)",
  _AFTER_FUEL_LEVEL_LTRS_: "Después del nivel de combustible (Ltrs)",
  _REFILL_FUEL_LEVEL_LTRS_: "Nivel de combustible recargado (Ltrs)",
  _DRIVER_MOBILE_: "Móvil del conductor",
  _DELIVERED_AT_: "Entregado en",
  _DELIVERY_STATUS_: "Estado de entrega",
  _FEEDBACK_: "Comentarios",
  _ATTACHED_IMAGE_: "Imagen adjunta",
  _ROAD_SPEED_VIOLATION_REPORT_:
    "Informe de violación de velocidad en carretera",
  _ROADSPEED_: "Velocidad en carretera",
  _ROAD_MAX_SPEED_: "Velocidad máxima en carretera",
  _SALES_PERSON_TOTAL_DETAILS_: "Detalles totales del vendedor",
  _SALES_PERSON_NAME_: "Nombre del vendedor",
  _SALES_COORDINATOR_NAME_: "Nombre del coordinador de ventas",
  _TOTAL_MEETING_: "Total de reuniones",
  _TOTAL_MEETING_ATTEND_: "Total de reuniones asistidas",
  _TOTAL_HOT_CUSTOMER_: "Total de clientes calientes",
  _TOTAL_WARM_CUSTOMER_: "Total de clientes tibios",
  _TOTAL_COOL_CUSTOMER_: "Total de clientes fríos",
  _MEETING_DATE_: "Fecha de reunión",
  _MEETING_TIME_: "Hora de reunión",
  _MEETING_STATUS_: "Estado de la reunión",
  _FINISHED_AT_: "Finalizado en",
  _NEXT_MEETING_DATE_: "Fecha de próxima reunión",
  _NEXT_: "Siguiente",
  _SUBMIT_: "Enviar",
  _CUSTOMER_STATUS_: "Estado del cliente",
  _SALES_PERSON_LOCATION_: "Ubicación del vendedor",
  _VEHICLE_LOCATION_: "Ubicación del vehículo",
  _B_CARD_: "Tarjeta de visita",
  _WANT_TO_DELETE_INSPECTION_: "¿Desea eliminar la inspección?",
  _DELETE_INSPECTION_: "¿Eliminar inspección?",
  _EDIT_INSPECTION_: "Editar detalles de inspección",
  _TECHNICIAN_NAME_: "Nombre del técnico",
  _REPAIR_: "Reparación",
  _REMOVAL_: "Retiro",
  _CHECKING_: "Revisión",
  _SEND_: "Enviar",
  _COMMAND_TYPE_: "Tipo de comando",
  _ENTER_APN_: "Ingresar APN",
  _ENTER_IP_: "Ingresar IP",
  _ENTER_PORT_: "Ingresar puerto",
  _ENTER_INTERVAL_: "Ingresar intervalo",
  _SMS_COMMAND_: "Comando SMS",
  _SALES_PERSON_: "Vendedor",
  _COMAPNY_NAME_: "Nombre de la empresa",
  _SUBJECT_: "Asunto",
  _EMAIL_BODY_: "Cuerpo del correo",
  _LAST_EXPIRY_DATE_: "Última fecha de vencimiento",
  _CURRENT_EXPIRY_DATE_: "Fecha de vencimiento actual",
  _OPTION_: "Opción",
  _PUNCH_IN_TIME_: "Hora de entrada",
  _PUNCH_IN_LOCATION_: "Ubicación de entrada",
  _PUNCH_OUT_TIME_: "Hora de salida",
  _PUNCH_OUT_LOCATION_: "Ubicación de salida",
  _GPS_: "GPS",
  _STATIONARY_FROM_: "Estacionado desde",
  _VEHICLE_START_TIME_: "Hora de inicio del vehículo",
  _VEHICLE_STOP_TIME_: "Hora de parada del vehículo",
  _TOTAL_TRAVEL_TIME_: "Tiempo total de viaje",
  _TOTAL_FS_CUSTOMER_: "Total de clientes FS",
  _TOTAL_RT_CUSTOMER_: "Total de clientes RT",
  _TOTAL_CUSTOMER_: "Total de clientes",
  _FS_DELIVERY_TIME_: "Tiempo de entrega FS",
  _RT_DELIVERY_TIME_: "Tiempo de entrega RT",
  _TO_DATE_COL_: "Hasta la fecha:",
  _IDLE_DURATION_IN_MIN_: "Duración de inactividad (min)",
  _TOTAL_NO_OF_VEHICLES_: "Número total de vehículos: ",
  _SENSOR_1_: "Sensor1 : ",
  _SENSOR_2_: "Sensor2 : ",
  _SENSOR_3_: "Sensor3 : ",
  _SENSOR_4_: "Sensor4 : ",
  _VEHICLE_DATA_NOT_AVAILABLE_: "Datos del vehículo no disponibles...",
  _DETAIL_TRACKING_: "Seguimiento detallado",
  _SEARCH_BY_VEHICLE_: "Buscar por vehículo",
  _ASSIGN_VEHICLE_: "Asignar vehículo",
  _SELECT_USER_: "Seleccionar usuario",
  _DETAIL_TRACKING_MAP_: "Seguimiento detallado en mapa",
  _LIVE_ROUTE_PATH_: "Ruta en vivo",
  _LIVE_TRAVERSED_: "Recorrido en vivo",
  _ADD_DEPARTMENT_: "Agregar departamento",
  _ADD_JOB_TYPE_: "Agregar tipo de trabajo",
  _SELECT_JOB_TYPE_: "Seleccionar tipo de trabajo",
  _ADDED_SUCCESSFULLY_: "Agregado con éxito",
  _DEPARTMENT_DETAIL_: "Detalle del departamento",
  _ASSIGN_BUS_TO_STUDENT_: "Asignar bus al estudiante",
  _SAVE_TO_ASSIGN_: "Guardar para asignar",

  _JOB_DETAILS_: "Detalles del trabajo",
  _STATUS_PENDING_: "Estado: Pendiente",
  _NO_VEHICLE_ASSIGNED_: "No se asignó vehículo",
  _NO_DATA_FOUND_SELECTED_DATE_:
    "No se encontraron datos para la fecha seleccionada",
  _JOB_NO_: "N° de trabajo",
  _JOBS_: "Trabajos",
  _TEXT_: "Texto",
  _MAIL_SETTINGS_: "Configuración de correo",
  _MENU_SETTINGS_: "Configuración de menú",
  _ADD_SIM_DETAILS_: "Agregar detalles de SIM",
  _ADD_INSPECTION_: "Agregar inspección",
  _TRIGGER_DETAILS_WINDOW_: "Ventana de detalles del disparador",
  _ROUTE_INFO_: "Información de ruta",
  _ADDRESS_INFO_WINDOW_: "Ventana de información de dirección",
  _VEHICLES_NOT_REPORTING_: "Vehículos sin reporte",
  _EXCESSIVE_IDLING_: "Inactividad excesiva",
  _OVERSPEED_REPORT_: "Informe de exceso de velocidad",
  _DATE_COL_: "Fecha :",
  _INVALID_ADDRESS_: "Dirección inválida",
  _POI_SAVED_SUCCESSFULL_: "POI guardado exitosamente",
  _SELECT_SHAPE_DRAW_FENCE_: "Seleccione forma y dibuje el perímetro",
  _LOADING_DATA_: "Cargando datos...",
  _RECORDS_NOT_FOUND_: "No se encontraron registros",
  _REMOVE_MARKER_: "Eliminar marcador",
  _INFORMATION_: "Información",
  _VEHICLE_RENEWAL_ALERT_: "Alerta de renovación de vehículo",
  _LIVE_ROUTE_: "Ruta en vivo",
  _CREATE_REPORT_: "Crear informe",
  _EXCESSIVE_IDLE_REPORT_: "Informe de inactividad excesiva",
  _VEHICLE_SUMMARY_: "Resumen del vehículo",
  _UNAUTHORIZED_USAGE_: "Uso no autorizado",
  _GEOFENCE_REPORT_: "Informe de geocerca",
  _DRIVER_BEHAVIOUR_REPORT_: "Informe de comportamiento del conductor",
  _FUEL_USAGE_REPORT_: "Informe de consumo de combustible",
  _DELIVERY_REPORT_: "Informe de entregas",
  _VEHICLE_MANAGEMENT_: "Gestión de vehículos",
  _SCHOOL_MANAGEMENT_: "Gestión escolar",
  _JOB_MANAGEMENT_: "Gestión de trabajos",
  _MASTERS_: "Maestros",
  _VEHICLES_TO_RENEW_: "Vehículos a renovar",
  _OTHER_: "Otro",
  _HIDE_VEHICLE_NO_: "Ocultar número de vehículo",
  _EDIT_GEOFENCE_: "Editar geocerca",
  _ACTIVITY_PANEL_SETTING_: "Configuración del panel de actividad",
  _IMPORT_POI_SUCCESSFULLY_: "POI importado con éxito",
  _EVENT_NAME_: "Nombre del evento",
  _INFO_: "Info",
  _MAXIMUM_4_VEHICLES_ALLOWED_: "Máximo 4 vehículos permitidos",
  _PASSENGER_LOG_: "Registro de pasajeros",
  _BUS_REGISTRATION_REPORT_: "Informe de registro de buses",
  _RPM_GRAPH_REPORT_: "Informe de gráfico de RPM",
  _RULE_TRIGGER_: "Activación de regla",
  _GEOFENCE_SUMMARY_: "Resumen de geocercas",
  _DRIVER_LOGIN_: "Inicio de sesión del conductor",
  _DRIVER_PERFORMANCE_: "Rendimiento del conductor",
  _VEHICLE_PERFORMANCE_: "Rendimiento del vehículo",
  _MACHINE_WORKING_HOURS_: "Horas de trabajo de la máquina",
  _CANBUS_REPORT_: "Informe Canbus",
  _PROJECT_VEHICLE_REPORT_: "Informe de vehículos del proyecto",
  _FUEL_CONSUMPTION_REPORT_: "Informe de consumo de combustible",
  _FUEL_REFILL_REPORT_: "Informe de recarga de combustible",
  _SALES_MANAGEMENT_: "Gestión de ventas",
  _VEHICLE_EXPIRY_REPORT_: "Informe de vencimiento de vehículos",
  _SALES_PERSON_TRACK_REPORT_: "Informe de seguimiento del vendedor",
  _STATIONARY_REPORT_: "Informe de vehículos estacionarios",
  _DISTANCE_KM_REPORT_: "Informe de distancia (km)",
  _FLEET_GEOFENCE_SUMMARY_REPORT_: "Informe resumido de geocercas de la flota",

  _CHECK_BUS_ROUT_: "Verificar ruta del bus",
  _TRIP_ID_: "ID del viaje",
  _MOOBILE_APP_: "Aplicación móvil",
  _SIBLING1_NAME_: "Nombre del hermano 1",
  _SIBLING1_ID_: "ID del hermano 1",
  _SIBLING1_CLASS_: "Clase del hermano 1",
  _SIBLING2_NAME_: "Nombre del hermano 2",
  _SIBLING2_ID_: "ID del hermano 2",
  _SIBLING2_CLASS_: "Clase del hermano 2",
  _FATHER_NAME_: "Nombre del padre",
  _FATHER_CONTACT_NO_: "Teléfono del padre",
  _MOTHER_NAME_: "Nombre de la madre",
  _MOTHER_CONTACT_NO_: "Teléfono de la madre",
  _GUARDIAN_NAME_: "Nombre del tutor",
  _GUARDIAN_CONTACT_NO_: "Teléfono del tutor",
  _PICKUP_POINT_: "Punto de recogida",
  _PICKUP_TIME_: "Hora de recogida",
  _AVAILABLE_SEATS_: "Asientos disponibles",
  _ROUT_TRIP_LIST_: "Lista de viajes de la ruta",
  _TRACKING_TIME_FROM_: "Seguimiento desde",
  _TRACKING_TIME_TO_: "Seguimiento hasta",
  _STAFF_DETAILS_: "Detalles del personal",
  _TRACKING_INTERVAL_MIN_: "Intervalo de seguimiento (Min)",
  _OTHER_PERMIT_: "Otro permiso",
  _STAFF_DATA_SAVE_: "Datos del personal guardados correctamente",
  _SAVING_SALES_PERSON_DATA_: "Guardando datos del vendedor...",
  _USERNAME_ALREDY_USE_:
    "El nombre de usuario ya está en uso. Por favor intente otro",
  _SALES_PERSON_ID_: "ID del vendedor",
  _EMPLOYEE_STATUS_: "Estado del empleado",
  _REMOVE_SALES_PERSON_: "Eliminar vendedor",
  _TIME_FROM_: "Hora desde",
  _TIME_TO_: "Hora hasta",
  _LOADING_HOUR__DETAILS_: "Cargando detalles de horas de trabajo",
  _WORKING_HOUR_DETAILS_:
    "Detalles de horas de trabajo agregados correctamente",
  _SENSOR1_NAME_: "Nombre del sensor 1 (°C)",
  _SENSOR1_LOW_LIMIT_: "Límite bajo del sensor 1 (°C)",
  _SENSOR1_HIGH_LIMIT_: "Límite alto del sensor 1 (°C)",
  _SENSOR2_NAME_: "Nombre del sensor 2 (°C)",
  _SENSOR2_LOW_LIMIT_: "Límite bajo del sensor 2 (°C)",
  _SENSOR2_HIGH_LIMIT_: "Límite alto del sensor 2 (°C)",
  _SENSOR3_NAME_: "Nombre del sensor 3 (°C)",
  _SENSOR3_LOW_LIMIT_: "Límite bajo del sensor 3 (°C)",
  _SENSOR3_HIGH_LIMIT_: "Límite alto del sensor 3 (°C)",
  _RETURNED_DATE_: "Fecha de devolución",
  _RETURNED_FROM_: "Devuelto desde",
  _EDIT_RETURN_ASSET_: "Editar detalles de activos devueltos",
  _DELETE_VEHICLE_DETAILS_: "Eliminar detalles del vehículo",
  _DELETE_VEHICLE_: "Eliminar vehículo",
  _LICENSE_NO_: "Número de licencia",
  _SALIK_USED_: "Salik usado",
  _SALIK_CHARGES_: "Cargos de Salik",
  _RETURN_ASSET_: "Devolver activos",
  _PROJECT_NAME_: "Nombre del proyecto",
  _ADD_NEW_PROJECT_: "Agregar nuevo proyecto",
  _SAVING_DETAILS_: "Guardando detalles...",
  _ALREADY_ENTERED_FOR_DATE_:
    "Ya ingresó lecturas para este vehículo en esta fecha",
  _EDIT_VEHICLE_DETAILS_: "Editar detalles del vehículo",
  _DELETE_MAINTENANCE_: "Eliminar lista de mantenimiento",
  _EDIT_MAINTENANCE_LIST_: "Editar lista de mantenimiento",
  _TOTAL_DELIVERIES_: "Total de entregas",
  _DATA_NOT_AVAILABLE_: "Datos no disponibles",
  _DATA_BROWSER_STATS_2012_: "Datos: estadísticas del navegador 2012",
  _DELIVERY_DASHABOARD_: "Panel de entregas",
  _REMOVE_DELIVERY_DETAIL_: "Eliminar detalle de entrega",
  _CUSTOMER_MOBILE_NO_: "Teléfono móvil del cliente",
  _SALES_EXECUTIVE_NAME_: "Nombre del ejecutivo de ventas",
  _DELIVERED_TIME_: "Hora de entrega",
  _CREATING_GEOFENCE_: "Creando geocerca...",
  _ONLY_9_DIGITS_ALLOWED_: "Solo se permiten 9 dígitos",
  _SALES_PERSON_EXECUTIVE_: "Ejecutivo de ventas",
  _SALES_PERSON_COORDINATOR_: "Coordinador de ventas",
  _NOTE_TO_SALES_PERSON_: "Nota para el vendedor",
  _AUTO_FINISH_: "Finalización automática",
  _LANDLINE_NUMBER_: "Número de línea fija",
  _LANDLINE_: "Teléfono fijo",
  _ADD_NEW_JOB_: "Agregar nuevo trabajo",
  _REQUEST_DATE_: "Fecha de solicitud",
  _ADD_JOB_REQUEST_DETAILS_: "Agregar detalles de solicitud de trabajo",
  _INVOICE_NUMBER_: "Número de factura",
  _REQUEST_TIME_: "Hora de solicitud",
  _REMOVE_JOB_REQUEST_DETAIL_: "Eliminar detalle de solicitud de trabajo",
  _DEPARTMENT_NAME_: "Nombre del departamento",
  _CONTACT_NO_: "Número de contacto",
  _ALLOCATE_AT_: "Asignar en",
  _REMOVE_PARENT_: "¿Eliminar padre?",
  _STUDENTS_NAME_: "Nombre de los estudiantes",
  _CLASS_: "Clase",
  _PARENTS_NAME_: "Nombre de los padres",
  _FUEL_DETAILS_: "Detalles de combustible",
  _GRADE_LIST_: "Lista de grados",
  _GRADE_BUS_TIMING_: "Horario de bus por grado",
  _SCHOOL_CALENDER_LIST_: "Lista de calendario escolar",
  _SCHOOL_CALENDER_: "Calendario escolar",
  _STAFF_: "Personal",
  _REMOVE_PASSENGER_: "¿Eliminar pasajero?",
  _CHECK_ROUTE_: "Verificar ruta",
  _SELECT_VEHICLES_: "Por favor seleccione vehículos",
  _SUCCESS_: "Éxito",
  _FILE_UPLOADED_: "Su archivo ha sido subido",
  _REASSIGN_VEHICLE_: "Reasignar vehículo",
  _EXPORT_TO_EXCEL_: "Exportar a Excel",
  _SEARCH_DELIVERY_: "Buscar entrega",
  _SEARCH_VEHICLE_: "Buscar vehículo",

  _EDIT_FUEL_FILLED_: "Editar combustible cargado",
  _DELETE_FUEL_FILLED_: "Eliminar combustible cargado",
  _FUEL_FILLED_LITERS_: "Combustible cargado (litros)",
  _LOADING_FUEL_DETAILS_: "Cargando detalles de combustible",
  _FUEL_FILLED_DETAILS_ADDED_SUCCESS_:
    "Detalles de combustible agregados correctamente",
  _EDIT_FUEL_DETAILS_: "Editar detalles de combustible",
  _DELETE_FUEL_DETAILS_: "Eliminar detalles de combustible",
  _FUEL_DETAIL_IS_EMPTY_: "El campo de detalles de combustible está vacío",
  _FUEL_DETAILS_LIST_: "Lista de detalles de combustible",
  _EXPORT_TO_EXCEL_: "Exportar a Excel",
  _EXPORT_AS_EXCEL_: "Exportar como Excel",
  _EXPORT_AS_PDF_: "Exportar como PDF",
  _EXPORT_AS_XML_: "Exportar como XML",
  _EXPORT_AS_CSV_: "Exportar como CSV",
  _RECORDS_: "Registros",
  _PLEASE_SELECT_VEHICLES_: "Por favor seleccione vehículos",
  _PLEASE_SELECT_PASSENGER_: "Por favor seleccione pasajero",
  _VEHICLE_DETAILS_: "Detalles del vehículo",
  _ALLOCATE_VEHICLE_DETAILS_LIST_: "Lista de asignación de vehículos",
  _SEARCH_BY_ALLOCATE_DATE_: "Buscar por fecha de asignación",
  _SEARCH_BY_RETURN_DATE_: "Buscar por fecha de devolución",
  _ROUT_ALLOCATION_LIST_: "Lista de asignación de rutas",
  _REASSIGN_VEHICLE_: "Reasignar vehículo",
  _ADD_STUDENT_: "Agregar estudiante",
  _GRADE_TIMING_LIST_: "Lista de horarios por grado",
  _GRADE_LIST_: "Lista de grados",
  _GRADE_BUS_TIMINGS_: "Horarios de bus por grado",
  _SCHOOL_CALENDER_LIST_: "Lista de calendario escolar",
  _SCHOOL_CALENDER_: "Calendario escolar",
  _PARENTS_LIST_: "Lista de padres",
  _PARENTS_NAME_: "Nombre de los padres",
  _CLASS_: "Clase",
  _SEARCH_: "Buscar",
  _PARENTS_: "Padres",
  _GRADE_: "Grado",
  _ASSIGN_TRIP_: "Asignar viaje",
  _CAPACITY_: "Capacidad:",
  _AVAILABLE_SEAT_: "Asiento disponible:",
  _STUDENT_ID_: "ID del estudiante",
  _GRADE_TIMING_DETAILS_: "Detalles del horario por grado",
  _LOADING_GRADE_DETAILS_: "Cargando detalles del grado",
  _GRADE_TIMING_ADDED_SUCCESS_: "Detalles de horario agregados correctamente",
  _EDIT_GRID_: "Editar grado",
  _EDIT_GRID_TIMING_: "Editar horario del grado",
  _DELETE_GRID_TIMING_: "Eliminar horario del grado",
  _DELETE_GRID_: "Eliminar grado",
  _ACADEMIC_YEAR_FROM_: "Año académico desde",
  _ACADEMIC_YEAR_TO_: "Año académico hasta",
  _ENTER_ACADEMIC_YEAR_TO_: "Ingrese año académico hasta",
  _EDIT_SCHOOL_CALENDER_: "Editar calendario escolar",
  _DELETE_SCHOOL_CALENDER_: "Eliminar calendario escolar",
  _SCHOOL_REOPEN_: "Reapertura de la escuela",
  _HOLYDAYS_: "Vacaciones",
  _PARENTS_MEETING_: "Reunión de padres",
  _MEETING_: "Reunión",
  _DELIVERY_: "Entrega",
  _EVENT_: "Evento",
  _WINTER_BREAK_FROM_: "Vacaciones de invierno desde",
  _WINTER_BREAK_TO_: "Vacaciones de invierno hasta",
  _SPRING_BREAK_FROM_: "Vacaciones de primavera desde",
  _SPRING_BREAK_TO_: "Vacaciones de primavera hasta",
  _SUMMER_BREAK_FROM_: "Vacaciones de verano desde",
  _SUMMER_BREAK_TO_: "Vacaciones de verano hasta",
  _FIRST_TERM_: "Primer trimestre",
  _FULL_TERM_: "Trimestre completo",
  _SCHOOL_CALENDER_DETAILS_: "Detalles del calendario escolar",
  _SECOND_TERM_: "Segundo trimestre",
  _THIRD_TERM_: "Tercer trimestre",
  _SCHOOL_CALENDER_UPDATED_: "Calendario escolar actualizado correctamente",
  _SCHOOL_CALENDER_ADDED_: "Calendario escolar agregado correctamente",
  _LOADING_SCHOOL_CALENDER_DETAILS_: "Cargando detalles del calendario escolar",
  _PLEASE_SELECT_START_POINT_FIRST_:
    "Por favor seleccione primero el punto de inicio",
  _SUGGEST_ROUTE_: "Sugerir ruta",
  _DEPARTURE_TIME_: "Hora de salida",
  _PLEASE_SELECT_ADDRESS_AND_SEQUENCE_:
    "Por favor seleccione dirección y secuencia",
  _PLEASE_SELECT_START_POINTAND_ADDRESS_:
    "Por favor seleccione punto de inicio y dirección",
  _EDIT_TRIP_: "Editar viaje",
  _DELETE_TRIP_: "Eliminar viaje",
  _ASSIGN_BUS_TO_STUDENT_: "Asignar bus al estudiante",
  _COPY_TRIP_: "Copiar viaje",
  _REMOVE_TRIP_: "¿Eliminar viaje?",
  _SELECT_VEHICLE_1: "Seleccionar vehículo (Nombre del conductor)",
  _SELECT_VEHICLE_: "Seleccionar vehículo",
  _SELECT_DISTRIBUTOR1_: "Seleccionar distribuidor 1",
  _DISTRIBUTOR_: "Distribuidor",
  _HIJRI_: "Hiyri",
  _GREGORIAN_: "Gregoriano",
  _FILTER_TYPE_: "Filtrar por tipo",
  _SALES_PERSON_LIST_: "Lista de vendedores",
  _STAFF_LIST_: "Lista de personal",
  _JOB_REQUEST_: "Solicitud de trabajo",
  _DELETE_JOB_: "Eliminar trabajo",
  _FINISH_JOB_: "¿Desea finalizar el trabajo?",
  _SELECT_ONE_JOB_: "Por favor seleccione al menos un trabajo",
  _SURE_TO_DELETE_: "¿Está seguro que desea eliminar?",
  _SELECT_JOB_: "Por favor seleccione trabajo",
  _SURE_TO_FINISH_JOB_: "¿Está seguro que desea finalizar el trabajo?",
  _SEARCH_REQUEST_: "Buscar solicitud",
  _SELECT_DISTRIBUTOR_: "Seleccionar distribuidor",
  _SELECT_DEPARTMENT_: "Seleccionar departamento",
  _PENDING_: "Pendiente",
  _PROCESSED_: "Procesado",
  _FINISHED_: "Finalizado",
  _SELECT_SALES_EXECUTIVE_: "Seleccionar ejecutivo de ventas",
  _SALES_EXECUTIVE_: "Ejecutivo de ventas",
  _EXCEL_DETAILS_ID_NAME_: "Detalles Excel (ID/Nombre)",
  _JOB_REQUEST_LIST_: "Lista de solicitudes de trabajo",
  _WANT_TO_DELETE_: "¿Desea eliminar?",
  _EDIT_RECORD_: "Editar registro",
  _DELETE_RECORD_: "Eliminar registro",
  _SEARCH_BUS_NO_: "Buscar por número de bus",
  _SEARCH_NAME_: "Buscar por nombre",
  _SEARCH_TAGID_: "Buscar por TagId",
  _WRONG_BUS_BOARDING_: "Subida incorrecta de bus",
  _TRIP_DETAILS_: "Detalles del viaje",
  _SEARCH_BY_BUS_NO_: "Buscar por número de bus",
  _SEARCH_BY_NAME_: "Buscar por nombre",
  _SEARCH_BY_TAGID_: "Buscar por TagId",
  _TRIP_START_TIME_: "Hora de inicio del viaje",
  _POINT_COVERED_: "Punto cubierto",
  _POINT_LEFT_: "Punto restante",
  _TRIP_END_TIME_: "Hora de fin del viaje",
  _START_LOCATION_: "Lugar de inicio",
  _COLOR_CODE_: "Código de color",
  _ASSIGN_VEHICLE_TOJOB_REQ_: "Asignar vehículo a solicitud de trabajo",
  _ASSIGN_VEHICLE_TO_COMPANY_: "Asignar vehículo a la empresa",
  _SELECT_DEVICE_GROUP_: "Seleccionar grupo de dispositivo",
  _ASSIGN_DEVICE_GROUP_TO_VEHICLE_: "Asignar grupo de dispositivo al vehículo",
  _NO_VEHICLE_PLZ_ADD_: "No hay vehículos. Por favor agregue vehículos",
  _DEVICE_GROUP_APPLIED_TO_SELECTED_:
    "Grupo de dispositivo aplicado a los vehículos seleccionados",
  _SAVE_GROUP_DEVICE_DATA_: "Guardando datos del grupo de dispositivos...",
  _CLASS_DEPARTMENT_: "Clase/Departamento",
  _STUDENT_OFF_BOARDS_: "Estudiante bajó del bus",
  _STUDENT_ON_BOARDS_: "Estudiante subió al bus",
  _NOT_VALID_TIME_: "Hora no válida",
  _SEARCH_ZONE_ADDRESS_: "Buscar zona o dirección",
  _ADD_WAYPOINTS_: "Agregar puntos de referencia",
  _GET_LOCATION_: "Obtener ubicación",
  _ENTER_ADDRESS_: "Ingrese su dirección",
  _DETAILS_: "Detalles",
  _DATA_NOT_AVALABLE_: "Datos no disponibles",
  _STUDENT_DASHABOARD_: "Panel del estudiante",
  _SELECT_BUS_: "Seleccionar bus",
  _SETTINGS_: "Configuración",
  _PASSWORD_SENT_TO_EMAIL_ADDRESS_:
    "Su contraseña ha sido enviada a su correo electrónico",
  _DETAILS_SEND_SUCCESSFULLY_: "Detalles enviados correctamente",
  _NOT_VALID_NUMBER_: "Número no válido",
  _NOT_VALID_TEXT_: "Texto no válido",
  _ENTER_EMAILID_: "Por favor ingrese su correo electrónico",
  _NAVIGATION_WINDOW_: "Ventana de navegación",
  _AN_ADDRESS_: "Una dirección",
  _ANOTHER_ADDRESS_: "Otra dirección",
  _GET_DIRECTION_: "Obtener dirección",
  _VEHICLE_NOT_AVAILABLE_: "Vehículo no disponible",
  _GEOFENCE_: "Geocerca",
  _VEHICLE_ZONE_: "Zona del vehículo",
  _ADD_ROUTE_ALLOCATION_: "Agregar asignación de ruta",
  _SUCCESSFULLY_UPDATED_: "Actualizado correctamente",
  _SEARCH_SERVICE_TYPE_: "Buscar tipo de servicio",
  _SEARCH_GARAGE_: "Buscar taller",
  _SEARCH_DATE_: "Buscar por fecha",
  _SELECT_EXCEL_FILE_ONLY_: "Por favor seleccione solo archivos Excel",
  _STUDENT_ABSENT_: "Estudiante ausente",
  _DISTANCE_FUELVOLUME_: "Distancia y volumen de combustible",
  _FUELVOLUME_: "Volumen de combustible",
  _SELECT_ZONE_: "Seleccionar zona",
  _ASSIGN_VEHICLES_TO_ZONES_: "Asignar vehículos a zonas",
  _GEO_FANCE_: "Geocerca",
  _FLEET_REPORTS_GEONAME_: "Nombre de la geocerca",
  _GENERAL_: "General",
  _LOCATIONS_: "Ubicaciones",
  _ALERTS_: "Alertas",
  _MESSAGES_LIST_: "Lista de mensajes",
  _EVENTS_: "Eventos",
  _MDT_: "MDT",
  _VEHICLE_OFFLINE_TRACKING_: "Seguimiento offline del vehículo",
  _VEHICLE_TRACKING_: "Seguimiento del vehículo",
  _TRIP_NO_: "Número de viaje",
  _MAXIMUM_SPEED_: "Velocidad máxima",
  _FUEL_USED_: "Combustible usado",
  _VEHICLE_TRIP_REPORT_: "Informe de viaje del vehículo",
  _GEO_BOUNDARY_REPORT_: "Informe de límite geográfico",
  _ADD_EVENT_: "Agregar evento",
  _REMOVE_ROUTE_: "Eliminar ruta",
  _OPTION2_: "Opción 2",
  _OPTION3_: "Opción 3",
  _REMOVE_MAINTENANCE_DETAIL_: "Eliminar detalle de mantenimiento",
  _GRADE_TIMINGS_: "Horarios por grado",
  _VEHICLE_DISTANCE_: "Distancia del vehículo",
  _VEHICLE_DISTANCE_LIST_: "Lista de distancias del vehículo",
  _DUTY_TIME_FROM_: "Hora de inicio del turno",
  _DUTY_TIME_TO_: "Hora de fin del turno",
  _SHIFT_NAME_: "Nombre del turno",
  _ADD_NOTIFICATION_: "Agregar notificación",
  _POSTED_AT_: "Publicado en",
  _SEND_NOW_: "Enviar ahora",
  _VIDEO_MONITORING_: "Monitoreo de video",
  _MDVRAlarm_Report_: "Informe de alarma MDVR",
  _WELCOME_: "Bienvenido ",
  _MENU_SETTING_LIST_: "Lista de configuración del menú",
  _NOTIFICATION_LIST_: "Lista de notificaciones",
  _INSPECTION_LIST_: "Lista de inspección",
  _MDVR_ALARM_REPORT_: "Informe de alarma MDVR",
  _DEVICE_ID_: "ID del dispositivo",
  _ALARM_TYPE_: "Tipo de alarma",
  _CONTENT_: "Contenido",
  _LAST_DATE_TIME_: "Última fecha y hora",
  _LIVE_VIDEO_STREAMING_: "Transmisión de video en vivo",
  _CHANNEL1_: "Canal 1",
  _CHANNEL2_: "Canal 2",
  _CHANNEL3_: "Canal 3",
  _CHANNEL4_: "Canal 4",
  _CHANNEL_: "Canal",
  _PLAY_BACK_OPTION_: "Opciones de reproducción",
  _COLLECTION_LIST_: "Lista de colecciones",
  _REMOVE_COLLECTION_IMAGE_: "Eliminar imagen de la colección",

  _REMOVE_COLLECTION_IMAGE_MSG_:
    "¿Desea eliminar la imagen de la colección de AWS?",
  _AWS_: "AWS",
  _IMAGE_UPLOAD_: "Subida de imagen",
  _SELECT_IMAGE_: "Por favor seleccione una imagen...",
  _BLACKLIST_PERSON_REPORT_: "Informe de persona en lista negra",
  _SIMILARITY_: "Similitud",
  _DESCRIPTION_: "Descripción",
  _BLACKLIST_: "Lista negra",
  _BLACKLISTED_AT_: "Agregado a lista negra en",
  _BLACKLIST_PERSON_: "Agregar persona a lista negra",
  _FIRST_NAME_: "Nombre",
  _LAST_NAME_: "Apellido",
  _OFFICER_ID_: "ID del oficial de policía",
  _OFFICER_DETAILS_: "Detalles del oficial de policía",
  _LIVE_LOCATION_: "Ubicación en vivo",
  _LIVE_LOCATION_TITLE_: "Lista de ubicación en vivo",
  _CREATE_LINK_: "Crear enlace",
  _LIVE_LOCATION_URL_: "URL de ubicación en vivo",
  _CURRENT_GPS_ODOMETER_: "Odómetro GPS actual",
  _CHANGE_ODOMETER_: "Cambiar odómetro",
  _ODOMETER_TRAVELLED_: "Odómetro recorrido",
  _TOTAL_ODOMETER_: "Odómetro total",
  _DIFF_ODOMETER_: "Diferencia de odómetro",
  _ADJUST_ODOMETER_: "Ajustar odómetro",
  _GPS_ODOMETER_: "Odómetro GPS",
  _ODOMETER_ADJUSTMENT_: "Ajuste de odómetro",
  _WASL_DRIVER_LIST_: "Lista de conductores WASL",
  _VIEW_ON_MAP_: "Ver en mapa",
  _POLICE_OFFICERS_LIST_: "Lista de oficiales de policía",
  _POLICE_OFFICER_NAME_: "Nombre del oficial de policía",
  _POLICE_OFFICER_MOBILE_NO_: "Teléfono móvil del oficial de policía",
  _POLICE_OFFICER_USERNAME_: "Usuario del oficial de policía",
  _POLICE_OFFICER_: "Oficial de policía",
  _BLACK_LIST_: "Lista negra",
  _VEHICLE_GROUPS_: "Grupos de vehículos",
  _TOTAL_COUNT_: "Cantidad total",
  _BLOCK_UNBLOCK_: "Bloquear/Desbloquear",
  _GENDER_: "Género",
  _MALE_: "Masculino",
  _FEMALE_: "Femenino",
  _CUSTOMER_DISTRIBUTOR_: "Cliente/Distribuidor",
  _WASL_REGISTRATION_: "Registro WASL",
  _UPLOADING_: "Subiendo...",
  _SELECT_RECORD_: "Por favor seleccione registros",
  _PROCESSING_: "Procesando...",
  _ALERT_BLOCK_UNBLOCK_: "¿Está seguro que desea bloquear/desbloquear?",
  _ALERT_REMOVE_FROM_BLACKLIST_:
    "¿Está seguro que desea eliminar a la persona de la lista negra?",
  _BILL_NO_: "Número de factura",
  _ADD_SERVICE_: "Agregar servicio",
  _ID_: "ID",
  _ITEM_: "Artículo",
  _PRICE_: "Precio",
  _GROSS_PRICE_: "Precio bruto",
  _INCHARGE_NAME_: "Nombre del encargado",
  _WORKING_DAYS_: "Días laborales",
  _CURRENT_SPEED_: "Velocidad actual",
  _FLEET_REPORTS_DRIVERNAME_: "Nombre del conductor",
  _FLEET_REPORTS_AMOUNT_: "Cantidad",
  _LOAD_SENSOR_: "Sensor de carga",
  _MINIMUM_VOLT_: "Voltaje mínimo",
  _MAXIMUM_VOLT_: "Voltaje máximo",
  _HEAD_WEIGHT_: "Peso cabeza",
  _ATTACH_TAILER_: "Adjuntar remolque",
  _TRAILER_ID_: "ID del remolque",
  _TRAILER_TYPE_: "Tipo de remolque",
  _TRAILER_EMPTY_WEIGHT_: "Peso vacío del remolque",
  _ADD_TRAILER_: "Agregar remolque",
  _ADD_TRIP_COST_: "Agregar costo del viaje",
  _TRAILER_LIST_: "Lista de remolques",
  _TAILER_: "Remolque",
  _SEARCH_BY_ZONE: "Buscar por zona",
  _FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT1_:
    "Cinturón de seguridad del conductor",
  _FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT2_:
    "Cinturón de seguridad del pasajero",
  _BLE_: "BLE",
  _analog_: "Analógico",
  _VOLUME_PER_UNIT_: "Volumen por unidad",
  _BLE_TEMP_: "Temperatura BLE",
  _BLE_HUMIDITY_: "Humedad BLE",
  _BLE_TEMP1_: "Temperatura BLE1",
  _BLE_TEMP2_: "Temperatura BLE2",
  _BLE_TEMP3_: "Temperatura BLE3",
  _BLE_TEMP4_: "Temperatura BLE4",
  _MIN_TEMP1_: "Temperatura mínima 1",
  _MIN_TEMP2_: "Temperatura mínima 2",
  _MIN_TEMP3_: "Temperatura mínima 3",
  _MIN_TEMP4_: "Temperatura mínima 4",
  _MAX_TEMP1_: "Temperatura máxima 1",
  _MAX_TEMP2_: "Temperatura máxima 2",
  _MAX_TEMP3_: "Temperatura máxima 3",
  _MAX_TEMP4_: "Temperatura máxima 4",
  _BLE_HUMIDITY1_: "Humedad BLE1",
  _BLE_HUMIDITY2_: "Humedad BLE2",
  _BLE_HUMIDITY3_: "Humedad BLE3",
  _BLE_HUMIDITY4_: "Humedad BLE4",
  _MIN_HUMIDITY1_: "Humedad mínima 1",
  _MIN_HUMIDITY2_: "Humedad mínima 2",
  _MIN_HUMIDITY3_: "Humedad mínima 3",
  _MIN_HUMIDITY4_: "Humedad mínima 4",
  _MAX_HUMIDITY1_: "Humedad máxima 1",
  _MAX_HUMIDITY2_: "Humedad máxima 2",
  _MAX_HUMIDITY3_: "Humedad máxima 3",
  _MAX_HUMIDITY4_: "Humedad máxima 4",
  _FLEET_RULESELECTORDETAIL_BLE_DESCRIPTION_:
    "Esta regla se activará cuando la temperatura/humedad supere el límite definido. El usuario puede establecer la temperatura/humedad mínima y máxima.",
  _BLE_TEMP_HUMIDITY_: "Temperatura/Humedad BLE",
  _IDLE_DURATION_: "Duración inactiva",
  _START_LOAD_VOLTAGE_: "Voltaje de carga inicial",
  _END_LOAD_VOLTAGE_: "Voltaje de carga final",
  _START_LUGGAGE_LOAD_: "Inicio de carga de equipaje",
  _END_LUGGAGE_LOAD_: "Fin de carga de equipaje",
  _START_EMPTY_WEIGHT_: "Peso vacío inicial",
  _END_EMPTY_WEIGHT_: "Peso vacío final",
  _START_TOTAL_WEIGHT_: "Peso total inicial",
  _END_TOTAL_WEIGHT_: "Peso total final",
  _PLAYBACK_: "Reproducción",
  _PLAY_BACK_OPTION_: "Opciones de reproducción",
  _FILE_START_DATE_: "Fecha de inicio del archivo",
  _FILE_START_TIME_: "Hora de inicio del archivo",
  _FILE_END_DATE_: "Fecha de fin del archivo",
  _FILE_END_TIME_: "Hora de fin del archivo",

  _START_TIME_: "Hora de inicio",
  _END_TIME_: "Hora de fin",
  _SOURCE_FILE_START_DATE_: "Fecha de inicio del archivo fuente",
  _SOURCE_FILE_START_TIME_: "Hora de inicio del archivo fuente",
  _SOURCE_FILE_END_DATE_: "Fecha de fin del archivo fuente",
  _SOURCE_FILE_END_TIME_: "Hora de fin del archivo fuente",
  _FILE_TAG_: "Etiqueta de archivo",
  _FILE_PATH_: "Ruta del archivo",
  _FILE_SIZE_: "Tamaño del archivo",
  _RECORD_TYPE_: "Tipo de registro",
  _GENERAL_: "General",
  _ALARM_: "Alarma",
  _DOWNLOAD_TYPE_: "Tipo de descarga",
  _WHOLE_FILE_: "Archivo completo",
  _SEGMENT_: "Segmento",
  _DEVICE_NUMBER_: "Número de dispositivo",
  _INDEX_: "Índice",
  _TIME_: "Hora",
  _TYPE_: "Tipo",
  _FILE_LOCATION_: "Ubicación del archivo",
  _FILE_: "Archivo",
  _FILE_TYPE_: "Tipo de archivo",
  _DATE_: "Fecha",
  _START_: "Inicio",
  _END_: "Fin",
  _MDVR_ALARM_REPORT_: "Informe de alarma MDVR",
  _ALARM_TYPE_: "Tipo de alarma",
  _START_SPEED_: "Velocidad inicial (KM/H)",
  _END_SPEED_: "Velocidad final (KM/H)",
  _HOUR_METER_READING_: "Lectura del cuentahoras",
  _REGULAR_RUNNING_HOUR_: "Horas de funcionamiento regular",
  _MAX_HOUR_PER_DAY_: "Horas máximas por día",
  _GENSET_WORKING_HOUR_REPORT_: "Informe de maquinaria",
  _FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_: "Ubicación",
  _SEND_: "Enviar",
  _HARSH_ACCEL_: "Aceleración brusca",
  _HARSH_BRACKING_: "Frenado brusco",
  _EX_IDELING_: "Ex-Inactividad",
  _DRIVER_BEHAVIOR_SETTINGS_: "Configuración de comportamiento del conductor",
  _SPEEDING_: "Exceso de velocidad",
  _RPM_EXCESS_: "Exceso de RPM",
  _Min_Mileage_: "Kilometraje mínimo (Km)",
  _DISPLAY_ABSOLUTE_VAL_: "Mostrar valor absoluto",
  _TOP_SCORE_: "Puntuación máxima",
  _USER_COSTIMIZED_SCORE_: "Puntuación personalizada por usuario",
  _ASSET_OR_VEHICLES_: "Activo o vehículos",
  _ASSET_DEVICE_MANAGEMENT_: "Asignación de dispositivos de activos",
  _RPM_LIMIT_: "Límite de RPM",
  _MIN_ALLOWED_EVENTS_: "Eventos mínimos permitidos",
  _ABSOLUTE_VAL_: "Valor absoluto",
  _DRIVER_SCORE_REPORT_: "Informe de puntuación del conductor",
  _ACCEL_N_: "Acel.",
  _BRAKE_: "Freno",
  _EXIDLE_: "Ex-Inactividad",
  _SCORE_: "Puntuación",
  _DBRAKE_: "Freno",
  _TOTAL_WEIGHT_: "Peso total",
  _PAGE_: "Página",
  _OF_: "de {0}",
  _DRIVER_SCORE_GRAPH_: "Gráfico de puntuación del conductor",
  _HORIZONTAL_: "Horizontal",
  _VERTICAL_: "Vertical",
  _MAX_SPEED_GRAPH_: "Gráfico de velocidad máxima",
  _RENEW_OPTION_: "Renovar",
  _UPLOAD_: "Subir",
  _SAMPLE_: "MUESTRA",
  _IMPORT_EXPORT_EXCEL_: "Importar desde Excel",
  _FULL_PATH_: "Ruta completa",
  _STRAIGHT_LINE_: "Línea recta",
  _TRIP_: "Viaje",
  _OVERSPEED_: "Exceso de velocidad",
  _ALL_: "Todo",
  _TRAVEL_: "Viajar",
  _FAST_: "Rápido",
  _MEDIUM_: "Medio",
  _SLOWER_: "Más lento",
  _STOPPED_: "Detenido",
  _IDLE_: "Inactivo",
  _HARSH_ACCELERATION_: "Aceleración brusca",
  _HARSH_DEACCELERATION_: "Desaceleración brusca",
  _LOAD_SENSOR_DISCONNECT_ALARM_: "Alarma de desconexión del sensor de carga",
  _POWER_CUT_ALARM_: "Alarma de corte de energía",
  _HIGH_IMPACT_ACCIDENT_: "Alto impacto (Accidente)",
  _LOW_IMPACT_ACCIDENT_: "Bajo impacto (Incidente)",
  _GSM_JAMMING_ALARM_: "Alarma de interferencia GSM",
  _NO_EVENT_: "Sin eventos",
  _STOP_: "Detener",
  _EXIDLE_: "Ex-Inactivo",
  _RUNNING_: "En marcha",
  _NODATA_: "Sin datos",
  _NoData_: "Sin datos",
  _TOTAL_: "Total",
  _EXPIRED_: "Expirado",
  _EXPIRINGSOON_: "Expirando pronto",
  _SELECT_ALL_GROUPS_: "Seleccionar todos los grupos",
  _HISTORY_OF_MULTIPLE_VEHICLES_: "Historial de múltiples vehículos",
  _APPLY_: "Aplicar",
  _CANCEL_: "Cancelar",
  _CUSTOME_RANGE_: "Rango personalizado",
  _SEND_WEB_PUSH_NOTIFICATION_: "Notificación web push",
  _MULTI_VIDEO_MONITORING_: "Monitoreo de múltiples videos",
  _TRACK_BY_GROUP_: "Rastrear por grupo",
  _GROUP_NAME_: "Nombre del grupo",
  _COMPANY_: "Compañía",
  _DRIVER_: "Conductor",
  _IGNITION1_: "Ignición",
  _YES_: "Sí",
  _NO_: "No",
  _MAINTENANCE_DASHBOARD_: "Panel de mantenimiento",
  _Monthly_Expenses_: "Gastos mensuales",
  _Weekly_Expenses_: "Gastos semanales",
  _REMINDERS_: "Recordatorios",
  _Cost_InThousand_: "Costo (en miles)",
  _FLEET_VEHICLE_VEHICLEDETAIL_LASTBATTERY_: "Último cambio de batería",
  _FLEET_VEHICLE_VEHICLEDETAIL_BATTERY_CHANGE_INT_:
    "Intervalo de cambio de batería (días)",
  _ORDER_STATUS_: "Estado",
  _IASTIMARA_RENEWAL_: "Renovación Istimara",
  _INSURANCE_RENEWAL_: "Renovación de seguro",
  _Battery_Next_Change_Date_: "Próxima fecha de cambio de batería",
  _PAYMENT_: "Pago",
  _PAYMENT_AND_ACCESSORIES_: "Pago y accesorios",
  _NEW_EXPIRY_DATE_: "Nueva fecha de expiración",
  _PAYMENT_AMOUNT_: "Monto",
  _PAYMENT_LIST_: "Lista de pagos",
  _PAYMENT_DETAILS_LIST_: "Lista de detalles de pagos",
  _PAYMENT_ID_: "ID de pago",
  _PAYMENT_METHOD_: "Método de pago",
  _TOTAL_VEHICLE_: "Total de vehículos",
  _TOTAL_AMOUNT_: "Monto total",
  _PAYMENT_DATE_: "Fecha de pago",
  _VEHICLE_DETAIL_: "Detalles",
  _NON_STOPPAGE_FOR_: "En movimiento desde (min) sin parada",
  _RENEWAL_PRICE_: "Precio de renovación",
  _WASL_REPORT_: "Informe WASL",
  _TEMPERATURE_: "Temperatura",
  _HUMIDITY_: "Humedad",
  _RFID_CHARGES_: "Cargos RFID",
  _TOTAL_CHARGES_: "Cargos totales",
  _SEARCH_DERIVER_IDENTIFYNUMBER_:
    "Buscar por número de identificación del conductor",
  _COMMERCIAL_RECORD_BUMBER_: "Número de registro comercial",
  _COMMERCIAL_RECORD_ISSUE_DATE1_: "Fecha de emisión del registro comercial",
  _VEHICLE_MODEL_: "Modelo",
  _MANUFACTURER_: "Fabricante",
  _TYPE_OF_VEHICLE_: "Tipo de vehículo",
  _FUEL_TYPE_: "Tipo de combustible",
  _COMMENTS_: "Comentarios",
  _SELECT_ACTIVITY_: "Seleccionar actividad",
  _REGISTRATION_DATE_: "Fecha de registro",

  _WEIGHT_REPORT_: "Informe de peso",
  _BLE1CUSTOM2_: "BLE1 Personalizado2",
  _BLE1CUSTOM3_: "BLE1 Personalizado3",
  _BLE1CUSTOM4_: "BLE1 Personalizado4",
  _BLE1CUSTOM5_: "BLE1 Personalizado5",
  _BLE2CUSTOM2_: "BLE2 Personalizado2",
  _BLE2CUSTOM3_: "BLE2 Personalizado3",
  _BLE2CUSTOM4_: "BLE2 Personalizado4",
  _BLE2CUSTOM5_: "BLE2 Personalizado5",
  _BLE3CUSTOM2_: "BLE3 Personalizado2",
  _BLE3CUSTOM3_: "BLE3 Personalizado3",
  _BLE3CUSTOM4_: "BLE3 Personalizado4",
  _BLE3CUSTOM5_: "BLE3 Personalizado5",
  _BLE4CUSTOM2_: "BLE4 Personalizado2",
  _BLE4CUSTOM3_: "BLE4 Personalizado3",
  _BLE4CUSTOM4_: "BLE4 Personalizado4",
  _BLE4CUSTOM5_: "BLE4 Personalizado5",
  _WAREHOUSE_LIST_: "Lista de almacenes",
  _ADD_WAREHOUSE_: "Agregar almacén",
  _NAME_WAREHOUSE_: "Nombre del almacén",
  _ADDRESS_OF_WAREHOUSE_: "Dirección del almacén",
  _LAND_CORDINATES_: "Coordenadas del terreno",
  _LAND_CORDINATE_NAME_: "ej. lat1:long1,lat2:long2,lat3:long3,lat4:long4",
  _LICENSE_ISSUE_DATE_: "Fecha de emisión de la licencia",
  _LICENSE_EXPIRY_DATE_: "Fecha de expiración de la licencia",
  _PHONE_: "Teléfono",
  _WAREHOUSE_LAND_AREA_: "Área del terreno (m²)",
  _WAREHOUSE_EMAIL_: "Correo del gerente",
  _INVENTORY_: "Inventario",
  _INVENTORY_LIST_: "Lista de inventario",
  _ADD_INVENTORY_: "Agregar inventario",
  _INVENTORY_NAME_: "Nombre del inventario",
  _INVENTORY_NUMBER_: "Número de inventario",
  _STORING_CATEGORY_: "Categoría de almacenamiento",
  _STORING_TYPE_: "Tipo de almacenamiento",
  _FLEET_GROUP_GROUPDETAIL_WAREHOUSE_SETLOAD_: "Guardando datos del almacén",
  _NAME_GRID_OF_WAREHOUSE_: "Almacén",
  _CITY_OF_WAREHOUSE_: "Ciudad",
  _LICENSE_GRID_NUMBER_: "Número de licencia",
  _LICENSE_GRID_ISSUE_DATE_: "Fecha de emisión",
  _LICENSE_GRID_EXPIRY_DATE_: "Fecha de expiración",
  _PLOT_DEFAULT_: "Parcela predeterminada",
  _CLUSTER_: "Cluster",
  _MANAGER_GRID_MOBILE_: "Móvil del gerente",
  _EMAIL_GRID_: "Correo del gerente",
  _WAREHOUSE_GRID_LAND_AREA_: "Área del terreno",
  _WAREHOUSE_WASL_REPLY_: "Respuesta WASL",
  _REGISTER_IN_WASL_: "Registrar en WASL",
  _WAREHOUSE_WASL_RESPONSE_: "Respuesta WASL",
  _SAVE_INVENTORY_DATA_: "Guardar datos de inventario",
  _SFDA_COMPANY_ACTIVITY_: "Actividad de la empresa SFDA",
  _SENSOR_REPORT_: "Informe de sensores del gateway",
  _TIMESTAMP_: "Marca de tiempo",
  _ALARMTYPE_: "Tipo de alarma",
  _BATTORY_VOLTAGE_: "Voltaje de batería",
  _POWER_VOLTAGE_: "Voltaje de energía",
  _SENSOR_TYPE_: "Tipo de sensor",
  _SENSOR_COUNT_: "Cantidad de sensores",
  _SENSOR_ID_: "ID del sensor",
  _SENSORID_: "ID del sensor",
  _BATTORY_VOLTAGE_STATUS_: "Estado del voltaje de batería",
  _SENSOR_BATTORY_VOLTAGE_: "Voltaje de batería del sensor",
  _TEMPRATURE_ALERT_STATUS_: "Estado de alerta de temperatura",
  _SENSORE_TEMPERATURE_: "Temperatura del sensor",
  _SENSOR_BUTTON_STATUS_: "Estado del botón del sensor",
  _SENSOR_STATUS_: "Estado del sensor",
  _HUMIDITY_: "Humedad",
  _RSSI_: "RSSI",
  _SENSOR_TIME_: "Hora del sensor",
  _LUBE_OIL_VOLUME_: "Volumen de aceite lubricante",
  _LUBE_OIL1_PERCENT_: "Nivel de aceite lubricante %",
  _LUBE_OIL_: "Aceite lubricante",
  _FUEL_CALIBRATION_NAME_: "Nombre de calibración de combustible",
  _FUEL_TANK_CAPACITY_: "Capacidad del tanque de combustible",
  _TANK_L_IN_CM_: "Tanque (L) en cm",
  _TANK_W_IN_CM_: "Tanque (W) en cm",
  _TANK_HEIGHT_IN_CM_: "Altura del tanque en cm",
  _TANK1_l_IN_CM_: "Tanque1 (L) en cm",
  _TANK1_D_IN_CM_: "Tanque1 (D) en cm",
  _MAX_VOLTAGE_: "Voltaje máximo",
  _MIN_VOLTAGE_: "Voltaje mínimo",
  _INVENTORY_STATUS_REPORT_: "Informe de estado de inventario",
  _FLEET_REPORTS_VEHICLENO_: "Nombre del activo",
  _INVENTORY_WASL_KEY_: "Clave WASL del inventario",
  _WASREHOUSE_WASL_KEY_: "Clave WASL del almacén",
  _TEMP_: "Temperatura",
  _TEMP_PDF_: "PDF de temperatura",
  _INVENTORIES_: "Inventarios",
  _WAREHOUSE_MONITORING_: "Monitoreo de almacén",
  _WAREHOUSE_NAME_: "Nombre del almacén",
  _WAREHOUSE_LICENSE_: "Licencia No",
  _REMINDER_: "Recordatorio",
  _UPDATE_IMEI_: "Actualizar IMEI",
  _REGION_: "Región",
  _BRANCH_: "Sucursal",
  _DEPARTMENT_: "Departamento",
  _YEAR_: "Año",
  _OWNERSHIP_: "Propiedad",
  _FLEET_VEHICLENAME_: "Nombre del vehículo",
  _INSTALLATION_TYPE_: "Tipo de instalación",
  _STOP_LOCATION_: "Ubicación de parada",
  _DEVICE_TESTING_: "Prueba del dispositivo",
  _ENTER_IMEI_: "Ingresar IMEI",
  _ACCIDENT_ALERT_: "Alerta de accidente",
  _TOWING_ALERT_: "Alerta de remolque",
  _STAY_ALERT_: "Alerta de permanencia",
  _PARKING_ALERT_: "Alerta de estacionamiento",
  _VEHICLE_HARSH_CONNECTING_: "Curvas bruscas del vehículo",
  _VEHICLE_HARSH_BRACKING_: "Frenado brusco del vehículo",
  _ROAD_OVERSPEED_: "Exceso de velocidad en carretera",
  _PAYMENT_: "Pago",
  _TESTING_POWER_CONNECTION_: "Prueba de conexión de energía",
  _TESTING_ACC_: "Prueba ACC",
  _TESTING_GPS_: "Prueba GPS",
  _LAST_KNOWN_DISTANCE_: "Última distancia conocida",
  _LAST_KNOWN_BLE_HUMIDITY_: "Última humedad BLE conocida",
  _LAST_KNOW_BLE_TEMPERATURE_: "Última temperatura BLE conocida",
  _TESTING_VOLTAGE_: "Prueba de voltaje",
  _TESTING_WEIGHT_: "Prueba de peso",
  _DEVICE_TESTING_: "Prueba del dispositivo",
  _POWER_CONNECTED_: "Energía conectada",
  _LATTITUDE_AND_LONGITUDE_: "Latitud y longitud",
  _FILTER_BY_: "Filtrar por",
  _REPORT_FORMAT_: "Formato de informe",
  _ASSIGN_ALL_VEHICLES_: "Asignar todos los vehículos",
  _WASL_STATION_: "Estación WASL",
  _STATION_LIST_: "Lista de estaciones",
  _STATION_CODE_: "Código de estación",
  _ARABIC_NAME_: "Nombre árabe",
  _ENGLISH_NAME_: "Nombre inglés",
  _CITY_CODE_: "Código de ciudad",
  _INSIDE_CITY_: "Dentro de la ciudad",
  _BETWEEN_CITIES_: "Entre ciudades",
  _BETWN_CITIES_: "Entre ciudades",
  _STATIONS_TATUS_: "Estado de la estación",
  _PHONE_EXTENSION_: "Extensión telefónica",
  _STATION_REGISTRATION_: "Registro de estación",
  _WASL_TRIP_: "Viaje WASL",
  _WASL_TRIP_LIST_: "Lista de viajes WASL",
  _PRIMARY_DRIVER_: "Conductor principal",
  _ASSISTANT_DRIVER_: "Conductor asistente",
  _WASL_TRIP_REGISTRATION_: "Registro de viaje WASL",
  _WASL_TRIP_TYPE_: "Tipo de viaje",
  _WASL_TRIP_DEPARTURE_STATION_CODE_: "Código de estación de salida",
  _WASL_TRIP_ARRIVAL_STATION_CODE_: "Código de estación de llegada",
  _WASL_TRIP_ARRIVAL_TIME: "Hora estimada de llegada",
  _WASL_TRIP_DEPARTURE_TIME: "Hora estimada de salida",
  _INVOICE_NUM_: "Número de factura",
  _FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL4_: "Entrada digital 4",
  _PASSENGER_OUT_: "Pasajero fuera",
  _PASSENGE_IN_: "Pasajero dentro",
  _WASL_TRIP_STATION_CODE_: "Código de estación",
  _UPDATE_WASL_TRIP_: "Actualizar viaje WASL",
  _PRIMARY_DRIVER_IDENTITY_: "Identidad del conductor principal",
  _ASSISTANT_DRIVER_IDENTITY_: "Identidad del conductor asistente",
  _TRIP_NUMBER_: "Número de viaje",
  _DISTANCE_IN_METERS_: "Distancia en metros",
  _NO_OF_PASSENGER: "Número de pasajeros",
  _NO_OF_PASSENGERS_: "Número de pasajeros",
  _WASL_BUS_REPORT_: "Informe de viaje en autobús WASL",
  _WASL_BUS_TRIP_REPORT_: "Informe de viaje en autobús WASL",
  _TRIP_STATUS_: "Estado del viaje",
  _GEOFENCE_VISIT_: "Informe de visita a geocerca",
  _GEOFENCE_VISIT_REPORT_: "Informe de visita a geocerca",
  _GEOFENCEVISIT_: "Visita a geocerca",
  _LATITUDE_: "Latitud",
  _LOGITUDE_: "Longitud",
  _LOCATION_: "Ubicación",
  _DRIVERID_: "Conductor",
  _BREAKE_SWITCH_: "Interruptor de freno",
  _WHEEL_BASE_SPEED_: "Velocidad basada en ruedas",
  _CRUISE_CONTROL_ACTIVE_: "Control de crucero activo",
  _CLUTCH_SWITCH_: "Interruptor de embrague",
  _PTO_STATE_: "Estado PTO",
  _ACCELERATION_PEDAL_POSITION_: "Posición del pedal de aceleración",
  _ENGINEE_CURRENT_LOAD_: "Carga actual del motor",
  _ENGINE_TOTAOL_FUEL_USE_: "Combustible total usado por el motor",
  _FUEL_LEVEL_: "Nivel de combustible",
  _ENGINE_SPEED_: "Velocidad del motor",
  _AXEL_WIDTH1_: "Peso eje 1",
  _AXEL_WIDTH2_: "Peso eje 2",
  _AXEL_WIDTH3_: "Peso eje 3",
  _AXEL_WIDTH4_: "Peso eje 4",
  _AXEL_WIDTH5_: "Peso eje 5",
  _AXEL_WIDTH6_: "Peso eje 6",
  _AXEL_WIDTH7_: "Peso eje 7",
  _AXEL_WIDTH8_: "Peso eje 8",
  _AXEL_WIDTH9_: "Peso eje 9",
  _AXEL_WIDTH10_: "Peso eje 10",
  _AXEL_WIDTH11_: "Peso eje 11",
  _AXEL_WIDTH12_: "Peso eje 12",
  _AXEL_WIDTH13_: "Peso eje 13",
  _AXEL_WIDTH14_: "Peso eje 14",
  _AXEL_WIDTH15_: "Peso eje 15",
  _ENGINE_TOTAL_HOURSE_OF_OPERATION_: "Horas totales de operación del motor",
  _SOPTWARE_VERSION_SUPPORTED_: "Versión de software compatible",
  _DIGNOSTIC_SUPPORTED_: "Diagnóstico compatible",
  _REQEST_SUPPORTED_: "Solicitudes compatibles",
  _SERVICE_DISTANCE_: "Distancia de servicio",
  _DIRECTION_INDICATION_: "Indicación de dirección",
  _TACHOGRAPH_PERFORMANCE_: "Rendimiento del tacógrafo",
  _HANDLING_INFO_: "Información de manejo",
  _SYSTEM_EVENT_: "Evento del sistema",
  _ENGINE_COOLENT_TEMETATURE_: "Temperatura del refrigerante del motor",
  _AMBIENT_AIR_TEMPERATURE_: "Temperatura ambiente",
  _FUEL_RATE_: "Consumo de combustible 2",
  _INSTANTANIOUSE_FUEL_ECONOMY_: "Economía de combustible instantánea",
  _PTO_DRIVE_ENGAGEMENT_: "Engranaje PTO activado",
  _HIGH_RESOLUTION_ENGINE_TOTAL_FUEL_USED_:
    "Combustible total usado por el motor (alta resolución)",
  _GROSS_COMBINATION_VEHICLE_WEIGHT_: "Peso bruto combinado del vehículo",
  _ADBLUE_STATUS_: "Estado AdBlue",
  _BREAKE_PEDAL_POSITION_: "Posición del pedal de freno",
  _FUEL_LEVEL2_: "Nivel de combustible 2",
  _MIL_INDICATOR_: "Indicador MIL",
  _TELL_TALE0_: "Indicador 0",
  _TELL_TALE1_: "Indicador 1",
  _TELL_TALE2_: "Indicador 2",
  _TELL_TALE3_: "Indicador 3",
  _ADBLUE_LEVEL1_: "Nivel de AdBlue",
  _USER_ACTIVITY_REPORT_: "Informe de actividad del usuario",
  _REGISTERED_AT_: "Registrado en",
  _REGISTERED_BY_: "Registrado por",
  _REGISTERED_BY_IP: "Registrado por IP",
  _UPDATED_AT_: "Actualizado en",
  _UPDATED_BY_: "Actualizado por",
  _UPDATED_BY_IP: "Actualizado por IP",
  _DELETED_AT_: "Eliminado en",
  _DELETED_BY_: "Eliminado por",
  _DELETED_BY_IP_: "Eliminado por IP",
  _SELECT_ADMIN_USER_: "Seleccionar distribuidor",
  _YEARLY_: "Anual",
  _MONTHLY_: "Mensual",
  _QUARTERLY_: "Trimestral",
  _STUDENT_: "Estudiante",
  _EMPLOYEE_: "Empleado",
  _EMPLOYEE_LIST_: "Lista de empleados",
  _EMPLOYEE_DETAILS_: "Detalles del empleado",
  _CREATE_DATE: "Fecha de creación",
  _TYRE_CHANGE_REMINDER_: "Recordatorio de cambio de neumático",
  _SERVICE_REMINDER_: "Recordatorio de servicio",
  _INSURANCE_REMINDER_: "Recordatorio de seguro",
  _UPCOMING_: "Próximo",
  _DUE_: "Pendiente",
  _OVERDUE_: "Vencido",
  _OIL_CHANGE_REMINDER_: "Recordatorio de cambio de aceite",
  _BATTERY_CHANGE_REMINDER_: "Recordatorio de cambio de batería",
  _SERVICE_: "Servicio",
  _TYRE_CHANGE_: "Cambio de neumático",
  _OIL_CHANGE_: "Cambio de aceite",
  _ISTIMARA_REMINDER_: "Recordatorio Istimara",
  _INSURANCE_: "Seguro",
  _ISTIMARA_: "Istimara",
  _VEHICLEID_: "ID del vehículo",
  _TOTAL_RUNNING_HOURS_: "Horas totales de funcionamiento",
  _EXCESS_RUNNING_HOURS_: "Horas de funcionamiento excesivas",
  _STOP_SINCE_: "Detenido desde",
  _STATIONARY_REPORT_HOURS_: "Horas",
  _EQUIPMENT_NAME_: "Nombre del equipo",
  _BRAND_: "Marca",
  _FUEL_CALIBRATION_: "Calibración de combustible",
  _ADD_RECORD_: "Agregar registro",
  _TOLERANCE_: "Tolerancia (mt)",
  _ADD_JOB_DETAILS: "Agregar detalles del trabajo",
  _SELECT_FROM_MAP: "Seleccionar del mapa",
  _MAP_SETTING_: "Configuración del mapa",
  _OFFLINE_ALERT_: "Alertas fuera de línea",
  _DRIVER_BEHAVIOR_LIST_: "Lista de comportamiento del conductor",
  _STOP_: "Detener",
  _TODAY_ACTIVITY_: "Actividad de hoy",
  _FACEBOOK_: "Facebook",
  _INSTAGRAM_: "Instagram",
  _LINKEDIN_: "LinkedIn",
  _TWITTER_: "Twitter",
  _SKYPE_: "Skype",
  _WHATSAPP_: "WhatsApp",
  _LINK_TO_SHARE_: "Enlace para compartir",
  _COPY_LINK_: "COPIAR ENLACE",
  _PHONE_NUMBER_1_: "Número de contacto principal",
  _EMAIL_2_: "Correo secundario",
  _EMAIL_1_: "Correo principal",
  _PHONE_NUMBER_2_: "Número de contacto secundario",
  _HALF_YEARLY_: "Semestral",
  _NO_ROLE_: "Sin rol",
  _DEFAULT_ROLE_: "Rol predeterminado",
  _BASIC_: "Básico",
  _INDIVIDUAL_: "Individual",
  _DEFAULT_: "Predeterminado",
  _TOW_CAR_: "Remolque de auto",
  _SPECIALITY_TRANSPORT_: "Transporte especializado",
  _BUS_RENTAL_: "Alquiler de autobús",
  _EDUCATIONAL_TRANSPORT_: "Transporte educativo",
  _SFDA_: "SFDA",
  _PTA_: "PTA",
  _PERMANENT_: "Permanente",
  _TEMPORARY_: "Temporal",
  _SELECT_COUNTRY_: "Seleccionar país",
  _CLICK_TO_UPLOAD_PHOTO_ID: "Haga clic para cargar identificación",
  _SELECT_EMPLOYEE_TYPE: "Seleccionar tipo de empleado",
  _SELECT_DOB_FORMAT_: "Seleccionar formato de fecha de nacimiento",
  _EDIT_ACCOUNT_DETAILS_: "Editar detalles de la cuenta",
  _DELETE_ACCOUNT_: "Eliminar cuenta",
  _WASL_STATUS_: "Estado WASL",
  _ASSIGN_: "Asignar",
  _EDIT_STAFF_DETAILS_: "Editar detalles del personal",
  _DELETE_STAFF_DETAILS_: "Eliminar detalles del personal",
  _DELETE_EMPLOYEE_: "Eliminar empleado",
  _EDIT_PASSENGER_DETAILS_: "Editar detalles del pasajero",
  _DELETE_PASSENGER_: "Eliminar pasajero",
  _SEARCH_BY_NAME_MOBILE_EMAIL_: "Buscar por nombre, número móvil, correo",
  _SEARCH_BY_DRIVER_NAME_MOBILE_: "Buscar por conductor, móvil",
  _SEARCH_BY_NAME_MOBILE_TAGID_BUSNO_:
    "Buscar por nombre, móvil, ID de etiqueta, número de bus",
  _SEARCH_BY_VEHICLE_NO_DRIVER_NAME_: "Buscar por vehículo, conductor",
  _SEARCH_BY_DRIVER_VEHICLE_: "Buscar por conductor, vehículo",
  _PROJECT_: "Proyecto",
  _CLICK_TO_UPLOAD_: "Haga clic para cargar",
  _SELECT_PROJECT_: "Seleccionar proyecto",
  _ADD_PROJECT_: "Agregar proyecto",
  _PROJECT_DETAILS_: "Detalles del proyecto",
  _RETURNED_FROM_: "Devuelto desde",
  _EDIT_RETURN_ASSET_: "Editar activo devuelto",
  _EDIT_MAINTENANCE_: "Editar mantenimiento",
  _DELETE_MAINTENANCE_: "Eliminar mantenimiento",
  _OPERATION_: "Operación",
  _Id_: "ID",
  _SEARCH_BY_GARAGE_SERVICE_VEHICLE_:
    "Buscar por taller, fecha de servicio, vehículo",
  _SEARCH_BY_GARAGE_VEHICLE_: "Buscar por taller, vehículo",
  _ASSIGNED_TO_: "Asignado a",
  _SHIFT_NAME_: "Nombre del turno",
  _ASSIGN_TO_: "Asignar a",
  _ASSIGN_BUS_TO_STUDENT_: "Asignar bus a estudiante",
  _EDIT_DETAILS_: "Editar detalles",
  _PLEASE_CREATE_LINK_: "Por favor, crear enlace",
  _SCHOOL_BUS_: "Autobús escolar",
  _PICKUP_: "Recoger",
  _PICKuP_: "Recoger",
  _2TON_PICKUP_: "PickUp 2 toneladas",
  _3TON_PICKUP_: "PickUp 3 toneladas",
  _5TON_PICKUP_: "PickUp 5 toneladas",
  _10TON_PICKUP_: "PickUp 10 toneladas",
  _CRANE_: "Grúa",
  _JCB_: "JCB",
  _VAN_: "Furgoneta",
  _HIACE_: "Hiace",
  _URVAN_: "Urvan",
  _TANKER_: "Camión cisterna",
  _BULLDOZER_: "Bulldozer",
  _DUMPER_: "Volquete",
  _REEFER_: "Refrigerado",
  _SHOVEL_: "Pala",
  _EXCAVATOR_: "Excavadora",
  _FORKLIF_: "Montacargas",
  _BOBCAT_: "Bobcat",
  _ROLLER_: "Rodillo",
  _CANTER_: "Canter",
  _MINIBUS_: "Minibús",
  _TOURIST_BUS_: "Autobús turístico",
  _BOOM_LOADER_: "Cargador articulado",
  _GENERATOR_: "Generador",
  _HILUX_: "Hilux",
  _MOTORCYCLE_: "Motocicleta",
  _6_MONTHS_: "6 Meses",
  __PRIVATE_CAR_: "Coche privado",
  _PUBLIC_TRANSPORT_: "Transporte público",
  _PRIVATE_TRANSPORT_: "Transporte privado",
  _PUBLIC_MINIBUS_: "Minibús público",
  _PRIVATE_MINIBUS_: "Minibús privado",
  _TAXI_: "Taxi",
  _HEAVY_EQUIPMENT_: "Equipo pesado",
  _DIPLOMATIC_: "Diplomático",
  _VEHICLE_INFO_: "Información del vehículo",
  _FUEL_ID_1_: "ID de combustible 1",
  _FUEL_ID_2_: "ID de combustible 2",
  _TEMP_ID1_: "ID temporal 1",
  _TEMP_ID2_: "ID temporal 2",
  _TEMP_ID3_: "ID temporal 3",
  _TANK_DETAILS_: "Detalles del tanque",
  _TANK2_L_IN_CM_: "Tanque2(L) en cm",
  _TANK2_W_IN_CM_: "Tanque2(W) en cm",
  _TANK2_H_IN_CM_: "Tanque2(H) en cm",
  _TANK2_D_IN_CM_: "Tanque2(D) en cm",
  _F_ID_2_: "ID de combustible 2",
  _SPACE_2_CM_: "Espacio 2 (cm)",
  _TANK3_IN_CM_: "Tanque3(L) en cm",
  _TANK3_W_IN_CM_: "Tanque3(W) en cm",
  _TANK3_H_IN_CM_: "Tanque3(H) en cm",
  _TANK3_D_IN_CM_: "Tanque3(D) en cm",
  _F_ID_3_: "ID de combustible 3",
  _SPACE_3_CM_: "Espacio 3 (cm)",
  _ADD_NEW_VEHICLE_: "Agregar nuevo vehículo",
  _COLUMNS_: "Columnas",
  _SELECT_COLUMNS_: "Seleccionar columnas",
  _SELECT_STATION_CODE_: "Seleccionar código de estación",
  _DISTANCE_IN_METERS_: "Distancia en metros",
  _PLATE_NO_SEQUENCENO_: "Número de placa, Número de secuencia",
  _SEARCH_BY_BRAND_DRIVERNAME_SIMNO_IMEI_ASSET_:
    "Buscar por marca, nombre del conductor, SIM, IMEI, activo, chasis",
  _INSTALLED_: "Instalado",
  _UNINSTALLED_: "Desinstalado",
  _DELETED_: "Eliminado",
  _SELECT_TANK_SHAPE_: "Seleccionar forma del tanque",
  _SPACE_1_CM_: "Espacio 1 (cm)",
  _SELECT_TANK2_SHAPE_: "Seleccionar forma del tanque2",
  _SELECT_TANK3_SHAPE_: "Seleccionar forma del tanque3",
  _SELECT_CLASS_: "Seleccionar clase",
  _SEARCH_BY_STUDENT_PARENT_MOBILE_EMAIL_:
    "Buscar por estudiante, padre, móvil, correo",
  _SEARCH_MAP_: "Buscar en el mapa",
  _DOYOU_WANT_TO_REGISTER_: "¿Desea registrar",
  _IN_WASL_: "en WASL?",
  _VENDOR_CODE_: "Código del proveedor",
  _STATE_: "Estado",
  _ENTER_ACADEMIC_YEAR_FROM_: "Ingrese año académico desde",
  _FLEET_STATUS_: "Estado de la flota",
  _IN_ACTIVE_: "Inactivo",
  _OVERSPEED_: "Exceso de velocidad",
  _OUTSIDE_GEOFENCE_: "Fuera de geocerca",
  _CONNECTED_: "Conectado",
  _DISCONNECTED_: "Desconectado",
  _ALERTS_TRIGGERED_: "Alertas activadas",
  _HARSH_BREAKING_: "Frenado brusco",
  _HARSH_TURNING_: "Giro brusco",
  _FLEET_IDLE_: "Flota inactiva",
  _TOTAL_FLEET_IDLE_HOUR_: "Horas totales de flota inactiva",
  _APPROX_FUEL_WASTE_LTR_: "Combustible aproximado desperdiciado (L)",
  _LITRES_: "Litros",
  _NOTE_: "Nota",
  _FLEET_IDLE_NOTE_MSG_:
    "Generalmente, un auto en ralentí consume entre 1.89 a 2.74 litros de combustible por hora",
  _JOB_INFO_: "Información del trabajo",
  _ON_GOING_: "En curso",
  _CANCELLED_: "Cancelado",
  _TOTAL_FLEET_USAGE_: "Uso total de la flota",
  _AVG_DIST_VEH_: "Distancia promedio / vehículo",
  _DAY_HRS_: "Horas diurnas",
  _NIGHT_HRS_: "Horas nocturnas",
  _RENEWAL_: "Renovación",
  _DISTANCE_CLASSIFICATION_: "Clasificación de distancia",
  _ONDUTY_KM_TIME_: "Km y tiempo en servicio",
  _OFFDUTY_KM_TIME_: "Km y tiempo fuera de servicio",
  _TOTAL_DISTANCE_COVERED_: "Distancia total cubierta",
  _VEHICLE_SCORE_: "Puntuación del vehículo",
  _VEHSCORE_AC_COUNT_: "Cuenta de aire acondicionado",
  _VEHSCORE_BREAK_COUNT_: "Cuenta de frenos",
  _VEHSCORE_EXIDLE_COUNT_: "Cuenta de ex-idle",
  _VEHSCORE_RPM_COUNT_: "Cuenta de RPM",
  _VEHSCORE_SPEED_COUNT_: "Cuenta de velocidad",
  _DELETE_TRIP_DETAILS_: "Eliminar detalles del viaje",
  _ROUT_DEVIATION_ALERT_: "Alerta de desviación de ruta",
  _PLEASE_SELECT_ACCOUNT_: "Seleccione una cuenta",
  _SEARCH_ON_MAP_: "Buscar en el mapa",
  _HISTORY_: "Historial",
  _START_POINT_: "Punto de inicio",
  _END_POINT_: "Punto final",
  _DEVICE_LOG_LIST_: "Lista de registro de dispositivos",
  _ModBus_: "ModBus",
  _NORMAL_: "Normal",
  _EDIT_DEVICE_RECORD_: "Editar registro de dispositivo",
  _DELETE_DEVICE_RECORD_: "Eliminar registro de dispositivo",
  _PLEASE_SELECT_VEHICLE_: "Seleccione vehículos",
  _PLEASE_SELECT_REPORT_: "Seleccione informe",
  _SAMPLE_: "Muestra",
  _NEW_GEOFENCE_: "Nueva geocerca",
  _RETAILS_: "Minoristas",
  _FOOD_SERVICE_: "Servicio de comida",
  _HEAD_OFFICE_: "Oficina central",
  _GARAGE_: "Taller",
  _OUTLET_: "Sucursal",
  _WE_NEED_TO_DRAW_GEOFENCE_:
    "Necesitamos dibujar la geocerca para la dirección",
  _DISTANCE_BETWEEN_THEM_: "Distancia entre ellos",
  _PLEASE_CLICK_MAP_TO_SELECT_LOCATIONS_:
    "Haga clic en el mapa para seleccionar ubicaciones",
  _VEHICLE_OR_DRIVER_: "Vehículo o conductor",
  _ALL_DATA_: "Todos los datos",
  _TEMP_ID_: "ID temporal",
  _MOVING_: "En movimiento",
  _MANUFACTURING_YEAR_: "Año de fabricación",
  _NO_OF_PASSENGER_: "Número de pasajeros",
  _IDLE_RPM_: "RPM en ralentí",
  _STOPPED_RPM_: "RPM detenido",
  _MOVING_RPM_: "RPM en movimiento",
  _ADDRESS_GRID_OF_WAREHOUSE_: "Dirección de almacén",
  _HUMIDITY_: "Humedad",
  _INPUT_2_: "Entrada 2",
  _SEND_EMAIL_: "Enviar correo",
  _ALL_EVENTS_: "Todos los eventos",
  _ACCIDENT_: "Accidente",
  _DROP_: "Descarga",
  _WASL_COMPANY_: "Compañía WASL",
  _WASL_VEHICLE_: "Vehículo WASL",
  _WASL_DRIVER_: "Conductor WASL",
  _ELAPSED_TIME_: "Tiempo transcurrido",
  _GEOFENCE_DETAILS_: "Detalles de la geocerca",
  _TOTAL_EXCEL_: "Total Excel",
  _TOTAL_PDF_: "Total PDF",
  _ROLE_SETTING_: "Configuración de rol",
  _DELETE_SETTING_: "Eliminar configuración",
  _EDIT_SETTING_: "Editar configuración",
  _EDIT_BEHAVIOUR_SETTING_: "Editar configuración de comportamiento",
  _DELETE_BEHAVIOUR_SETTING_: "Eliminar configuración de comportamiento",
  _ON_: "Encendido",
  _OFF_: "Apagado",
  _DAYS_: "Días",
  _STOPPAGE_: "Parada",
  _SEATBELT_VIOLATION_: "Violación del cinturón de seguridad",
  _BASE_LOCATION_: "Ubicación base",
  _DRIVER_MOBILE_NO_: "Móvil del conductor",
  _EX_IDLE_COUNT_: "Conteo de ex-idle",
  _SEARCH_VEHICLE_DRIVER_: "Buscar por vehículo, conductor",
  _MULKIYA_RENEWAL_: "Renovación de Mulkiya",
  _EXCESSIVE_IDLE_: "Ralentí excesivo",
  _VEHICLE_HARSH_ACCEL_: "Aceleración brusca del vehículo",
  _NON_STOPPAGE_: "Sin paradas",
  _GPS_BATTERY_DISCONNECTION_: "Desconexión de batería GPS",
  _GPS_BATTERY_DISCONNECTION_DESC_:
    "Esta alerta se activa cuando la batería interna del GPS está a punto de agotarse",
  _UNAUTHO_DRIVING_: "Conducción no autorizada",
  _NON_STOPPAGE_MIN: "Minutos sin parada",
  _COMPANY_LIST_: "Lista de compañías",
  _PASSENGER_LIST_: "Lista de pasajeros",
  _SCHOOL_CALENDER_LIST_: "Lista del calendario escolar",
  _PARENT_LIST_: "Lista de padres",
  _TRIP_MANAGEMENT_: "Gestión de viajes",
  _ADVANCE_DASHBOARD_: "Panel avanzado",
  _ASSET_REGISTER_REPORT_: "Informe de registro de activos",
  _DRIVER_LOGIN_REPORT_LIST_:
    "Lista de informes de inicio de sesión de conductor",
  _SIM_LIST_: "Lista de SIM",
  _ALERT_LIST_: "Lista de alertas",
  _ALERT_MSG_DISPLAY_8_VEHICLES_AT_TIME_:
    "Solo se pueden mostrar 8 vehículos a la vez",
  _DRIVER_NOT_AVAILABLE_: "Conductor no disponible",
  _PLEASE_ENTER_COMPANY_NAME_: "Ingrese el nombre de la compañía",
  _PLEASE_SELECT_VEHICLE_: "Seleccione el vehículo",
  _PLEASE_SEARCH_BY_OPTION_: "Seleccione la opción de búsqueda",
  _PLEASE_SELECT_GEOFENCE_: "Seleccione geocerca",
  _PLEASE_ENTER_LOCATION_: "Ingrese ubicación",
  _PLEASE_CLICK_ON_MAP_: "Haga clic en el mapa",
  _PLEASE_ADD_DISTANCE_: "Agregue distancia",
  _DISCARD_: "Descartar",
  _JOB_MANAGEMENT_LIST_: "Lista de gestión de trabajos",
  _GRADE_BUS_TIMING_LIST_: "Lista de horarios de autobús por grado",
  _SELECT_TIME_: "Seleccionar hora",
  _OPENSTREET_: "Openstreet",
  _MIN_TEMP_: "Temp mínima",
  _ACCELERATION_FOR_: "Aceleración para",
  _BRAKING_FOR_: "Frenado para",
  _SPEEDING_FOR_: "Exceso de velocidad para",
  _RPM_FOR_: "RPM para",
  _ACCELERATION_RATE_: "Tasa de aceleración",
  _BRAKE_RATE_: "Tasa de frenado",
  _IDLE_RATE_: "Tasa de ralentí",
  _RPM_RATE_: "Tasa de RPM",
  _SPEED_RATE_: "Tasa de velocidad",
  _EX_IDLING_FOR_: "Ex-idle para",
  _TOTAL_NO_VEHICLE_: "Número total de vehículos",
  _EXIDLE_GRAPH_: "Gráfico de ex-idle",
  _TYRE_CHANGE_REAMINDER_: "Recordatorio de cambio de neumático",
  _HELP_: "Ayuda",
  _VEHICLE_LIST_: "Lista de vehículos",
  _VEHICLE_GRP_LIST_: "Lista de grupos de vehículos",
  _VEHICLE_LIVE_LOCATION_LIST_: "Lista de ubicación en vivo de vehículos",
  _VEHICLE_ODOMETER_LIST_: "Lista de odómetros de vehículos",
  _VEHICLE_FUEL_CALIBERATION_LIST_:
    "Lista de calibración de combustible de vehículos",
  _EXIDLE_REPORT_: "Informe EX-IDLE",
  _DRIVER_RELATED_: "Relacionado con conductor",
  _DRIVER_LOGIN_REPORT_LIST_:
    "Lista de informes de inicio de sesión de conductor",
  _DRIVER_PERFORMANCE_REPORT_LST_:
    "Lista de informes de desempeño del conductor",
  _DRIVER_COMPLAIN_REPORT_LIST_: "Lista de informes de quejas del conductor",
  _ASSIGN_DRIVER_: "Asignar conductor",
  _ASSIGN_ASSET_: "Asignar activo",
  _VEHICLE_DISTANCE_TRAVELLED_DETAILS_:
    "Detalles de distancia recorrida del vehículo",
  _ENTER_MONTHS_: "Ingrese meses",
  _SECONDARY_CONTACT_NO_: "Número de contacto secundario",
  _Enter_Primary_Contact_: "Ingrese contacto principal",
  _Identity_Number_should_be_10_Digit_Number_:
    "El número de identidad debe tener 10 dígitos",
  _Account_Name_Identity_Number_CR_Number_:
    "Nombre de cuenta, número de identidad, número CR",
  _Enter_7_or_10_Digit_Number_: "Ingrese número de 7-10 dígitos",
  _Enter_8_or_10_Digit_: "Ingrese número de 8-10 dígitos",
  _Enter_5_or_12_Digit_Number_: "Ingrese número de 5 o 12 dígitos",
  _Search_By_Driver_Name_Driver_Identity_Number_:
    "Buscar por nombre del conductor, número de identidad del conductor",
  _PASSENGER_DELETE_POPUP_: "¿Está seguro que desea eliminar al pasajero?",
  _FILE_SIZE_UPTO_10_MB_:
    "El tamaño del archivo debe ser menor o igual a 10 MB",
  _INSTALLATION_TYPE_MESSAGE_:
    "Seleccione tipo de instalación como PTA para habilitar sensor de carga",
  _RENEWAL_FOR_: "Renovación para",
  _RENEW_VEHICLE_: "Renovar vehículo",
  _ENTER_PROJECT_NAME_: "Ingrese nombre del proyecto",
  _PLEASE_SELECT_A_VEHICLE_TO_SET_GPS_ODOMETER_:
    "Seleccione un vehículo para configurar el odómetro GPS",
  _HOLIDAY_EVENT_: "Evento de vacaciones",
  _CLEAR_MAP_: "Limpiar mapa",
  _PLEASE_ENTER_IMEI_: "Ingrese IMEI",
  _TOTAL_SHOULD_BE_MORE_THAN_100_: "Verifique el total %, debe ser 100%",
  PLEASE_ENTER_NEW_PASSWORD_: "Ingrese nueva contraseña",
  PLEASE_ENTER_OLD_PASSWORD_: "Ingrese contraseña antigua",
  PLEASE_ENTER_CONFIRM_PASSWORD_: "Ingrese confirmación de contraseña",
  _NEW_PASSWORD_AND_CONFIRM_PASSWORD_MESSAGE_:
    "La nueva contraseña y la confirmación no coinciden",
  _PLEASE_ENTER_TEMPERATURE_: "Ingrese temperatura",
  _PLEASE_ENTER_TIME_LIMIT_: "Ingrese límite de tiempo",
  _SET_PARKING_TIME_LIMIT_:
    "Establecer límite de tiempo de estacionamiento (minutos)",
  _TIME_LIMIT_: "Límite de tiempo",
  PLEASE_CHECK_SEND_PUSH_NOTIFICATION_: "Verifique enviar notificación push",
  _FLEET_RULESELECTORDETAIL_RULE_PASSENGER_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo se mueve a 10 km/h y el pasajero no lleva cinturón de seguridad.",
  _PLEASE_ENTER_A_VALID_EMAIL_ADDRESS_:
    "Ingrese una dirección de correo válida",
  _FLEET_RULESELECTORDETAIL_RULE_INSURANCE_RENEWAL_DESCRIPTION_:
    "Esta regla se activa cuando los neumáticos han expirado.",
  _FLEET_RULESELECTORDETAIL_RULE_SPEED_VIOLATION_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo excede la velocidad definida en geocercas seleccionadas.",
  _FLEET_RULESELECTORDETAIL_RULE_UNAUTHORIZED_DRIVER_DESCRIPTION_:
    "Esta alerta se activa cuando un conductor no autorizado maneja el vehículo.",
  _FLEET_RULESELECTORDETAIL_RULE_GPS_BATTERY_DESCRIPTION_:
    "Esta alerta se activa cuando la batería interna del GPS está a punto de agotarse.",
  _FLEET_RULESELECTORDETAIL_RULE_NON_STOPPAGE_DESCRIPTION_:
    "Esta alerta se activa cuando el vehículo se mueve durante más tiempo del definido.",
  _FLEET_RULESELECTORDETAIL_RULE_BLE_TEMP_DESCRIPTION_:
    "Esta regla se activa cuando la temperatura/humedad excede los límites definidos. Se puede establecer temperatura/humedad mínima y máxima",
  _FLEET_RULESELECTORDETAIL_RULE_ACCIDENT_ALERT_DESCRIPTION_:
    "Esta alerta se activa cuando el vehículo sufre un accidente.",
  _FLEET_RULESELECTORDETAIL_RULE_TOWING_ALERT_DESCRIPTION_:
    "Esta alerta se activa cuando el vehículo se mueve y el encendido está apagado.",
  _FLEET_RULESELECTORDETAIL_RULE_STAY_ALERT_DESCRIPTION_:
    "Esta alerta se activa si el vehículo permanece en la geocerca seleccionada más tiempo del límite definido.",
  _FLEET_RULESELECTORDETAIL_RULE_PARKING_ALERT_DESCRIPTION_:
    "Esta alerta se genera si el vehículo está estacionado más tiempo del límite definido.",
  _FLEET_RULESELECTORDETAIL_RULE_POWER_CUT_DESCRIPTION_:
    "Esta alerta se activa cuando la energía principal del dispositivo se desconecta.",
  _FLEET_RULESELECTORDETAIL_RULE_PANIC_DESCRIPTION_:
    "Esta alerta se activa cuando se presiona el botón de pánico.",
  _FLEET_RULESELECTORDETAIL_RULE_VEHICLE_HARSH_BRAKING_DESCRIPTION_:
    "Esta alerta se activa según los eventos recibidos de los dispositivos GPS.",
  _FLEET_RULESELECTORDETAIL_RULE_MULKIYA_RENEWAL_DESCRIPTION_:
    "Esta regla se activa cuando el aceite ha expirado.",
  _FLEET_RULESELECTORDETAIL_RULE_EXCESSIVE_IDLE_DESCRIPTION_:
    "Esta regla se activa cuando el vehículo permanece en ralentí más allá del límite definido en la página del vehículo.",
  _FLEET_RULESELECTORDETAIL_RULE_EXCESSIVE_IGINITION_DESCRIPTION_:
    "Esta regla se activa cuando el encendido del vehículo se enciende y apaga.",
  _FLEET_RULESELECTORDETAIL_RULE_ROAD_OVERSPEED_DESCRIPTION_:
    "Esta regla se activa cuando la velocidad del vehículo supera la velocidad de la carretera.",
  _FLEET_RULESELECTORDETAIL_RULE_ENGINE_TEMP_DESCRIPTION_:
    "Esta alerta se activa cuando la temperatura del motor excede el límite definido.",
  _DURATION_: "Duración (minutos)",
  _RATE_: "Tasa",
  _SENSOR_: "Sensor",
  _COMMAND_NOT_DEFINED_: "Comando no definido",
  _SELECT_SEQUENCE_FIRST_: "Seleccione secuencia primero",
  _VEHICLE_MAINTENANCE_LIST_: "Lista de mantenimiento de vehículos",
  _EXIDLE_DURATION_IN_MINUTE_: "Duración EX-Idle (min)",
  _VEHICLE_TEMP_SENSOR_LIST_: "Lista de sensores de temperatura del vehículo",
  _VEHICLE_WORKING_HOURS_LIST_: "Lista de horas de trabajo del vehículo",
  _VEHICLE_TRAILER_LIST_: "Lista de remolques del vehículo",
  _HEIGHT__: "Altura",
  _WIDTH_: "Ancho",
  _DIAMETER_: "Diámetro",
  _COMMERCIAL_RECORD_ISSUE_DATE2_: "Fecha de emisión del registro",
  _UPDATE_GEOFENCE_: "Actualizar geocerca",
  _SELECT_CHANNEL_: "Seleccionar canal",
  _CHANGE_RADIUS_: "Cambiar radio",
  _CHANGE_OPACITY_: "Cambiar opacidad",
  _CHANGE_GRADIENT_: "Cambiar gradiente",
  _TOGGLE_HEATMAP_: "Alternar mapa de calor",
  _WAREHOUSE_MONITORING_: "Monitoreo de almacén",
  _WAREHOUSE_: "Almacén",
  _ACC_EVENT_: "Evento ACC",
  _BRAKE_EVENT_: "Evento de freno",
  _EXIDLE_EVENT_: "Evento EX-Idle",
  _SPEED_EVENT_: "Evento de velocidad",
  _ACC_RATE_: "Tasa ACC",
  _BRAKE_RATE_: "Tasa de frenado",
  _EXIDLE_RATE_: "Tasa EX-Idle",
  _SPEED_RATE_: "Tasa de velocidad",
  _SEATBELT_EVENT_: "Evento cinturón de seguridad",
  _SEATBELT_RATE_: "Tasa de cinturón de seguridad",
  _ENTER_PHONE_NO_: "Ingrese número de teléfono",
  _CURRENT_FUEL_LEVEL_: "Nivel de combustible actual",
  _COMPANY_NAME_ARABIC_: "Nombre de la compañía en árabe",
  _STATUS_ACTIVE_: "¿Está seguro de cambiar el estado a activo?",
  _STATUS_INACTIVE_: "¿Está seguro de cambiar el estado a inactivo?",
  _EXIDLE_GRAPH_: "Gráfico EX-Idle",
  _ADMIN_REPORT_: "Informe de administrador",
  _SELECT_DATE_: "Seleccionar fecha",
  _ALERT_TRIGGER_: "Disparo de alerta",
  _INVENTORY_ONE_: "Inventario 1",
  _INVENTORY_TWO_: "Inventario 2",
  _INVENTORY_THREE_: "Inventario 3",
  _INVENTORY_FOUR_: "Inventario 4",
  _NO_DATA_AVAILABLE_: "No hay datos disponibles",
  _TEMPERATURE_DASHBOARD_: "Panel de temperatura",
  _HOME_: "Inicio",

  _SELECT_SUB_GROUP_: "Seleccionar subgrupo",
  _MINIMUM_: "Mínimo",
  _MAXIMUM_: "Máximo",
  _SENSORS_: "Sensores",
  _FAULTY_: "Defectuoso",
  _SENSOR_DETAILS_: "Detalles del sensor",
  _MIN_TEMP_ALERT_: "Alerta de temperatura mínima",
  _MAX_TEMP_ALERT_: "Alerta de temperatura máxima",
  _TEMPERATURE_ALERTS_: "Alertas de temperatura",
  _NO_ALERTS_GENERATED_: "No se generaron alertas",
  _RANGE_VIOLATION_ALERTS_:
    "Aquí se reflejarán todas las alertas por violación de rango de temperatura y humedad.",
  _CURRENT_STATUS_: "Estado actual",
  _STATE_DURATION_: "Duración del estado",
  _LAST_SIGNAL_SYNC_: "Última sincronización de señal",
  _FULL_SUMMARY_: "Resumen completo",
  _FINISH_LOCATION_: "Ubicación final",
  _WORK_TIME_: "Tiempo de trabajo",
  _STOP_DURATION_: "Duración de parada",
  _DRIVING_DURATION_: "Duración de conducción",
  _ACCIDENT_COUNT_: "Número de accidentes",
  _SHARE_LIVE_LOCATION_: "Compartir ubicación en vivo",
  _ENTER_EXCEL_: "Ingrese archivo Excel",
  _USER_ID_: "ID de usuario",
  _CUSTOMER_CODE_: "Código de cliente",
  _ROUTE_ID_: "ID de ruta",
  _ROUTE_NAME_: "Nombre de la ruta",
  _CREATED_DATE_: "Fecha de creación",
  _INVOICE_DATE_: "Fecha de factura",
  _DEPOSITOR_: "Depositante",
  _ALLOCATE_TIME_: "Tiempo asignado",
  _QUIT_: "Salir",
  _LOGOUT_STATUS_: "¿Está seguro de cerrar sesión?",
  _VOLTAGE_DROP_: "Caída de voltaje",
  ARABIC_VEHICLE_NO_: "Número de vehículo en árabe",
  _MULKIYA_TYPE_: "Tipo de Mulkiya",
  _AREA_: "Área",
  _RESPONSIBLE_MANAGER: "Gerente responsable",
  _VEHICLE_OWNERSHIP_: "Propiedad del vehículo",
  _OWN_: "Propio",
  _RENTED_: "Alquilado",
  _SMART_PHONE_: "Teléfono inteligente",
  _MDVR_IMEI_: "IMEI MDVR",
  _MIN_FINE_AMOUNT_: "Monto mínimo de multa",
  _FINE_PER_MINUTE_: "Multa por minuto",
  _SPEEDMILEAGE_: "Velocidad/Kilometraje",
  _RULE_: "Regla",
  _SEAT_SENSORS_: "Sensor de asiento",
  _DEVICE_UDID_: "UDID del dispositivo",
  _DEVICE_UDID2_: "UDID del dispositivo 2",
  _SCREEN_UDID_: "UDID de la pantalla",
  _SCREEN_UDID2_: "UDID de la pantalla 2",
  _SEATING_CAPACITY_: "Capacidad de asientos",
  _MAX_NO_BAGGAGE_: "Número máximo de equipaje",
  _INPUT_DIGITAL_: "Entrada digital",
  _PULSE_COUNT_PER_CIRCLE_: "Conteo de pulsos por círculo",
  _MILEAGE_PER_CIRCLE_: "Kilometraje por círculo",
  _SPEED_CONSTANT_: "Constante de velocidad",
  _SUBTOTAL_AMOUNT_: "Monto subtotal",
  _VAT5_: "IVA 5%",
  _SERVICE_CATEGORY_: "Categoría de servicio",
  _CUSTOMER_NAME_INVOICE_NO_:
    "Nombre del cliente, N° de factura, Fecha de factura",
  _ODOMETER_RECORDS_: "Registros de odómetro",
  _PROCESS_DATA_: "Procesar datos",
  _SHEDULED_AT_: "Programado en",
  _SUB_GROUP_: "Subgrupo",
  _GROUP_: "Grupo",
  _ADD_INVOICE_: "Agregar factura",
  _INVOICE_ID_: "ID de factura",
  _CANCEL_JOB_: "Cancelar trabajo",
  _REASON_TO_CANCEL_JOB_: "Motivo para cancelar el trabajo",
  _TRIP_DISTANCE_TRAVELLED_: "Distancia del viaje recorrida",
  _DOOR_OPEN_CLOSE_ALERT_: "Alerta de puerta abierta/cerrada",
  _DOOR_OPEN_CLOSE_ALERT_STATEMENT_:
    "Esta alerta se activará cuando la puerta del vehículo se abra o cierre.",
  _MULKIYA_RENEWAL_ALERT_: "Alerta de renovación Mulkiya",
  _MULKIYA_RENEWAL_ALERT_STATEMENT_:
    "Esta alerta se activa 30, 15 y 7 días antes de la fecha de vencimiento de Mulkiya.",
  _INSURANCE_RENEWAL_ALERT_: "Alerta de renovación de seguro",
  _INSURANCE_RENEWAL_ALERT_STATEMENT_:
    "Esta alerta se activa 30, 15 y 7 días antes de la fecha de vencimiento del seguro.",
  _BATTERY_CHANGE_ALERT_: "Alerta de cambio de batería",
  _BATTERY_CHANGE_ALERT_STATEMENT_:
    "Esta alerta se activa 30, 15 y 7 días antes de la próxima fecha de cambio de batería.",
  _SERVICE_OIL_TYRE_CHANGE_ALERT_:
    "Alerta de servicio/cambio de aceite/neumático",
  _SERVICE_OIL_TYRE_CHANGE_ALERT_STATEMENT_:
    "Esta alerta se activa cuando el servicio, aceite o cambio de neumático es debido para el vehículo seleccionado.",
  _TAXI_CUSTOMERS_: "Clientes de taxi",
  _NAME_: "Nombre",
  _EMAIL_ADDRESS_: "Correo electrónico",
  _DISCOUNT_LIST_: "Lista de descuentos",
  _DISCOUNT_NAME_: "Nombre del descuento",
  _DISCOUNT_TYPE_: "Tipo de descuento",
  _DISCOUNT_: "Descuento",
  _ADD_DISCOUNT_: "Agregar descuento",
  _DELETE_DISCOUNT_: "Eliminar descuento",
  _FLAT_AMOUNT_: "Monto fijo",
  _DISCOUNT_AMOUNT_: "Monto del descuento",
  _ADVERTISEMENT_: "Publicidad",
  _DELETE_ADVERTISEMENT_: "Eliminar publicidad",
  _INTERVAL_SEC_: "Intervalo (seg)",
  _IMAGE_VIDEO_TYPE_: "Tipo de imagen/video",
  _PICTURE_VIEW_: "Vista de imagen",
  _PLEASE_SELECT_IMAGE_VIDEO_: "Seleccione imagen/video",
  _FULL_BANNER_: "Banner completo",
  _MIDDLE_BANNER_: "Banner medio",
  _BOTTOM_BANNER_: "Banner inferior",
  _AUDIO_MESSAGE_: "Mensaje de audio",
  _DELETE_AUDIO_MESSAGE_: "Eliminar audio",
  _AUDIO_VIEW_: "Vista de audio",
  _PLEASE_SELECT_AUDIO_: "Seleccione audio",
  _POINT_OF_INTEREST_: "Punto de interés",
  _DELETE_POINT_OF_INTEREST_: "Eliminar",
  _POINT_OF_INTEREST_TYPE_: "Tipo de punto de interés",
  _EVENT_LIST_: "Lista de eventos",
  _TITLE_: "Título",
  _NEWS_: "Noticias",
  _SPECIAL_OFFER_: "Oferta especial",
  _ADD_NEWS_: "Agregar noticias",
  _DELETE_NEWS_: "Eliminar noticias",
  _ADD_OFFER_: "Agregar oferta",
  _ADD_POI_: "Agregar punto de interés",
  _NEW_MAINTENANCE_: "Nuevo mantenimiento",
  _MAINTENANCE_TYPE_: "Tipo de mantenimiento",
  _ADD_NEW_MAINTENANCE_: "Agregar nuevo mantenimiento",
  _ADD_NEW_SERVICE_: "Agregar nuevo servicio",
  _SUB_GROUP_LIST_: "Lista de subgrupos",
  _SERVICE_TEMPLATE_: "Plantilla de servicio",
  _SERVICE_ID_: "ID de servicio",
  _VEHICLE_AUDIT_: "Auditoría del vehículo",
  _ACCIDENT_ANALYSIS_: "Análisis de accidentes",
  _VEHICLE_AUDIT_SCORE_: "Puntuación de auditoría del vehículo",
  _ACCIDENT_REASON_: "Motivo del accidente",
  _OUTSIDE_PARTY_: "Tercero",
  _ACCIDENT_TYPE_: "Tipo de accidente",
  _TAXI_TYPE_: "Tipo de taxi",
  _TAXI_TYPE_LIST_: "Lista de tipos de taxi",
  _QUEUE_LIST_: "Lista de cola",
  _POSITION_: "Posición",
  _SUB_GROUP_DETAILS_: "Detalles del subgrupo",
  _TAXI_MANAGEMENT_: "Gestión de taxis",
  _TAXI_DEFAULT_PARAMETERS_: "Parámetros predeterminados de taxi",
  _FARE_DETAILS_: "Detalles de tarifa",
  _DAY_TIME_FROM_: "Horario diurno desde (hrs)",
  _DAY_TIME_TO_: "Horario diurno hasta (hrs)",
  _SPEED_DISTANCE_: "Velocidad/Distancia",
  _MAX_SPEED_INTERVAL_SEC_: "Intervalo máximo de velocidad (seg)",
  _DIGITAL_INPUT_1: "Entrada digital 1",
  _DIGITAL_INPUT_2: "Entrada digital 2",
  _DIGITAL_INPUT_3: "Entrada digital 3",
  _DIGITAL_INPUT_4: "Entrada digital 4",
  _PRINTER_: "Impresora",
  _TAXI_DEFAULT_PARAMETERS_DETAILS_:
    "Detalles de parámetros predeterminados de taxi",
  _TAXI_PARAMETER_LIST_: "Lista de parámetros de taxi",
  _TARIFF_NAME_: "Nombre de tarifa",
  _BASIC_FARE_: "Tarifa básica",
  _MINIMUM_FARE_: "Tarifa mínima",
  _DISTANCE_FARE_: "Tarifa por distancia",
  _TIME_FARE_: "Tarifa por tiempo",
  _VALID_FROM_DATETIME_: "Válido desde fecha/hora",
  _VALID_TO_DATETIME_: "Válido hasta fecha/hora",
  _FAIR_TYPE_: "Tipo de tarifa",
  _TAX_PERCENTAGE_: "Porcentaje de impuesto",
  _BOOKING_CHARGES_: "Cargos por reserva",
  _ADD_VERSION_: "Agregar versión",
  _VERSION_: "Versión",
  _HOLIYDAY_: "Día festivo",
  _LONG_DISTANCE_FARE_: "Tarifa de larga distancia",
  _LONG_DISTANCE_KM_: "Larga distancia (Km)",
  _PEAK_TIME_FROM_: "Hora punta desde",
  _PEAK_TIME_TO_: "Hora punta hasta",
  _PEAK_DISTANCE_FARE_: "Tarifa por distancia en hora punta",
  _PEAK_TIME_FARE_: "Tarifa por tiempo en hora punta",
  _PEAK_BASIC_FARE_: "Tarifa básica en hora punta",
  _PEAK_MIN_FARE_: "Tarifa mínima en hora punta",
  _TAXI_PARAMETERS_: "Parámetros de taxi",

  _ASSIGN_ZONE_: "Asignar zona",
  _QUESTION_: "Pregunta",
  _ANSWER_: "Respuesta",
  _PREDEFINED_MESSAGES_LIST_: "Lista de mensajes predefinidos",
  _ADD_PREDEFINED_MESSAGES_: "Agregar mensaje predefinido",

  _START_ADDRESS_: "Dirección de inicio",
  _END_ADDRESS_: "Dirección de fin",
  _END_POINT_2_: "Punto final / Punto común",
  _TRIP_DISTANCE_: "Distancia del viaje",
  _TOTAL_JOB_: "Total de trabajos",
  _STARTED_: "Iniciado",
  _DELIVERIES_: "Entregas",
  _JOB_COMPLETED_: "Trabajo completado",
  _PENDING_JOBS_: "Trabajos pendientes",
  _CANCELLED_JOBS_: "Trabajos cancelados",
  _CREATED_AT_: "Creado en",
  _UPDATED_FIELD_: "Campo actualizado",
  _CANCELLED_AT_: "Cancelado en",
  _CANCELLED_BY_: "Cancelado por",
  _DELIVERY_LOG_: "Registro de entregas",
  _ORDER_STATUS1_: "Estado del pedido",
  _UNDELIVERED_REASON_: "Motivo de no entrega",
  _NO_OF_ATTEMPTS_: "Número de intentos",
  _LOG_: "Registro",
  _FLEET_REPORTS_GEOFENCEREPORT_LOCATION_IN_: "Ubicación dentro del geocerca",
  _FLEET_REPORTS_GEOFENCEREPORT_LOCATION_OUT_: "Ubicación fuera del geocerca",
  _DETAILED_JOB_REPORT_: "Informe detallado del trabajo",
  _TOTAL_KM_DAY_: "Total Km/Día",
  _JOB_STARTED_TIME_: "Hora de inicio del trabajo",
  _JOB_FINISHED_TIME_: "Hora de finalización del trabajo",
  _TRAVEL_KM_: "Km recorridos",
  _SELECT_VEHICLE_BY_: "Seleccionar vehículo por",
  _SPEED_DURATION_: "Duración de velocidad",
  _VENDOR_ID_: "ID del proveedor",
  _SPECIAL_: "Especial",
  _NEIGHT_PRICE_: "Precio de vecino",
  _BIG_PRICE_: "Precio grande",
  _BIG_NEIGHT_PRICE_: "Precio grande de vecino",
  _REMARK_: "Observación",
  _CERTIFICATE_: "Certificado",
  _CHASSIS_NUMBER_: "Número de chasis",
  _TRACKER_ID_: "ID del rastreador",
  _GLOBAL_SEARCH_: "Búsqueda global",
  _SEARCH_: "Buscar",
  _AGREEMENT_: "Acuerdo",
  _TRADE_LICENSE_: "Licencia comercial",
  _CERTIFICATE_REPORT_: "Informe de certificado",
  _ISSUING_DATE_: "Fecha de emisión",
  _S_NO_: "N.º",
  _ASSIGN_GEOFENCE_TO_COMPANY_: "Asignar geocerca a la empresa",
  _ASSIGN_GEOFENCE_: "Asignar geocerca",
  _SOCIAL_MEDIA_: "Redes sociales",
  _ADD_SOCIAL_MEDIA_: "Agregar redes sociales",
  _RTA_OFFICIALS_: "Oficiales de RTA",
  _DAILY_JOB_REPORT_: "Informe diario de trabajo",
  _HELP_CENTER_: "Centro de ayuda",
  _DEPARTMENT_MSG_: "Por favor, ingrese el nombre del departamento",

  _UPLOAD_EXCEL_: "Subir Excel",
  _UPLOAD_EXCEL_FILE_: "Subir archivo Excel",
  _UPLOAD_EXCEL_TITLE_: "Registro masivo de dispositivos",
  _SAMPLE_EXCEL_DESC_:
    "Crea todas las solicitudes de registro de una vez. Luego, cada una debe pasar por el proceso de aceptación regular.",
  _SAMPLE_DOWNLOAD_: "Descarga de ejemplo",
  _UPLOAD_TEXT_: "Suelte los archivos aquí o haga clic",
  _UPLOAD_TEXT_1_: "examinar",
  _UPLOAD_TEXT_2_: "en su máquina",
  _SAMPLE_DOWNLOAD_DESC_:
    "Crea todas las credenciales y dispositivos utilizando la lista proporcionada de valores de propiedad. Los dispositivos pueden comenzar a comunicarse con la plataforma inmediatamente.",
  _SAMPLE_UPLOAD_: "Subida de ejemplo",
  _DELETE_STATUS_:
    "¿Está seguro de que desea eliminar este registro? Esta acción no se puede deshacer.",

  _MASTERS_TITILE_:
    "La sección Maestros proporciona acceso a las herramientas centrales de configuración y gestión del sistema. Aquí, puede administrar datos de referencia clave, incluidos detalles de cuentas, información de vehículos y especificaciones de trabajo.",

  _ACCOUNT_TAB_TITILE_:
    "Aquí puede crear, modificar y eliminar cuentas, así como administrar los detalles de la cuenta, permisos y otra información relevante.",

  _VEHICLE_MANAGEMENT_TITILE_:
    "Aquí puede agregar nuevos vehículos, actualizar la información existente, realizar un seguimiento de los registros de mantenimiento y administrar asignaciones de vehículos.",

  _FUEL_MANAGEMENT_TITILE_:
    "Aquí puede rastrear el consumo de combustible, monitorear niveles de combustible y generar informes sobre eficiencia de combustible.",

  _SCHOOL_MANAGEMENT_TITILE_:
    "Aquí puede administrar la información de estudiantes y maestros, realizar un seguimiento del progreso académico y supervisar las operaciones escolares.",

  _JOB_MANAGEMENT_TITILE_:
    "Aquí puede crear nuevos trabajos, asignar tareas, realizar un seguimiento del progreso y supervisar la finalización del trabajo.",

  _TAXI_MANAGEMENT_TITILE_:
    "Aquí puede administrar la información del vehículo, asignaciones de conductores, despacho de viajes e interacciones con los clientes.",

  _TRIP_MANAGEMENT_TITILE_:
    "Aquí puede crear, modificar y eliminar cuentas, así como administrar detalles de cuenta, permisos y otra información relevante.",

  _WAREHOUSE_MANAGEMENT_TITILE_:
    "Aquí puede crear, modificar y eliminar cuentas, así como administrar detalles de cuenta, permisos y otra información relevante.",

  _INVENTORY_MANAGEMENT_TITILE_:
    "Aquí puede crear, modificar y eliminar cuentas, así como administrar detalles de cuenta, permisos y otra información relevante.",

  _TRACKING_TITLE_:
    "La sección de seguimiento proporciona herramientas para monitorear varios aspectos del sistema. Aquí puede rastrear el progreso, identificar problemas potenciales y obtener información sobre el rendimiento general.",

  _LIVE_TRACKING_TITILE_:
    "La sección de seguimiento en vivo le permite monitorear la ubicación y el estado actuales de vehículos, personal u otros elementos rastreados en tiempo real.",

  _TRACK_BY_GROUP_TITILE_:
    "La sección de seguimiento por grupo permite monitorear y rastrear información organizada por grupo. Esto proporciona métricas de rendimiento y otros indicadores relevantes.",

  _MULTITRACKING_DESC_:
    "La sección de seguimiento múltiple proporciona la capacidad de rastrear múltiples elementos o procesos simultáneamente.",

  _LIVE_ROUTE_PATH_DESC_:
    "La sección de ruta en vivo muestra la ruta actual del vehículo o viaje seleccionado.",

  _ADVANCE_DASHBOARD_DESC_:
    "El tablero avanzado proporciona una visión completa de los indicadores de rendimiento y datos.",

  _DETAIL_TRACKING_DESC_:
    "El seguimiento detallado proporciona puntos de datos específicos y permite obtener información sobre aspectos de sus operaciones.",

  _HEAT_MAP_DESC_:
    "La sección de mapa de calor proporciona una representación visual de los datos utilizando degradados de color.",

  _TEMPERATURE_DASHBOARD_DESC_:
    "El tablero de temperatura proporciona una vista visual de los datos de temperatura.",

  _DASHBOARD_DESC_:
    "El tablero proporciona una visión en tiempo real de los principales indicadores del sistema.",

  _MAINTENANCE_DASHBOARD_DESC_:
    "El panel de mantenimiento proporciona todas las actividades de mantenimiento.",

  _HISTORY_TRACKING_DESC_:
    "La sección de historial de seguimiento proporciona un registro de todas las actividades pasadas dentro del sistema.",

  _SENSOR_REPORT_DESC_:
    "La sección de informes de sensores proporciona acceso a los informes generados a partir de datos de sensores.",

  _WAREHOUSE_MONITORING_DESC_:
    "La sección de monitoreo de almacén proporciona información en tiempo real sobre las operaciones del almacén.",

  _VIDEO_MONITORING_DESC_:
    "La sección de monitoreo de video proporciona acceso a transmisiones en vivo de todas las cámaras conectadas.",

  _MULTI_VIDEO_MONITORING_DESC_:
    "La sección de monitoreo múltiple permite ver múltiples transmisiones de video simultáneamente. Esto proporciona una visión completa de las áreas monitoreadas, permitiendo identificar y responder rápidamente a cualquier evento.",

  _EMAIL_REPORT_DESC_:
    "La sección de informes por correo electrónico permite generar y administrar informes por correo electrónico. Aquí puede seleccionar los informes que desea recibir, configurar el horario de entrega y administrar sus suscripciones.",

  _EMAIL_REPORT_TITLE_:
    "La sección de informes por correo electrónico permite generar y administrar informes por correo electrónico.",

  _SETTINGS_DESC_:
    "La sección de configuración permite personalizar y configurar varios aspectos del sistema. Aquí puede ajustar preferencias, administrar configuraciones del sistema y personalizar su experiencia de usuario.",

  _NOTIFICATION_TITLE_:
    "La sección de notificaciones muestra una lista de notificaciones recientes. Aquí puede revisar actualizaciones importantes, alertas y mensajes del sistema.",

  _SIM_LIST_DESC_:
    "La lista de SIM proporciona una visión completa de todas las tarjetas SIM dentro del sistema. Aquí puede ver los detalles de la SIM y la información asociada.",

  _DEVICE_LOG_LIST_DESC_:
    "Aquí puede revisar registros detallados de acciones de dispositivos, eventos del sistema y posibles errores, proporcionando información valiosa sobre el rendimiento y comportamiento del dispositivo.",

  _EMAIL_MESSAGE_DESC_:
    "Aquí puede revisar registros detallados de acciones de dispositivos, eventos del sistema y posibles errores, proporcionando información valiosa sobre el rendimiento y comportamiento del dispositivo.",

  _INSPECTION_DESC_:
    "La sección de inspecciones proporciona herramientas para realizar y administrar inspecciones. Aquí puede programar inspecciones y registrar hallazgos.",

  _GPRS_COMMAND_DESC_:
    "La sección de comandos GPRS proporciona herramientas para enviar y administrar comandos a dispositivos habilitados para GPRS.",

  _ADD_LOCATION_DESC_:
    "Aquí, puede especificar el nombre de la ubicación, la dirección y otros detalles relevantes.",

  _FAQ_DESC_:
    "Aquí, puede encontrar soluciones rápidas a problemas comunes y aprender cómo funciona nuestro sistema.",

  _PREDEFINED_MESSAGES_LIST_DESC_:
    "La sección de mensajes predefinidos proporciona una lista de mensajes de uso común que se pueden insertar rápidamente en las comunicaciones.",

  _DEVICE_LIST_DESC_:
    "La lista de dispositivos proporciona una visión completa de todos los dispositivos dentro del sistema. Puede ver detalles del dispositivo, estado e información asociada.",

  _CHANGE_PASSWORD_DESC_:
    "La sección de cambio de contraseña le permite actualizar la contraseña de su cuenta por motivos de seguridad.",

  _GEOFENCE_MANAGEMENT_DESC_:
    "La sección de gestión de geocercas proporciona herramientas para crear, modificar y administrar geocercas.",

  _ALERT_MENU_DESC_:
    "La sección de alertas proporciona una vista centralizada de las notificaciones generadas por el sistema. Aquí, puede revisar actualizaciones importantes relacionadas con cuentas, vehículos, trabajos y viajes, asegurando que esté informado de eventos críticos.",

  _ALERT_TITLE_:
    "La sección de alertas muestra una lista de notificaciones y advertencias importantes. Aquí, puede revisar alertas generadas por el sistema, alertas definidas por el usuario y otra información crítica.",

  _GRAPHS_DESC_:
    "La sección de gráficos presenta información clave en formato gráfico, permitiendo una interpretación rápida y fácil de conjuntos de datos complejos. Estos gráficos proporcionan información visual sobre tendencias, patrones y relaciones dentro de los datos.",

  _SPEED_GRAPH_DESC_:
    "Este gráfico le permite identificar rápidamente patrones de velocidad, monitorear el rendimiento y analizar fluctuaciones de velocidad.",

  _DISTANCE_GRAPH_DESC_:
    "El gráfico de distancia proporciona una representación visual de las distancias para comprender y analizar rápidamente los datos relacionados con la distancia.",

  _IDLE_GRAPH_DESC_:
    "Este gráfico muestra los periodos de inactividad, permitiéndole identificar áreas potenciales de optimización y asignación de recursos.",

  _EXIDLE_GRAPH_DESC_:
    "Este gráfico le permite analizar periodos de inactividad, identificar ineficiencias potenciales y optimizar la utilización de recursos.",

  _USAGE_GRAPH_DESC_:
    "Aquí, puede ver patrones y tendencias en los datos de uso, permitiéndole monitorear la actividad del sistema e identificar áreas de mejora.",

  _TEMPERATURE_GRAPH_DESC_:
    "Estos gráficos muestran una representación visual de los datos de temperatura a lo largo del tiempo, permitiendo monitorear la temperatura.",

  _DASHBOARD_GRAPH_DESC_:
    "Aquí, puede obtener información sobre el rendimiento del sistema, tendencias y métricas clave a través de gráficos e interacciones visuales.",

  _FUEL_GRAPH_DESC_:
    "El gráfico de combustible proporciona una representación visual del consumo de combustible, permite analizar patrones de uso y monitorear la eficiencia del combustible a lo largo del tiempo.",

  _DRIVER_SCORE_GRAPH_DESC_:
    "Este gráfico muestra las calificaciones de los conductores, permitiéndole identificar rápidamente tendencias y evaluar el desempeño individual de los conductores.",

  _MAX_SPEED_GRAPH_DESC_:
    "Este gráfico le permite analizar el rendimiento de velocidad, identificar tendencias y detectar posibles violaciones del límite de velocidad.",

  _REPORTS_DESC_:
    "La sección de informes proporciona acceso a una variedad de informes que resumen datos y tendencias clave. Aquí, puede generar informes sobre varios aspectos del sistema, monitorear el rendimiento e identificar áreas de mejora.",

  _TRACKING_REPORTS_DESC_:
    "La sección de informes de seguimiento proporciona acceso a varios informes que rastrean métricas y actividades clave.",

  _MISCELLANEOUS_REPORTS_DESC_:
    "La sección de informes misceláneos proporciona acceso a una variedad de informes que no se cubren en otras áreas de informes específicas.",

  _DRIVER_RELATED_REPORTS_DESC_:
    "La sección de informes de conductores proporciona acceso a una variedad de informes relacionados con la actividad y el rendimiento del conductor.",

  _FLEET_REPORT_DESC_:
    "La sección de informes de flota proporciona acceso a una variedad de informes relacionados con su flota.",

  _ALERT_REPORT_DESC_:
    "La sección de informes de alertas proporciona acceso a informes sobre alertas generadas por el sistema.",

  _ADMIN_REPORT_DESC_:
    "La sección de informes administrativos proporciona acceso a una variedad de informes relacionados con la actividad del sistema, actividad de usuarios y otras funciones administrativas.",

  _WASTE_MANAGEMENT_: "Gestión de residuos",

  _WASTE_MANAGEMENT_DESC_:
    "La sección de gestión de residuos proporciona herramientas para supervisar todos los aspectos de la gestión de residuos. Aquí, puede rastrear la generación de residuos, gestionar los horarios de recolección, monitorear los procesos de eliminación y asegurar el cumplimiento de las regulaciones.",

  _WASTE_MANAGEMENT_DASHBOARD_: "Panel de gestión de residuos",

  _WASTE_MANAGEMENT_DASHBOARD_DESC_:
    "El panel de residuos proporciona una visión completa de las operaciones de gestión de residuos.",

  _JOB_DETAILS_DESC_:
    "Aquí, puede encontrar detalles sobre ubicaciones de recolección, tipos de residuos, horarios programados y cualquier instrucción especial relacionada con el trabajo.",

  _MASTERS_DESC_:
    "Aquí, puede administrar datos de referencia clave, incluidos tipos de residuos, sitios de eliminación, rutas de recolección e información de clientes.",

  _JOB_PLANNING_: "Planificación de trabajos",

  _JOB_PLANNING_DESC_:
    "Aquí, puede planificar rutas, asignar recursos y establecer horarios para asegurar operaciones de gestión de residuos eficientes.",

  _WASTE_MANAGEMENT_REPORT_DESC_:
    "Aquí, puede generar informes sobre generación de residuos, eliminación y reciclaje, permitiéndole rastrear tendencias y monitorear el rendimiento.",

  _USER_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su usuario. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _ASSIGN_FORM_DESC_:
    "Este formulario le permite asignar un vehículo a un usuario. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _DRIVER_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su conductor. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _POINT_OF_INTEREST_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su punto de interés. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _EVENT_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su evento. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _NEWS_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de sus noticias. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _SPECIAL_OFFER_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de sus ofertas especiales. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_GROUP_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su grupo de dispositivos. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_SUBGROUP_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su subgrupo de dispositivos. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_WORKINGHOURS_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de horas de trabajo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_DISTANCE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de distancia del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_LIVE_LOCATION_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de la ubicación en tiempo real del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_FUEL_CALIBRATION_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de calibración de combustible del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _TAXI_TYPE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del tipo de taxi. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _SERVICE_TEMPLATE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su plantilla de servicio. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_AUDIT_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de auditoría del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_ODOMETER_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del odómetro del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _MENU_SETTING_ADD_DESC_:
    "Este formulario le permite ver y/o modificar la configuración. Asegúrese de que todas las configuraciones sean precisas y estén actualizadas.",

  _DRIVER_BEHAVIOUR_ADD_DESC_:
    "Este formulario le permite ver y/o modificar la configuración de comportamiento del conductor. Asegúrese de que todas las configuraciones sean precisas y estén actualizadas.",

  _EMAIL_ADD_DESC_:
    "Este formulario le permite ver y/o modificar la configuración de correo. Asegúrese de que todas las configuraciones sean precisas y estén actualizadas.",

  _ADVERTISEMENT_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del anuncio. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _DISCOUNT_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del descuento. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _AUDIO_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del mensaje de audio. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _EMPLOYEE_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del empleado. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _PASSENGER_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del pasajero. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _ALLOCATE_VEHICLE_DESC_:
    "Este formulario le permite asignar un vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _RETURN_VEHICLE_DESC_:
    "Este formulario le permite devolver un vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _MAINTENANCE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar el mantenimiento del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _NEW_MAINTENANCE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar el mantenimiento del vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _ROUTE_MANAGEMENT_ADD_DESC_:
    "Este formulario le permite ver y/o modificar la gestión de rutas. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _FARE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de tarifas. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _FUEL_ADD_DESC_:
    "Este formulario de combustible le permite ver y/o modificar detalles. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _FUEL_FILLED_DESC_:
    "Este formulario de combustible llenado le permite ver y/o modificar detalles. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _PARENT_DETAILS_DESC_:
    "Este formulario de padres le permite ver y/o modificar detalles. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _PARENT_DETAILS_: "Detalles del padre",

  _CALENDER_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su calendario. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _CALENDER_DETAILS_: "Detalles del calendario",

  _GRADE_BUS_TIMING_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles del horario de autobuses. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _GRADE_BUS_TIMING_DETAILS_: "Detalles del horario de autobuses",

  _ALERT_ADD_DESC_:
    "Este formulario le permite ver y/o modificar la configuración de alertas. Asegúrese de que todas las configuraciones sean precisas y estén actualizadas.",

  _ACCOUNT_ADD_DESC_:
    "Este formulario le permite ver y modificar la información de su cuenta. Asegúrese de que todos los detalles sean precisos y estén actualizados.",

  _PAYMENT_TAB_DESC_:
    "El formulario de pagos y accesorios le permite enviar su pago de forma segura. Ingrese la información requerida y revise los detalles antes de enviar.",

  _JOB_MANAGEMENT_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su trabajo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _JOB_MANAGEMENT_: "Detalles del Trabajo",

  _JOB_REQUEST_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su solicitud de trabajo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _JOB_REQUEST_: "Solicitud de Trabajo",

  _FAQ_DETAIL_: "Detalles de FAQ",

  _FAQ_LIST_: "Lista de FAQ",

  _FAQ_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de sus preguntas frecuentes. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _PREDEFINED_MESSAGE_DETAIL_: "Detalles de Mensaje Predefinido",

  _PREDEFINED_MESSAGE_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de sus mensajes predefinidos. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _DEVICE_DETAIL_: "Detalles del Dispositivo",

  _DEVICE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su dispositivo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _FLEET_VEHICALDETAIL_TITLE_: "Detalles del Vehículo",

  _VEHICLE_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _FLEET_VEHICLE_DETAIL_TITLE_: "Detalles del Vehículo",

  _VEHICLE_DETAILS_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _VEHICLE_INFO_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su vehículo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _TANK_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su tanque. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _TAXI_DEFAULT_PARAMETERS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de los parámetros predeterminados del taxi. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _TANK_DETAILS_: "Detalles del Tanque",

  _FLEET_VEHICLE_USERDETAIL_TITLE_: "Detalles del Vehículo",

  _PYTHON_REPORT_LIST_: "Lista de Informes Python",

  _PYTHON_REPORT_: "Informes Python",

  _REPORT_LINK_: "Enlace de Informe",

  _IS_REQUIRED_: "¡es obligatorio!",

  _IS_INVALID_: "es inválido",

  _FLEET_TRACKING_: "Seguimiento de Flota",

  _ASSIGN_VEHICLE_FORM_DESC_:
    "Este formulario le permite asignar un vehículo a la empresa. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _EDIT_: "Editar",

  _DELETE_: "Eliminar",

  _ASSET_DETAILS_: "Detalles del Activo",

  _PERIPHERALS_: "Periféricos",

  _VEHICLE_ACTIVITY_: "Actividad del Vehículo",

  _CHASIS_NUMBER_: "Número de Chasis",

  _SUBSCRIPTION_TYPE_: "Tipo de Suscripción",

  _DEVICE_DETAILS_: "Detalles del Dispositivo",

  _FINANCIALS_: "Finanzas",

  _VEHICLE_COLOR_: "Color del Vehículo",

  _VEHICLE_BRAND_: "Marca del Vehículo",

  _EQUIPMENT_SERVICE_INTERVAL_: "Intervalo de Servicio del Equipo (hrs)",

  _LAST_SERVICE_: "Último Servicio (hrs)",

  _ASSET_ODOMETER_: "Odómetro del Activo",

  _DIFFERANTIAL_ODOMETER_: "Odómetro Diferencial",

  _ASSET_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su activo. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _MAINTENANCE_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de mantenimiento. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _PERIPHERALS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de los periféricos. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _ALERT_CLOSE_BUTTON_MESSAGE_:
    "¿Está seguro de que desea cerrar el formulario? Cualquier cambio no guardado se perderá.",

  _ASSET_SERVICING_: "Mantenimiento de Activos",

  _OVERSPEED_DURATION_REPORT_: "Informe de Duración de Exceso de Velocidad",

  _FLEET_TEMP_SUMMARY_REPORT_: "Informe Resumen de Temperatura de Flota",

  _DEPOT_NAME_: "Nombre del Depósito",

  _SUPERVISOR_NAME_: "Nombre del Supervisor",

  _Kms_COVERED_: "Km Cubiertos",

  _AVG_TEMP1_: "Temp Promedio1",

  _AVG_TEMP2_: "Temp Promedio2",

  _AVG_TEMP3_: "Temp Promedio3",

  _AVG_TEMP4_: "Temp Promedio4",

  _DOOR_OPENING_DURATION_: "Duración de Apertura de Puerta",

  _DOOR_OPENING_COUNT_: "Cantidad de Aperturas de Puerta",

  _NOTIFICATION_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de sus notificaciones. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _UPDATE_VALUES_: "Actualizar Valores",

  _SIM_ADD_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su SIM. Asegúrese de que toda la información sea precisa y esté actualizada.",

  _PLEASE_SELECT_REPORT_FORMAT_: "Por favor, seleccione el formato de informe",

  _INSPECTION_DETAIL_: "Detalles de Inspección",

  _PLEASE_SELECT_DATE_: "Por favor, seleccione la fecha",

  _PLEASE_SELECT_FROMTIME_: "Por favor, seleccione la hora",

  _PLEASE_SELECT_DRIVER_NAME_: "Por favor, seleccione el nombre del conductor",

  _DOWNLOAD_PDF_: "Descargar PDF",

  _PLEASE_SELECT_SHIFT_NAME_: "Por favor, ingrese el nombre del turno",

  _PLEASE_SELECT_WORKING_DAYS_: "Por favor, seleccione los días laborales",

  _PLEASE_SELECT_FROM_TIME_: "Por favor, seleccione la hora de inicio",

  _PLEASE_SELECT_TO_TIME_: "Por favor, seleccione la hora de finalización",

  _PLEASE_SELECT_ASSIGN_TO_: "Por favor, seleccione a quién asignar",

  _AI_DESC_:
    "La sección de IA proporciona herramientas e información inteligentes impulsadas por inteligencia artificial. Aquí puede acceder a funciones como análisis en tiempo real.",
  _ADD_GEOFENCE_: "Agregar Geocerca",
  _UPLOAD_FROM_EXCEL_: "Cargar desde Excel",
  _IRIDIUM_IMEI_: "IMEI de Iridium",
  _NEW_BOOKING_: "Nueva Reserva",
  _BOOKING_DASHBOARD_: "Panel de Reservas",
  _BOOKING_DASHBOARD_DESC:
    "Muestra todas las últimas reservas de taxis con su estado.",
  _BOOKING_REQUEST_ID_: "ID de Solicitud de Reserva",
  _TAXI_NO_: "Número de Taxi",
  _CUSTOMER_NO_: "Número de Cliente",
  _PICKUP_ADDRESS_: "Dirección de Recogida",
  _DROPOFF_ADDRESS_: "Dirección de Destino",
  _ESTIMATED_FARE_: "Tarifa Estimada",
  _TOTAL_FARE_: "Tarifa Total",
  _BOOKING_DATETIME_: "Fecha y Hora de Reserva",
  _TRIP_STOP_TIME_: "Tiempo de Parada del Viaje",
  _BOOKING_STATUS_: "Estado de la Reserva",
  _FINDING_: "Buscando",
  _BOOKING_PROCESSING_: "En Proceso",
  _REJECTED_: "Rechazado",
  _ONGOING_: "En Curso",
  _BOOKED_: "Reservado",
  _NO_OF_PASSENGERS_: "Número de Pasajeros",
  _NO_TAXI_FOUND_:
    "No hay taxis cercanos disponibles. Por favor, inténtelo más tarde.",
  _SEARCH_BY_CUSTOMERNAME_: "Buscar por nombre del cliente",
  _BOOKING_: "Reserva",
  _BOOKING_DESC_:
    "La sección de reservas proporciona todos los modelos, panel y creación de reservas de taxis.",
  _BOOKING_ADD_FORM_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su reserva. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _RIDE_NOW_: "Viajar Ahora",
  _ADD_BOOKING_: "Agregar Reserva",
  _TRIP_LOG_REPORT_: "Informe de Registro de Viaje",
  _VEHICLE_NO_: "Número de Vehículo",
  _TOTAL_NO_OF_TRIPS_: "Número Total de Viajes",
  _TOTAL_DISTANCE_FARE_: "Tarifa por Distancia Total",
  _TOTAL_WAITING_TIME_FARE_: "Tarifa por Tiempo de Espera Total",
  _TOTAL_VAT_: "IVA Total",
  _DRIVER_LOG_REPORT_: "Informe de Registro del Conductor",
  _BOOKING_ID_: "ID de Reserva",
  _ISSUES_: "Problemas",
  _RATINGS_: "Calificaciones",
  _CUSTOMER_FEEDBACK_REPORT_: "Informe de Retroalimentación del Cliente",
  _BOOKING_REPORT_: "Informe de Reservas",
  _BOOKING_COMPANY_: "Empresa de Reserva",
  _ORDER_CHANNEL_: "Canal de Pedido",
  _FARE_TYPE_: "Tipo de Tarifa",
  _PICKUP_LOCATION_: "Ubicación de Recogida",
  _DROP_TIME_: "Hora de Llegada",
  _DROP_LOCATION_: "Ubicación de Destino",
  _WAITING_TIME_: "Tiempo de Espera",
  _VAT_: "IVA",
  _WAITING_FARE_: "Tarifa de Espera",
  _TOLL_: "Peaje",
  _PARKING_: "Estacionamiento",
  _BOOKING_REPORT_DESC_:
    "La sección de informes de administrador proporciona acceso a un informe de reservas.",
  _REFERENCE_KEY_: "Clave de Referencia",
  _REFERENCE_NUMBER_: "Número de Referencia",
  _IS_VALID_: "Es Válido",
  _IS_DRIVER_VALID_: "El Conductor es Válido",
  _IS_VEHICLE_VALID_: "El Vehículo es Válido",
  _REGISTRATION_TIME_: "Hora de Registro",
  _CRIMINAL_RECORD_STATUS_: "Estado de Antecedentes Penales",
  _OPERATING_COMPANY_INFORMATION_: "Información de la Empresa Operativa",
  _OPERATING_COMPANY_NAME_: "Nombre de la Empresa Operativa",
  _REJECTION_REASON_: "Razón de Rechazo",
  _PLATE_INFORMATION_: "Información de la Placa",
  _GATEWAY_: "Puerta de Enlace",
  _GATEWAY_DETAILS_: "Detalles de la Puerta de Enlace",
  _SENSOR_GRAPH_: "Gráfico de Sensores",
  _VEHICLENO_SENSORS_: "Vehículo/Número de Sensores",
  _AI_ALARM_REPORT_: "Informe de Alarmas AI",
  _CURRENT_ADDRESS_: "Dirección Actual",
  _WAREHOUSE_MANAGEMENT_: "Gestión de Almacén",
  _WAREHOUSE_MANAGEMENT_TITILE_:
    "La sección de Gestión de Almacén proporciona acceso a funciones de gestión de almacenes.",
  _INVENTORY_MANAGEMENT_: "Gestión de Inventario",
  _INVENTORY_MANAGEMENT_TITILE_:
    "La sección de Gestión de Inventario proporciona acceso a funciones de gestión de inventario.",
  _WAREHOUSE_DETAILS_: "Detalles del Almacén",
  _WAREHOUSE_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su almacén. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _INVENTORY_DETAILS_: "Detalles de Inventario",
  _INVENTORY_DETAILS_DESC_:
    "Este formulario le permite ver y/o modificar los detalles de su inventario. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _SFDA_LICENSE_NUMBER_: "Número de Licencia SFDA",
  _SFDA_REPORT_: "Lista de Informes SFDA",
  _INVENTORY_FOUR_: "Inventario 4",
  _INVENTORY_FIVE_: "Inventario 5",
  _INVENTORY_SIX_: "Inventario 6",
  _INVENTORY_SEVEN_: "Inventario 7",
  _BULK_DELETE_BY_EXCEL_: "Eliminar en bloque desde Excel",
  _DELETE_VEHICLE_TITLE_: "Eliminar Vehículo mediante Excel",
  _REPORT_LIST_: "Lista de Informes",
  _SHOP_CODE_NAME_: "Código y Nombre de Tienda",
  _ENTER_SHOP_: "Ingresar Tienda",
  _EXIT_SHOP_: "Salir de la Tienda",
  _ENTER_TEMP_: "Ingresar Temperatura",
  _EXIT_TEMP_: "Temperatura de Salida",
  _PLATE_NO_1_: "Número de Placa",
  _TIME_SPEND_: "Tiempo Pasado en la Tienda",
  _COST_AVG_: "Costo Promedio",
  _TOTAL_DLIVERIES_POINT_: "Total de Puntos de Entrega",
  _REFEER_TEMP_AVG_: "Promedio de Temperatura de Reefer",
  _DOWNLOAD_VIDEO_LIST_BUTTON_: "Lista de Videos Descargados",
  _PLAYBACK_PANEL_: "Panel de Reproducción",
  _PLAY_BACK_DATA_: "Datos de Video de Reproducción",
  _DOWNLOADED_DATA_: "Datos de Video Descargados",
  _EVIDENCE_: "Evidencia",
  _EVIDENCE_DESC_:
    "Grabaciones MDVR que documentan violaciones de comportamiento del conductor o preocupaciones de seguridad o políticas de la empresa que requieren revisión y evaluación.",
  _SELECT_CHANNEL_ERROR_:
    "Seleccione al menos un canal para la reproducción desde el eje Y.",
  _SOS_LOG_REPORT_: "Informe de Registro SOS",
  _FLEET_ADVIST_VEHICLE_DESC_:
    "Este formulario le permite asignar un vehículo a un anuncio. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _BOOKING_PROCEDURE_: "Procedimiento de Reserva",
  _QUEUE_SYSTEM_: "Sistema de Cola",
  _NEAREST_TAXI_: "Taxi Más Cercano",
  _ALARM_NAME_: "Nombre de Alarma",
  _ALARM_ID_: "ID de Alarma",
  _STUDENT_REGISTRATION_: "Registro de Estudiante",
  _STUDENT_ADD_DESC_:
    "Este formulario le permite agregar un nuevo estudiante. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _TRANSPORT_TYPE_: "Tipo de Transporte",
  _DIVISION_: "División",
  _DROP_OFF_POINT_: "Punto de Destino",
  _PICKUP_TRIP_: "Viaje de Recogida",
  _PICKUP_BUS_: "Autobús de Recogida",
  _PICKUP_ROUTE_: "Ruta de Recogida",
  _SPECIAL_PICKUP_TRIP_: "Viaje Especial de Recogida",
  _SPECIAL_PICKUP_BUS_: "Autobús Especial de Recogida",
  _DROPOFF_TRIP_: "Viaje de Entrega",
  _DROPOFF_BUS_: "Autobús de Entrega",
  _DROPOFF_ROUTE_: "Ruta de Entrega",
  _SPECIAL_DROPOFF_TRIP_: "Viaje Especial de Entrega",
  _SPECIAL_DROPOFF_BUS_: "Autobús Especial de Entrega",
  _PRIMARY_CONTACT_NO_: "Número de Contacto Primario-Móvil",

  _PRIMARY_EMAILID_: "Correo Electrónico Principal",
  _PICKUP_DETAILS_: "Detalles de Recogida",
  _DROPOFF_DETAILS_: "Detalles de Destino",
  _CONTACT_DETAILS_: "Detalles de Contacto",
  _FATHER_DETAILS_: "Detalles del Padre",
  _MOTHER_DETAILS_: "Detalles de la Madre",
  _GUARDIAN_DETAILS_: "Detalles del Tutor",
  _PICKUP_BUSNO_: "Número de Autobús de Recogida",
  _PICKUP_ROUTE_: "Ruta de Recogida",
  _PICKUP_TRIP_: "Viaje de Recogida",
  _DROPOFF_BUSNO_: "Número de Autobús de Destino",
  _STUDENT_DETAILS_: "Detalles del Estudiante",
  _PICKUP_DROP_TAB_TITLE_: "Detalles de Recogida y Destino",
  _STUDENT_ADD_DESC_:
    "Este formulario le permite agregar un nuevo estudiante. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _PICKUP_DROP_TAB_DESC_:
    "Use esta sección para definir los lugares de recogida y destino del estudiante, los horarios y detalles relacionados con la ruta. Asegúrese de que la información sea precisa para una planificación de transporte fluida.",
  _CONTACT_DETAILS_DESC_:
    "Use esta sección para ingresar la información de contacto del estudiante, incluyendo detalles del tutor y contactos de emergencia. Asegúrese de que todos los detalles de contacto sean correctos y estén actualizados.",
  _TRIP_TYPE_: "Tipo de Viaje",
  _SORT_STUDENT_BY_: "Ordenar Estudiantes Por",
  _Total_Students_: "Total de Estudiantes",
  _INCLUDE_STAFF_: "Incluir Personal",
  _Total_STAFF_: "Total de Personal",
  _TRIP_CLOSURE_BUFFER_TIME_: "Tiempo de Amortiguación de Cierre de Viaje",
  _AUTOMATIC_TRIP_CLOSURE_: "Cierre Automático de Viaje",
  _TRIP_CLOSURE_: "Cierre de Viaje",
  _TRIP_START_CLOSE_CARD_NO_: "Número de Tarjeta de Inicio/Cierre del Viaje",
  _SELECT_ROUTE_: "Seleccionar Ruta",
  _SELECT_AREA_: "Seleccionar Área",
  _STUDENT_TRIP_ADD_: "Agregar Viaje de Estudiante",
  _STUDENT_TRIP_ADD_DESC_:
    "Este formulario le permite agregar un nuevo viaje de estudiante. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _ROUTE_: "Ruta",
  _ROUTE_ADD_DESC_:
    "Este formulario le permite agregar una nueva ruta. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _AREA_NAME_: "Nombre del Área",
  _TRIP_DETAILS_: "Detalles del Viaje",
  _TRIP_ADD_DESC_:
    "Este formulario le permite agregar un nuevo viaje. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _ASSIGN_BUS_DESC_:
    "Este formulario le permite asignar un autobús a un estudiante. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _ASSIGN_STUDENT_DESC_:
    "Este formulario le permite asignar un estudiante a un autobús. Asegúrese de que toda la información sea precisa y esté actualizada.",
  _ASSIGN_BUS_: "Asignar Autobús",
  _ASSIGN_STUDENT_: "Asignar Estudiante",
  _BUS_: "Autobús",
  _SEAT_CAPACITY_: "Capacidad de Asientos",
  _SEARCH_STUDENT_: "Buscar Estudiante",
  _WHATSAPP_NO_: "Número de WhatsApp",
  _UPLOAD_PHOTO_: "Subir Foto",
  _UPLOAD_STUDENT_PHOTO_: "Subir Foto del Estudiante",
  _UPLOAD_PARENTS_PHOTO_: "Subir Foto de los Padres",
  _SCHOOL_TRIP_: "Viaje Escolar",
  _ASSIGNED_: "Asignado",
  _UNASSIGNED_: "No Asignado",
  _SHIFT_NUMBER_: "Número de Turno",
  _SHIFT_TYPE_: "Tipo de Turno",
  _SHIFT_START_TIME_: "Hora de Inicio",
  _SHIFT_OPEN_LATITUDE_: "Latitud de Inicio",
  _SHIFT_OPEN_LONGITUDE_: "Longitud de Inicio",
  _SHIFT_LOGOFF_DURATION_: "Duración de Cierre de Sesión (seg)",
  _SHIFT_OPEN_DISTANCE_: "Distancia de Inicio",
  _SHIFT_END_TIME_: "Hora de Fin",
  _SHIFT_WAITING_TIME_: "Tiempo de Espera (seg)",
  _SHIFT_TOTAL_DISTANCE_: "Distancia Total",
  _SHIFT_HIRED_DISTANCE_: "Distancia Contratada",
  _SHIFT_FOR_HIRE_DISTANCE_: "Distancia Disponible para Contratación",
  _SHIFT_ON_CALL_DISTANCE_: "Distancia de Llamada",
  _SHIFT_BLACK_TRIP_DISTANCE_: "Distancia de Viaje No Registrado",
  _SHIFT_TRIP_COUNT_: "Número de Viajes",
  _SHIFT_FARE_AMOUNT_: "Tarifa",
  _SHIFT_EXTRA_FARE_AMOUNT_: "Tarifa Extra",
  _SHIFT_STATUS_: "Estado",
  _UNIT_NO_: "Número de Unidad",
  _OPEN_UID_: "ID de Usuario de Inicio",
  _CLOSE_UID_: "ID de Usuario de Cierre",
  _OPEN_SPEED_: "Velocidad de Inicio",
  _OPEN_GPS_FIX_: "GPS de Inicio",
  _OPEN_IGNITION_: "Encendido de Inicio",
  _UNITS_QUANTITY_: "Unidades",
  _FUEL_SURCHARGE_HIRED_KM_: "Recargo de Combustible (Km Contratados)",
  _DRIVER_SURCHARGE_HIRED_KM_: "Recargo de Conductor (Km Contratados)",
  _SHIFT_WAITING_TIME_FARE_: "Tarifa por Tiempo de Espera",
  _SHIFT_CREDIT_CARD_AMOUNT_: "Monto con Tarjeta de Crédito",
  _ITC_SURCHARGE_HIRED_KM_: "Recargo ITC (Km Contratados)",
  _DISCOUNT_CARD_TOTAL_AMOUNT_: "Monto Total de Tarjeta de Descuento",
  _COLLECT_TOTAL_: "Total a Cobrar",
  _DRIVER_INCOME_: "Ingreso del Conductor",
  _CLOSE_LATITUDE_: "Latitud de Cierre",
  _CLOSE_LONGITUDE_: "Longitud de Cierre",
  _CLOSE_SPEED_: "Velocidad de Cierre",
  _CLOSE_GPS_FIX_: "GPS de Cierre",
  _CLOSE_IGNITION_: "Encendido de Cierre",
  _TIPS_AMOUNT_: "Monto de Propinas",
  _OVERSPEED_COUNT_: "Número de Excesos de Velocidad",
  _HARSH_BRAKE_COUNT_: "Número de Frenadas Bruscas",
  _HARSH_ACCEL_COUNT_: "Número de Aceleraciones Bruscas",
  _CREATED_AT_: "Creado en",
  _UPDATED_AT_: "Actualizado en",
  _CLOSE_REASON_: "Motivo de Cierre",
  _UID_: "UID",
  _EVENT_CATEGORY_: "Categoría de Evento",
  _USER_ID_: "ID de Usuario",
  _GEO_ID_: "ID de Geo",
  _EVENT_TIME_: "Hora del Evento",
  _LATITUDE_: "Latitud",
  _LONGITUDE_: "Longitud",
  _GPS_FIX_: "GPS Fix",
  _IGNITION_: "Encendido",
  _VIOLATION_TYPE_: "Tipo de Violación",
  _VIOLATION_DESCRIPTION_: "Descripción de Violación",
  _QUANTITY_: "Cantidad",
  _GEO_SPEED_LIMIT_: "Límite de Velocidad Geográfico",
  _CURRENT_SPEED_: "Velocidad Actual",
  _UPLOAD_PARENT_PHOTO_1_: "Subir Foto del Padre 1",
  _UPLOAD_PARENT_PHOTO_2_: "Subir Foto del Padre 2",
  _STUDENT_LIST_: "Lista de Estudiantes",
  _STUDENT_TRIP_LIST_: "Lista de Viajes de Estudiantes",
  _STUDENT_ROUTE_LIST_: "Lista de Rutas de Estudiantes",
  _SHIFT_LOG_REPORT_: "Informe de Registro de Turno",
  _TAXI_VIOLATION_REPORT_: "Informe de Violaciones de Taxi",
  _SEARCH_BY_STUDENT_NAME_OR_STUDENT_TAGID_:
    "Buscar por Nombre del Estudiante o ID de Etiqueta del Estudiante",
  _RELEASE_: "Liberar",
  _RELEASED_: "Liberado",
  _NICE_TO_SEE_YOU_AGAIN_: "Encantado de verte de nuevo",
  _WELCOME_BACK_: "Bienvenido de nuevo",
};
